import { _jsxS, _jsxQ } from "@builder.io/qwik";
const LuAccessibility = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "16",
      cy: "4",
      r: "1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m18 19 1-7-6 1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m5 8 3-3 5.5 3-2.36 3.5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4.24 14.5a5 5 0 0 0 6.88 6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M13.76 17.5a5 5 0 0 0-6.88-6"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Kf_0");
const LuActivitySquare = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "18",
      rx: "2",
      width: "18",
      x: "3",
      y: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17 12h-2l-2 5-2-10-2 5H7"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "yN_0");
const LuActivity = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: /* @__PURE__ */ _jsxQ("path", null, {
    d: "M22 12h-4l-3 9L9 3l-3 9H2"
  }, null, 3, null)
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "xV_0");
const LuAirVent = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6 12H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6 8h12"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18.3 17.7a2.5 2.5 0 0 1-3.16 3.83 2.53 2.53 0 0 1-1.14-2V12"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6.6 15.6A2 2 0 1 0 10 17v-5"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "IQ_0");
const LuAirplay = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M5 17H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polygon", null, {
      points: "12 15 17 21 7 21 12 15"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "XQ_0");
const LuAlarmCheck = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "13",
      r: "8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M5 3 2 6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m22 6-3-3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6.38 18.7 4 21"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17.64 18.67 20 21"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m9 13 2 2 4-4"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "UJ_0");
const LuAlarmClockOff = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6.87 6.87a8 8 0 1 0 11.26 11.26"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M19.9 14.25a8 8 0 0 0-9.15-9.15"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m22 6-3-3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6.26 18.67 4 21"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m2 2 20 20"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 4 2 6"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Cn_0");
const LuAlarmClock = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "13",
      r: "8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 9v4l2 2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M5 3 2 6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m22 6-3-3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6.38 18.7 4 21"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17.64 18.67 20 21"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "pJ_0");
const LuAlarmMinus = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "13",
      r: "8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M5 3 2 6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m22 6-3-3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6.38 18.7 4 21"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17.64 18.67 20 21"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 13h6"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "bk_0");
const LuAlarmPlus = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "13",
      r: "8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M5 3 2 6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m22 6-3-3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6.38 18.7 4 21"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17.64 18.67 20 21"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 10v6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 13h6"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "P3_0");
const LuAlbum = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "18",
      rx: "2",
      ry: "2",
      width: "18",
      x: "3",
      y: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "11 3 11 11 14 8 17 11 17 3"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "tm_0");
const LuAlertCircle = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "12",
      x2: "12",
      y1: "8",
      y2: "12"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "12",
      x2: "12.01",
      y1: "16",
      y2: "16"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Ui_0");
const LuAlertOctagon = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("polygon", null, {
      points: "7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "12",
      x2: "12",
      y1: "8",
      y2: "12"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "12",
      x2: "12.01",
      y1: "16",
      y2: "16"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "cc_0");
const LuAlertTriangle = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 9v4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 17h.01"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "zY_0");
const LuAlignCenterHorizontal = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 12h20"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10 16v4a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10 8V4a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M20 16v1a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2v-1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14 8V7c0-1.1.9-2 2-2h2a2 2 0 0 1 2 2v1"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Xn_0");
const LuAlignCenterVertical = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 2v20"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 10H4a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 10h4a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 20H7a2 2 0 0 1-2-2v-2c0-1.1.9-2 2-2h1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 14h1a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-1"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "3p_0");
const LuAlignCenter = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "21",
      x2: "3",
      y1: "6",
      y2: "6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "17",
      x2: "7",
      y1: "12",
      y2: "12"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "19",
      x2: "5",
      y1: "18",
      y2: "18"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "OY_0");
const LuAlignEndHorizontal = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "16",
      rx: "2",
      width: "6",
      x: "4",
      y: "2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "9",
      rx: "2",
      width: "6",
      x: "14",
      y: "9"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M22 22H2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "8x_0");
const LuAlignEndVertical = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "6",
      rx: "2",
      width: "16",
      x: "2",
      y: "4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "6",
      rx: "2",
      width: "9",
      x: "9",
      y: "14"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M22 22V2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Au_0");
const LuAlignHorizontalDistributeCenter = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "14",
      rx: "2",
      width: "6",
      x: "4",
      y: "5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "10",
      rx: "2",
      width: "6",
      x: "14",
      y: "7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17 22v-5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17 7V2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 22v-3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 5V2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "gj_0");
const LuAlignHorizontalDistributeEnd = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "14",
      rx: "2",
      width: "6",
      x: "4",
      y: "5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "10",
      rx: "2",
      width: "6",
      x: "14",
      y: "7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10 2v20"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M20 2v20"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "6H_0");
const LuAlignHorizontalDistributeStart = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "14",
      rx: "2",
      width: "6",
      x: "4",
      y: "5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "10",
      rx: "2",
      width: "6",
      x: "14",
      y: "7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 2v20"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14 2v20"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "7M_0");
const LuAlignHorizontalJustifyCenter = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "14",
      rx: "2",
      width: "6",
      x: "2",
      y: "5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "10",
      rx: "2",
      width: "6",
      x: "16",
      y: "7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 2v20"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "az_0");
const LuAlignHorizontalJustifyEnd = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "14",
      rx: "2",
      width: "6",
      x: "2",
      y: "5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "10",
      rx: "2",
      width: "6",
      x: "12",
      y: "7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M22 2v20"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "0Y_0");
const LuAlignHorizontalJustifyStart = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "14",
      rx: "2",
      width: "6",
      x: "6",
      y: "5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "10",
      rx: "2",
      width: "6",
      x: "16",
      y: "7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 2v20"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "y2_0");
const LuAlignHorizontalSpaceAround = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "10",
      rx: "2",
      width: "6",
      x: "9",
      y: "7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 22V2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M20 22V2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Pw_0");
const LuAlignHorizontalSpaceBetween = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "14",
      rx: "2",
      width: "6",
      x: "3",
      y: "5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "10",
      rx: "2",
      width: "6",
      x: "15",
      y: "7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 2v20"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 2v20"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Uk_0");
const LuAlignJustify = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "3",
      x2: "21",
      y1: "6",
      y2: "6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "3",
      x2: "21",
      y1: "12",
      y2: "12"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "3",
      x2: "21",
      y1: "18",
      y2: "18"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "fi_0");
const LuAlignLeft = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "21",
      x2: "3",
      y1: "6",
      y2: "6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "15",
      x2: "3",
      y1: "12",
      y2: "12"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "17",
      x2: "3",
      y1: "18",
      y2: "18"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "WX_0");
const LuAlignRight = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "21",
      x2: "3",
      y1: "6",
      y2: "6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "21",
      x2: "9",
      y1: "12",
      y2: "12"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "21",
      x2: "7",
      y1: "18",
      y2: "18"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Jl_0");
const LuAlignStartHorizontal = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "16",
      rx: "2",
      width: "6",
      x: "4",
      y: "6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "9",
      rx: "2",
      width: "6",
      x: "14",
      y: "6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M22 2H2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "eu_0");
const LuAlignStartVertical = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "6",
      rx: "2",
      width: "9",
      x: "6",
      y: "14"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "6",
      rx: "2",
      width: "16",
      x: "6",
      y: "4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 2v20"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "vI_0");
const LuAlignVerticalDistributeCenter = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "6",
      rx: "2",
      width: "14",
      x: "5",
      y: "14"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "6",
      rx: "2",
      width: "10",
      x: "7",
      y: "4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M22 7h-5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 7H1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M22 17h-3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M5 17H2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "0k_0");
const LuAlignVerticalDistributeEnd = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "6",
      rx: "2",
      width: "14",
      x: "5",
      y: "14"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "6",
      rx: "2",
      width: "10",
      x: "7",
      y: "4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 20h20"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 10h20"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "6U_0");
const LuAlignVerticalDistributeStart = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "6",
      rx: "2",
      width: "14",
      x: "5",
      y: "14"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "6",
      rx: "2",
      width: "10",
      x: "7",
      y: "4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 14h20"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 4h20"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "JZ_0");
const LuAlignVerticalJustifyCenter = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "6",
      rx: "2",
      width: "14",
      x: "5",
      y: "16"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "6",
      rx: "2",
      width: "10",
      x: "7",
      y: "2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 12h20"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "r9_0");
const LuAlignVerticalJustifyEnd = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "6",
      rx: "2",
      width: "14",
      x: "5",
      y: "12"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "6",
      rx: "2",
      width: "10",
      x: "7",
      y: "2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 22h20"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "1L_0");
const LuAlignVerticalJustifyStart = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "6",
      rx: "2",
      width: "14",
      x: "5",
      y: "16"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "6",
      rx: "2",
      width: "10",
      x: "7",
      y: "6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 2h20"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "wT_0");
const LuAlignVerticalSpaceAround = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "6",
      rx: "2",
      width: "10",
      x: "7",
      y: "9"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M22 20H2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M22 4H2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Wy_0");
const LuAlignVerticalSpaceBetween = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "6",
      rx: "2",
      width: "14",
      x: "5",
      y: "15"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "6",
      rx: "2",
      width: "10",
      x: "7",
      y: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 21h20"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 3h20"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "sX_0");
const LuAmpersand = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17.5 12c0 4.4-3.6 8-8 8A4.5 4.5 0 0 1 5 15.5c0-6 8-4 8-8.5a3 3 0 1 0-6 0c0 3 2.5 8.5 12 13"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 12h3"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "CQ_0");
const LuAmpersands = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10 17c-5-3-7-7-7-9a2 2 0 0 1 4 0c0 2.5-5 2.5-5 6 0 1.7 1.3 3 3 3 2.8 0 5-2.2 5-5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M22 17c-5-3-7-7-7-9a2 2 0 0 1 4 0c0 2.5-5 2.5-5 6 0 1.7 1.3 3 3 3 2.8 0 5-2.2 5-5"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "2H_0");
const LuAnchor = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "5",
      r: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "12",
      x2: "12",
      y1: "22",
      y2: "8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M5 12H2a10 10 0 0 0 20 0h-3"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "B3_0");
const LuAngry = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 16s-1.5-2-4-2-4 2-4 2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7.5 8 10 9"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m14 9 2.5-1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 10h0"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M15 10h0"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "vk_0");
const LuAnnoyed = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 15h8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 9h2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14 9h2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "0c_0");
const LuAntenna = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 12 7 2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m7 12 5-10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m12 12 5-10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m17 12 5-10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4.5 7h15"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 16v6"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "3R_0");
const LuAperture = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "14.31",
      x2: "20.05",
      y1: "8",
      y2: "17.94"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "9.69",
      x2: "21.17",
      y1: "8",
      y2: "8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "7.38",
      x2: "13.12",
      y1: "12",
      y2: "2.06"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "9.69",
      x2: "3.95",
      y1: "16",
      y2: "6.06"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "14.31",
      x2: "2.83",
      y1: "16",
      y2: "16"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "16.62",
      x2: "10.88",
      y1: "12",
      y2: "21.94"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "wz_0");
const LuAppWindow = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "16",
      rx: "2",
      width: "20",
      x: "2",
      y: "4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10 4v4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 8h20"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6 4v4"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "0H_0");
const LuApple = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 20.94c1.5 0 2.75 1.06 4 1.06 3 0 6-8 6-12.22A4.91 4.91 0 0 0 17 5c-2.22 0-4 1.44-5 2-1-.56-2.78-2-5-2a4.9 4.9 0 0 0-5 4.78C2 14 5 22 8 22c1.25 0 2.5-1.06 4-1.06Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10 2c1 .5 2 2 2 5"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "jr_0");
const LuArchiveRestore = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "5",
      rx: "1",
      width: "20",
      x: "2",
      y: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 8v11a2 2 0 0 0 2 2h2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M20 8v11a2 2 0 0 1-2 2h-2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m9 15 3-3 3 3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 12v9"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "at_0");
const LuArchiveX = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "5",
      rx: "1",
      width: "20",
      x: "2",
      y: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 8v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m9.5 17 5-5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m9.5 12 5 5"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "0Z_0");
const LuArchive = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "5",
      rx: "1",
      width: "20",
      x: "2",
      y: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 8v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10 12h4"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Sg_0");
const LuAreaChart = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 3v18h18"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 12v5h12V8l-5 5-4-4Z"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Jj_0");
const LuArmchair = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M19 9V6a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 11v5a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-5a2 2 0 0 0-4 0v2H7v-2a2 2 0 0 0-4 0Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M5 18v2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M19 18v2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "8I_0");
const LuArrowBigDownDash = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M15 5H9"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M15 9v3h4l-7 7-7-7h4V9h6z"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Aj_0");
const LuArrowBigDown = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: /* @__PURE__ */ _jsxQ("path", null, {
    d: "M15 6v6h4l-7 7-7-7h4V6h6z"
  }, null, 3, null)
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "QG_0");
const LuArrowBigLeftDash = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M19 15V9"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M15 15h-3v4l-7-7 7-7v4h3v6z"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "um_0");
const LuArrowBigLeft = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: /* @__PURE__ */ _jsxQ("path", null, {
    d: "M18 15h-6v4l-7-7 7-7v4h6v6z"
  }, null, 3, null)
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "B9_0");
const LuArrowBigRightDash = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M5 9v6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 9h3V5l7 7-7 7v-4H9V9z"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "aq_0");
const LuArrowBigRight = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: /* @__PURE__ */ _jsxQ("path", null, {
    d: "M6 9h6V5l7 7-7 7v-4H6V9z"
  }, null, 3, null)
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "c0_0");
const LuArrowBigUpDash = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 19h6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 15v-3H5l7-7 7 7h-4v3H9z"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "t0_0");
const LuArrowBigUp = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: /* @__PURE__ */ _jsxQ("path", null, {
    d: "M9 18v-6H5l7-7 7 7h-4v6H9z"
  }, null, 3, null)
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "GH_0");
const LuArrowDown01 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m3 16 4 4 4-4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 20V4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "6",
      ry: "2",
      width: "4",
      x: "15",
      y: "4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17 20v-6h-2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M15 20h4"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "sb_0");
const LuArrowDown10 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m3 16 4 4 4-4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 20V4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17 10V4h-2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M15 10h4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "6",
      ry: "2",
      width: "4",
      x: "15",
      y: "14"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "53_0");
const LuArrowDownAZ = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m3 16 4 4 4-4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 20V4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M20 8h-5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M15 10V6.5a2.5 2.5 0 0 1 5 0V10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M15 14h5l-5 6h5"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "CB_0");
const LuArrowDownCircle = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 8v8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m8 12 4 4 4-4"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "n5_0");
const LuArrowDownFromLine = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M19 3H5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 21V7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m6 15 6 6 6-6"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "bN_0");
const LuArrowDownLeftFromCircle = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 12a10 10 0 1 1 10 10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m2 22 10-10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 22H2v-6"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "ah_0");
const LuArrowDownLeftSquare = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "18",
      rx: "2",
      width: "18",
      x: "3",
      y: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m16 8-8 8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 16H8V8"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "79_0");
const LuArrowDownLeft = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17 7 7 17"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17 17H7V7"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "8Q_0");
const LuArrowDownNarrowWide = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m3 16 4 4 4-4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 20V4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M11 4h4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M11 8h7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M11 12h10"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "1r_0");
const LuArrowDownRightFromCircle = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 22a10 10 0 1 1 10-10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M22 22 12 12"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M22 16v6h-6"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "VW_0");
const LuArrowDownRightSquare = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "18",
      rx: "2",
      width: "18",
      x: "3",
      y: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m8 8 8 8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 8v8H8"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "13_0");
const LuArrowDownRight = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m7 7 10 10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17 7v10H7"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "sX_0");
const LuArrowDownSquare = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "18",
      rx: "2",
      width: "18",
      x: "3",
      y: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 8v8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m8 12 4 4 4-4"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Wx_0");
const LuArrowDownToDot = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 2v14"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m19 9-7 7-7-7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "21",
      r: "1"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "yB_0");
const LuArrowDownToLine = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 17V3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m6 11 6 6 6-6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M19 21H5"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "t6_0");
const LuArrowDownUp = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m3 16 4 4 4-4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 20V4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m21 8-4-4-4 4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17 4v16"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "bV_0");
const LuArrowDownWideNarrow = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m3 16 4 4 4-4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 20V4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M11 4h10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M11 8h7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M11 12h4"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "oo_0");
const LuArrowDownZA = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m3 16 4 4 4-4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 4v16"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M15 4h5l-5 6h5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M15 20v-3.5a2.5 2.5 0 0 1 5 0V20"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M20 18h-5"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "i7_0");
const LuArrowDown = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 5v14"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m19 12-7 7-7-7"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "8R_0");
const LuArrowLeftCircle = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 12H8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m12 8-4 4 4 4"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Pv_0");
const LuArrowLeftFromLine = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m9 6-6 6 6 6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 12h14"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 19V5"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Yc_0");
const LuArrowLeftRight = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 3 4 7l4 4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 7h16"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m16 21 4-4-4-4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M20 17H4"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Pv_0");
const LuArrowLeftSquare = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "18",
      rx: "2",
      width: "18",
      x: "3",
      y: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m12 8-4 4 4 4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 12H8"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "8a_0");
const LuArrowLeftToLine = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 19V5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m13 6-6 6 6 6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 12h14"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "gc_0");
const LuArrowLeft = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m12 19-7-7 7-7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M19 12H5"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "VY_0");
const LuArrowRightCircle = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 12h8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m12 16 4-4-4-4"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "zs_0");
const LuArrowRightFromLine = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 5v14"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 12H7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m15 18 6-6-6-6"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "pY_0");
const LuArrowRightLeft = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m16 3 4 4-4 4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M20 7H4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m8 21-4-4 4-4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 17h16"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "1U_0");
const LuArrowRightSquare = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "18",
      rx: "2",
      width: "18",
      x: "3",
      y: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 12h8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m12 16 4-4-4-4"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "RQ_0");
const LuArrowRightToLine = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17 12H3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m11 18 6-6-6-6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 5v14"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "uy_0");
const LuArrowRight = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M5 12h14"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m12 5 7 7-7 7"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Ye_0");
const LuArrowUp01 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m3 8 4-4 4 4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 4v16"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "6",
      ry: "2",
      width: "4",
      x: "15",
      y: "4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17 20v-6h-2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M15 20h4"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "aB_0");
const LuArrowUp10 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m3 8 4-4 4 4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 4v16"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17 10V4h-2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M15 10h4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "6",
      ry: "2",
      width: "4",
      x: "15",
      y: "14"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Hc_0");
const LuArrowUpAZ = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m3 8 4-4 4 4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 4v16"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M20 8h-5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M15 10V6.5a2.5 2.5 0 0 1 5 0V10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M15 14h5l-5 6h5"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "5f_0");
const LuArrowUpCircle = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m16 12-4-4-4 4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 16V8"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Oy_0");
const LuArrowUpDown = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m21 16-4 4-4-4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17 20V4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m3 8 4-4 4 4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 4v16"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "rZ_0");
const LuArrowUpFromDot = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m5 9 7-7 7 7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 16V2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "21",
      r: "1"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "uY_0");
const LuArrowUpFromLine = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m18 9-6-6-6 6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 3v14"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M5 21h14"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "JE_0");
const LuArrowUpLeftFromCircle = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 8V2h6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m2 2 10 10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 2A10 10 0 1 1 2 12"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "es_0");
const LuArrowUpLeftSquare = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "18",
      rx: "2",
      width: "18",
      x: "3",
      y: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 16V8h8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 16 8 8"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "4n_0");
const LuArrowUpLeft = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 17V7h10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17 17 7 7"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "U0_0");
const LuArrowUpNarrowWide = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m3 8 4-4 4 4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 4v16"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M11 12h4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M11 16h7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M11 20h10"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "3O_0");
const LuArrowUpRightFromCircle = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M22 12A10 10 0 1 1 12 2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M22 2 12 12"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 2h6v6"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "8l_0");
const LuArrowUpRightSquare = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "18",
      rx: "2",
      width: "18",
      x: "3",
      y: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 8h8v8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m8 16 8-8"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "MX_0");
const LuArrowUpRight = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 7h10v10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 17 17 7"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "kF_0");
const LuArrowUpSquare = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "18",
      rx: "2",
      width: "18",
      x: "3",
      y: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m16 12-4-4-4 4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 16V8"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "G0_0");
const LuArrowUpToLine = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M5 3h14"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m18 13-6-6-6 6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 7v14"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "WT_0");
const LuArrowUpWideNarrow = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m3 8 4-4 4 4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 4v16"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M11 12h10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M11 16h7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M11 20h4"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "32_0");
const LuArrowUpZA = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m3 8 4-4 4 4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 4v16"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M15 4h5l-5 6h5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M15 20v-3.5a2.5 2.5 0 0 1 5 0V20"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M20 18h-5"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "rp_0");
const LuArrowUp = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m5 12 7-7 7 7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 19V5"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "gz_0");
const LuArrowsUpFromLine = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m4 6 3-3 3 3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 17V3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m14 6 3-3 3 3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17 17V3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 21h16"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "R9_0");
const LuAsterisk = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 6v12"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17.196 9 6.804 15"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m6.804 9 10.392 6"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "4n_0");
const LuAtSign = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 8v5a3 3 0 0 0 6 0v-1a10 10 0 1 0-4 8"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "1C_0");
const LuAtom = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M20.2 20.2c2.04-2.03.02-7.36-4.5-11.9-4.54-4.52-9.87-6.54-11.9-4.5-2.04 2.03-.02 7.36 4.5 11.9 4.54 4.52 9.87 6.54 11.9 4.5Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M15.7 15.7c4.52-4.54 6.54-9.87 4.5-11.9-2.03-2.04-7.36-.02-11.9 4.5-4.52 4.54-6.54 9.87-4.5 11.9 2.03 2.04 7.36.02 11.9-4.5Z"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "2n_0");
const LuAward = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "8",
      r: "6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M15.477 12.89 17 22l-5-3-5 3 1.523-9.11"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "36_0");
const LuAxe = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m14 12-8.5 8.5a2.12 2.12 0 1 1-3-3L11 9"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M15 13 9 7l4-4 6 6h3a8 8 0 0 1-7 7z"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Qn_0");
const LuAxis3D = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 4v16h16"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m4 20 7-7"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "00_0");
const LuBaby = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 12h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M15 12h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10 16c.5.3 1.2.5 2 .5s1.5-.2 2-.5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M19 6.3a9 9 0 0 1 1.8 3.9 2 2 0 0 1 0 3.6 9 9 0 0 1-17.6 0 2 2 0 0 1 0-3.6A9 9 0 0 1 12 3c2 0 3.5 1.1 3.5 2.5s-.9 2.5-2 2.5c-.8 0-1.5-.4-1.5-1"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "wz_0");
const LuBackpack = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 10a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4v10a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 6V4a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 21v-5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 10h8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 18h8"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "96_0");
const LuBadgeAlert = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "12",
      x2: "12",
      y1: "8",
      y2: "12"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "12",
      x2: "12.01",
      y1: "16",
      y2: "16"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "xl_0");
const LuBadgeCent = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 7v10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M15.4 10a4 4 0 1 0 0 4"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "I8_0");
const LuBadgeCheck = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m9 12 2 2 4-4"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "s5_0");
const LuBadgeDollarSign = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 18V6"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Su_0");
const LuBadgeEuro = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 12h5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M15 9.4a4 4 0 1 0 0 5.2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "1d_0");
const LuBadgeHelp = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "12",
      x2: "12.01",
      y1: "17",
      y2: "17"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Mn_0");
const LuBadgeIndianRupee = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 8h8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 12h8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m13 17-5-1h1a4 4 0 0 0 0-8"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "qw_0");
const LuBadgeInfo = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "12",
      x2: "12",
      y1: "16",
      y2: "12"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "12",
      x2: "12.01",
      y1: "8",
      y2: "8"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "qi_0");
const LuBadgeJapaneseYen = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m9 8 3 3v7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m12 11 3-3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 12h6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 16h6"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "En_0");
const LuBadgeMinus = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "8",
      x2: "16",
      y1: "12",
      y2: "12"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "qL_0");
const LuBadgePercent = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m15 9-6 6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 9h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M15 15h.01"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "iM_0");
const LuBadgePlus = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "12",
      x2: "12",
      y1: "8",
      y2: "16"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "8",
      x2: "16",
      y1: "12",
      y2: "12"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "yE_0");
const LuBadgePoundSterling = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 12h4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10 16V9.5a2.5 2.5 0 0 1 5 0"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 16h7"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "QD_0");
const LuBadgeRussianRuble = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 16h5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 12h5a2 2 0 1 0 0-4h-3v9"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "ow_0");
const LuBadgeSwissFranc = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M11 17V8h4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M11 12h3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 16h4"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Sg_0");
const LuBadgeX = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "15",
      x2: "9",
      y1: "9",
      y2: "15"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "9",
      x2: "15",
      y1: "9",
      y2: "15"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "WC_0");
const LuBadge = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: /* @__PURE__ */ _jsxQ("path", null, {
    d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z"
  }, null, 3, null)
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "0x_0");
const LuBaggageClaim = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M22 18H6a2 2 0 0 1-2-2V7a2 2 0 0 0-2-2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17 14V4a2 2 0 0 0-2-2h-1a2 2 0 0 0-2 2v10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "8",
      rx: "1",
      width: "13",
      x: "8",
      y: "6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "18",
      cy: "20",
      r: "2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "9",
      cy: "20",
      r: "2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Sz_0");
const LuBan = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m4.9 4.9 14.2 14.2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "0K_0");
const LuBanana = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 13c3.5-2 8-2 10 2a5.5 5.5 0 0 1 8 5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M5.15 17.89c5.52-1.52 8.65-6.89 7-12C11.55 4 11.5 2 13 2c3.22 0 5 5.5 5 8 0 6.5-4.2 12-10.49 12C5.11 22 2 22 2 20c0-1.5 1.14-1.55 3.15-2.11Z"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Z0_0");
const LuBanknote = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "12",
      rx: "2",
      width: "20",
      x: "2",
      y: "6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6 12h.01M18 12h.01"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "bo_0");
const LuBarChart2 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "18",
      x2: "18",
      y1: "20",
      y2: "10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "12",
      x2: "12",
      y1: "20",
      y2: "4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "6",
      x2: "6",
      y1: "20",
      y2: "14"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Aw_0");
const LuBarChart3 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 3v18h18"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18 17V9"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M13 17V5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 17v-3"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "1J_0");
const LuBarChart4 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 3v18h18"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M13 17V9"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18 17V5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 17v-3"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "am_0");
const LuBarChartBig = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 3v18h18"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "7",
      rx: "1",
      width: "4",
      x: "7",
      y: "10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "12",
      rx: "1",
      width: "4",
      x: "15",
      y: "5"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "wW_0");
const LuBarChartHorizontalBig = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 3v18h18"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "4",
      rx: "1",
      width: "12",
      x: "7",
      y: "5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "4",
      rx: "1",
      width: "7",
      x: "7",
      y: "13"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Fc_0");
const LuBarChartHorizontal = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 3v18h18"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 16h8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 11h12"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 6h3"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "xJ_0");
const LuBarChart = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "12",
      x2: "12",
      y1: "20",
      y2: "10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "18",
      x2: "18",
      y1: "20",
      y2: "4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "6",
      x2: "6",
      y1: "20",
      y2: "16"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "DB_0");
const LuBarcode = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 5v14"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 5v14"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 5v14"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17 5v14"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 5v14"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "qp_0");
const LuBaseline = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 20h16"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m6 16 6-12 6 12"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 12h8"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "nC_0");
const LuBath = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 6 6.5 3.5a1.5 1.5 0 0 0-1-.5C4.683 3 4 3.683 4 4.5V17a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "10",
      x2: "8",
      y1: "5",
      y2: "7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "2",
      x2: "22",
      y1: "12",
      y2: "12"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "7",
      x2: "7",
      y1: "19",
      y2: "21"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "17",
      x2: "17",
      y1: "19",
      y2: "21"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "3q_0");
const LuBatteryCharging = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M15 7h1a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6 7H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m11 7-3 5h4l-3 5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "22",
      x2: "22",
      y1: "11",
      y2: "13"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "yH_0");
const LuBatteryFull = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "10",
      rx: "2",
      ry: "2",
      width: "16",
      x: "2",
      y: "7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "22",
      x2: "22",
      y1: "11",
      y2: "13"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "6",
      x2: "6",
      y1: "11",
      y2: "13"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "10",
      x2: "10",
      y1: "11",
      y2: "13"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "14",
      x2: "14",
      y1: "11",
      y2: "13"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "wv_0");
const LuBatteryLow = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "10",
      rx: "2",
      ry: "2",
      width: "16",
      x: "2",
      y: "7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "22",
      x2: "22",
      y1: "11",
      y2: "13"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "6",
      x2: "6",
      y1: "11",
      y2: "13"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "5V_0");
const LuBatteryMedium = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "10",
      rx: "2",
      ry: "2",
      width: "16",
      x: "2",
      y: "7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "22",
      x2: "22",
      y1: "11",
      y2: "13"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "6",
      x2: "6",
      y1: "11",
      y2: "13"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "10",
      x2: "10",
      y1: "11",
      y2: "13"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Ld_0");
const LuBatteryWarning = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14 7h2a2 2 0 0 1 2 2v6c0 1-1 2-2 2h-2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6 7H4a2 2 0 0 0-2 2v6c0 1 1 2 2 2h2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "22",
      x2: "22",
      y1: "11",
      y2: "13"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "10",
      x2: "10",
      y1: "7",
      y2: "13"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "10",
      x2: "10",
      y1: "17",
      y2: "17.01"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "1n_0");
const LuBattery = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "10",
      rx: "2",
      ry: "2",
      width: "16",
      x: "2",
      y: "7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "22",
      x2: "22",
      y1: "11",
      y2: "13"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "4j_0");
const LuBeaker = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4.5 3h15"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6 3v16a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6 14h12"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "yK_0");
const LuBeanOff = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 9c-.64.64-1.521.954-2.402 1.165A6 6 0 0 0 8 22a13.96 13.96 0 0 0 9.9-4.1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10.75 5.093A6 6 0 0 1 22 8c0 2.411-.61 4.68-1.683 6.66"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M5.341 10.62a4 4 0 0 0 6.487 1.208M10.62 5.341a4.015 4.015 0 0 1 2.039 2.04"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "2",
      x2: "22",
      y1: "2",
      y2: "22"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "rb_0");
const LuBean = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10.165 6.598C9.954 7.478 9.64 8.36 9 9c-.64.64-1.521.954-2.402 1.165A6 6 0 0 0 8 22c7.732 0 14-6.268 14-14a6 6 0 0 0-11.835-1.402Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M5.341 10.62a4 4 0 1 0 5.279-5.28"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "a0_0");
const LuBedDouble = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 20v-8a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 10V6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 4v6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 18h20"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "3t_0");
const LuBedSingle = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 20v-8a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M5 10V6a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 18h18"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "rE_0");
const LuBed = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 4v16"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 8h18a2 2 0 0 1 2 2v10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 17h20"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6 8v9"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "cN_0");
const LuBeef = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12.5",
      cy: "8.5",
      r: "2.5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12.5 2a6.5 6.5 0 0 0-6.22 4.6c-1.1 3.13-.78 3.9-3.18 6.08A3 3 0 0 0 5 18c4 0 8.4-1.8 11.4-4.3A6.5 6.5 0 0 0 12.5 2Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m18.5 6 2.19 4.5a6.48 6.48 0 0 1 .31 2 6.49 6.49 0 0 1-2.6 5.2C15.4 20.2 11 22 7 22a3 3 0 0 1-2.68-1.66L2.4 16.5"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Nw_0");
const LuBeer = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17 11h1a3 3 0 0 1 0 6h-1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 12v6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M13 12v6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14 7.5c-1 0-1.44.5-3 .5s-2-.5-3-.5-1.72.5-2.5.5a2.5 2.5 0 0 1 0-5c.78 0 1.57.5 2.5.5S9.44 2 11 2s2 1.5 3 1.5 1.72-.5 2.5-.5a2.5 2.5 0 0 1 0 5c-.78 0-1.5-.5-2.5-.5Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M5 8v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V8"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "hJ_0");
const LuBellDot = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M19.4 14.9C20.2 16.4 21 17 21 17H3s3-2 3-9c0-3.3 2.7-6 6-6 .7 0 1.3.1 1.9.3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10.3 21a1.94 1.94 0 0 0 3.4 0"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "18",
      cy: "8",
      r: "3"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "C5_0");
const LuBellMinus = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18.4 12c.8 3.8 2.6 5 2.6 5H3s3-2 3-9c0-3.3 2.7-6 6-6 1.8 0 3.4.8 4.5 2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10.3 21a1.94 1.94 0 0 0 3.4 0"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M15 8h6"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "nr_0");
const LuBellOff = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8.7 3A6 6 0 0 1 18 8a21.3 21.3 0 0 0 .6 5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17 17H3s3-2 3-9a4.67 4.67 0 0 1 .3-1.7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10.3 21a1.94 1.94 0 0 0 3.4 0"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m2 2 20 20"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "7r_0");
const LuBellPlus = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M19.3 14.8C20.1 16.4 21 17 21 17H3s3-2 3-9c0-3.3 2.7-6 6-6 1 0 1.9.2 2.8.7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10.3 21a1.94 1.94 0 0 0 3.4 0"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M15 8h6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18 5v6"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Qn_0");
const LuBellRing = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10.3 21a1.94 1.94 0 0 0 3.4 0"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 2C2.8 3.7 2 5.7 2 8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M22 8c0-2.3-.8-4.3-2-6"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "P5_0");
const LuBell = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10.3 21a1.94 1.94 0 0 0 3.4 0"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "OH_0");
const LuBike = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "18.5",
      cy: "17.5",
      r: "3.5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "5.5",
      cy: "17.5",
      r: "3.5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "15",
      cy: "5",
      r: "1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 17.5V14l-3-3 4-3 2 3h2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "jP_0");
const LuBinary = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "6",
      rx: "2",
      width: "4",
      x: "14",
      y: "14"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "6",
      rx: "2",
      width: "4",
      x: "6",
      y: "4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6 20h4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14 10h4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6 14h2v6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14 4h2v6"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "9H_0");
const LuBiohazard = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "11.9",
      r: "2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6.7 3.4c-.9 2.5 0 5.2 2.2 6.7C6.5 9 3.7 9.6 2 11.6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m8.9 10.1 1.4.8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17.3 3.4c.9 2.5 0 5.2-2.2 6.7 2.4-1.2 5.2-.6 6.9 1.5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m15.1 10.1-1.4.8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16.7 20.8c-2.6-.4-4.6-2.6-4.7-5.3-.2 2.6-2.1 4.8-4.7 5.2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 13.9v1.6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M13.5 5.4c-1-.2-2-.2-3 0"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17 16.4c.7-.7 1.2-1.6 1.5-2.5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M5.5 13.9c.3.9.8 1.8 1.5 2.5"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "TF_0");
const LuBird = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 7h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3.4 18H12a8 8 0 0 0 8-8V7a4 4 0 0 0-7.28-2.3L2 20"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m20 7 2 .5-2 .5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10 18v3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14 17.75V21"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 18a6 6 0 0 0 3.84-10.61"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "me_0");
const LuBitcoin = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: /* @__PURE__ */ _jsxQ("path", null, {
    d: "M11.767 19.089c4.924.868 6.14-6.025 1.216-6.894m-1.216 6.894L5.86 18.047m5.908 1.042-.347 1.97m1.563-8.864c4.924.869 6.14-6.025 1.215-6.893m-1.215 6.893-3.94-.694m5.155-6.2L8.29 4.26m5.908 1.042.348-1.97M7.48 20.364l3.126-17.727"
  }, null, 3, null)
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "jj_0");
const LuBlinds = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 3h18"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M20 7H8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M20 11H8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10 19h10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 15h12"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 3v14"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "4",
      cy: "19",
      r: "2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "e0_0");
const LuBlocks = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "7",
      rx: "1",
      width: "7",
      x: "14",
      y: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10 21V8a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1H3"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "ra_0");
const LuBluetoothConnected = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m7 7 10 10-5 5V2l5 5L7 17"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "18",
      x2: "21",
      y1: "12",
      y2: "12"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "3",
      x2: "6",
      y1: "12",
      y2: "12"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Jp_0");
const LuBluetoothOff = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m17 17-5 5V12l-5 5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m2 2 20 20"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14.5 9.5 17 7l-5-5v4.5"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "wc_0");
const LuBluetoothSearching = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m7 7 10 10-5 5V2l5 5L7 17"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M20.83 14.83a4 4 0 0 0 0-5.66"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18 12h.01"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "ka_0");
const LuBluetooth = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: /* @__PURE__ */ _jsxQ("path", null, {
    d: "m7 7 10 10-5 5V2l5 5L7 17"
  }, null, 3, null)
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Y0_0");
const LuBold = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14 12a4 4 0 0 0 0-8H6v8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M15 20a4 4 0 0 0 0-8H6v8Z"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "S7_0");
const LuBomb = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "11",
      cy: "13",
      r: "9"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14.35 4.65 16.3 2.7a2.41 2.41 0 0 1 3.4 0l1.6 1.6a2.4 2.4 0 0 1 0 3.4l-1.95 1.95"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m22 2-1.5 1.5"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "3K_0");
const LuBone = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: /* @__PURE__ */ _jsxQ("path", null, {
    d: "M17 10c.7-.7 1.69 0 2.5 0a2.5 2.5 0 1 0 0-5 .5.5 0 0 1-.5-.5 2.5 2.5 0 1 0-5 0c0 .81.7 1.8 0 2.5l-7 7c-.7.7-1.69 0-2.5 0a2.5 2.5 0 0 0 0 5c.28 0 .5.22.5.5a2.5 2.5 0 1 0 5 0c0-.81-.7-1.8 0-2.5Z"
  }, null, 3, null)
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "D6_0");
const LuBookA = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m8 13 4-7 4 7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9.1 11h5.7"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "yM_0");
const LuBookAudio = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 8v3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 6v7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 8v3"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Ie_0");
const LuBookCheck = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m9 9.5 2 2 4-4"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "02_0");
const LuBookCopy = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 16V4a2 2 0 0 1 2-2h11"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M5 14H4a2 2 0 1 0 0 4h1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M22 18H11a2 2 0 1 0 0 4h11V6H11a2 2 0 0 0-2 2v12"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "GY_0");
const LuBookDashed = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M20 22h-2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M20 15v2h-2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 19.5V15"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M20 8v3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18 2h2v2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 11V9"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 2h2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 22h2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 17h2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 22H6.5a2.5 2.5 0 0 1 0-5H8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 5v-.5A2.5 2.5 0 0 1 6.5 2H8"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "4D_0");
const LuBookDown = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 13V7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m9 10 3 3 3-3"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "NT_0");
const LuBookHeadphones = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "9",
      cy: "12",
      r: "1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 12v-2a4 4 0 0 1 8 0v2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "15",
      cy: "12",
      r: "1"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "vR_0");
const LuBookHeart = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 8.2C16 7 15 6 13.8 6c-.8 0-1.4.3-1.8.9-.4-.6-1-.9-1.8-.9C9 6 8 7 8 8.2c0 .6.3 1.2.7 1.6h0C10 11.1 12 13 12 13s2-1.9 3.3-3.1h0c.4-.4.7-1 .7-1.7z"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "0m_0");
const LuBookImage = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "10",
      cy: "8",
      r: "2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m20 13.7-2.1-2.1c-.8-.8-2-.8-2.8 0L9.7 17"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "mq_0");
const LuBookKey = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H14"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M20 8v14H6.5a2.5 2.5 0 0 1 0-5H20"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "14",
      cy: "8",
      r: "2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m20 2-4.5 4.5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m19 3 1 1"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "8h_0");
const LuBookLock = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M20 15v7H6.5a2.5 2.5 0 0 1 0-5H20"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "5",
      rx: "1",
      width: "8",
      x: "12",
      y: "6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18 6V4a2 2 0 1 0-4 0v2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "mq_0");
const LuBookMarked = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "10 2 10 10 13 7 16 10 16 2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Vm_0");
const LuBookMinus = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 10h6"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "pd_0");
const LuBookOpenCheck = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 3H2v15h7c1.7 0 3 1.3 3 3V7c0-2.2-1.8-4-4-4Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m16 12 2 2 4-4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M22 6V3h-6c-2.2 0-4 1.8-4 4v14c0-1.7 1.3-3 3-3h7v-2.3"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "NX_0");
const LuBookOpenText = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6 8h2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6 12h2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 8h2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 12h2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "FD_0");
const LuBookOpen = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "uO_0");
const LuBookPlus = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 10h6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 7v6"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Qn_0");
const LuBookText = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 7h6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 11h8"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "2S_0");
const LuBookType = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 8V6H8v2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 6v7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10 13h4"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "69_0");
const LuBookUp2 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18 2h2v20H6.5a2.5 2.5 0 0 1 0-5H20"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 13V7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m9 10 3-3 3 3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m9 5 3-3 3 3"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "rr_0");
const LuBookUp = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 13V7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m9 10 3-3 3 3"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "20_0");
const LuBookUser = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "8",
      r: "2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M15 13a3 3 0 1 0-6 0"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Pc_0");
const LuBookX = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m14.5 7-5 5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m9.5 7 5 5"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Dv_0");
const LuBook = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: /* @__PURE__ */ _jsxQ("path", null, {
    d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20"
  }, null, 3, null)
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "0W_0");
const LuBookmarkCheck = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m9 10 2 2 4-4"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "7u_0");
const LuBookmarkMinus = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "15",
      x2: "9",
      y1: "10",
      y2: "10"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "8V_0");
const LuBookmarkPlus = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "12",
      x2: "12",
      y1: "7",
      y2: "13"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "15",
      x2: "9",
      y1: "10",
      y2: "10"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "9q_0");
const LuBookmarkX = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m14.5 7.5-5 5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m9.5 7.5 5 5"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "wv_0");
const LuBookmark = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: /* @__PURE__ */ _jsxQ("path", null, {
    d: "m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16z"
  }, null, 3, null)
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "3x_0");
const LuBoomBox = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 9V5a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 8v1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 8v1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 8v1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "12",
      rx: "2",
      width: "20",
      x: "2",
      y: "9"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "8",
      cy: "15",
      r: "2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "16",
      cy: "15",
      r: "2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "d2_0");
const LuBot = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 8V4H8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "12",
      rx: "2",
      width: "16",
      x: "4",
      y: "8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 14h2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M20 14h2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M15 13v2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 13v2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "ZM_0");
const LuBoxSelect = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M5 3a2 2 0 0 0-2 2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M19 3a2 2 0 0 1 2 2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 19a2 2 0 0 1-2 2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M5 21a2 2 0 0 1-2-2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 3h1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 21h1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14 3h1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14 21h1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 9v1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 9v1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 14v1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 14v1"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "IV_0");
const LuBox = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m3.3 7 8.7 5 8.7-5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 22V12"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "5m_0");
const LuBoxes = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2.97 12.92A2 2 0 0 0 2 14.63v3.24a2 2 0 0 0 .97 1.71l3 1.8a2 2 0 0 0 2.06 0L12 19v-5.5l-5-3-4.03 2.42Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m7 16.5-4.74-2.85"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m7 16.5 5-3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 16.5v5.17"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 13.5V19l3.97 2.38a2 2 0 0 0 2.06 0l3-1.8a2 2 0 0 0 .97-1.71v-3.24a2 2 0 0 0-.97-1.71L17 10.5l-5 3Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m17 16.5-5-3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m17 16.5 4.74-2.85"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17 16.5v5.17"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7.97 4.42A2 2 0 0 0 7 6.13v4.37l5 3 5-3V6.13a2 2 0 0 0-.97-1.71l-3-1.8a2 2 0 0 0-2.06 0l-3 1.8Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 8 7.26 5.15"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m12 8 4.74-2.85"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 13.5V8"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "JV_0");
const LuBraces = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 3H7a2 2 0 0 0-2 2v5a2 2 0 0 1-2 2 2 2 0 0 1 2 2v5c0 1.1.9 2 2 2h1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 21h1a2 2 0 0 0 2-2v-5c0-1.1.9-2 2-2a2 2 0 0 1-2-2V5a2 2 0 0 0-2-2h-1"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "VS_0");
const LuBrackets = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 3h3v18h-3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 21H5V3h3"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "kl_0");
const LuBrainCircuit = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 4.5a2.5 2.5 0 0 0-4.96-.46 2.5 2.5 0 0 0-1.98 3 2.5 2.5 0 0 0-1.32 4.24 3 3 0 0 0 .34 5.58 2.5 2.5 0 0 0 2.96 3.08 2.5 2.5 0 0 0 4.91.05L12 20V4.5Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 8V5c0-1.1.9-2 2-2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 13h4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 18h6a2 2 0 0 1 2 2v1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 8h8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M20.5 8a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16.5 13a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M20.5 21a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18.5 3a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "5a_0");
const LuBrainCog = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 4.5a2.5 2.5 0 0 0-4.96-.46 2.5 2.5 0 0 0-1.98 3 2.5 2.5 0 0 0-1.32 4.24 3 3 0 0 0 .34 5.58 2.5 2.5 0 0 0 2.96 3.08A2.5 2.5 0 0 0 12 19.5a2.5 2.5 0 0 0 4.96.44 2.5 2.5 0 0 0 2.96-3.08 3 3 0 0 0 .34-5.58 2.5 2.5 0 0 0-1.32-4.24 2.5 2.5 0 0 0-1.98-3A2.5 2.5 0 0 0 12 4.5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m15.7 10.4-.9.4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m9.2 13.2-.9.4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m13.6 15.7-.4-.9"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m10.8 9.2-.4-.9"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m15.7 13.5-.9-.4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m9.2 10.9-.9-.4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m10.5 15.7.4-.9"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m13.1 9.2.4-.9"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "oh_0");
const LuBrain = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9.5 2A2.5 2.5 0 0 1 12 4.5v15a2.5 2.5 0 0 1-4.96.44 2.5 2.5 0 0 1-2.96-3.08 3 3 0 0 1-.34-5.58 2.5 2.5 0 0 1 1.32-4.24 2.5 2.5 0 0 1 1.98-3A2.5 2.5 0 0 1 9.5 2Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14.5 2A2.5 2.5 0 0 0 12 4.5v15a2.5 2.5 0 0 0 4.96.44 2.5 2.5 0 0 0 2.96-3.08 3 3 0 0 0 .34-5.58 2.5 2.5 0 0 0-1.32-4.24 2.5 2.5 0 0 0-1.98-3A2.5 2.5 0 0 0 14.5 2Z"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "oi_0");
const LuBriefcase = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "14",
      rx: "2",
      ry: "2",
      width: "20",
      x: "2",
      y: "7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "sZ_0");
const LuBringToFront = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "8",
      rx: "2",
      width: "8",
      x: "8",
      y: "8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 10a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14 20a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "XP_0");
const LuBrush = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m9.06 11.9 8.07-8.06a2.85 2.85 0 1 1 4.03 4.03l-8.06 8.08"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7.07 14.94c-1.66 0-3 1.35-3 3.02 0 1.33-2.5 1.52-2 2.02 1.08 1.1 2.49 2.02 4 2.02 2.2 0 4-1.8 4-4.04a3.01 3.01 0 0 0-3-3.02z"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "yj_0");
const LuBugOff = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M15 7.13V6a3 3 0 0 0-5.14-2.1L8 2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14.12 3.88 16 2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M22 13h-4v-2a4 4 0 0 0-4-4h-1.3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M20.97 5c0 2.1-1.6 3.8-3.5 4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m2 2 20 20"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7.7 7.7A4 4 0 0 0 6 11v3a6 6 0 0 0 11.13 3.13"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 20v-8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6 13H2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 21c0-2.1 1.7-3.9 3.8-4"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "AJ_0");
const LuBugPlay = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m8 2 1.88 1.88"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14.12 3.88 16 2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 7.13v-1a3.003 3.003 0 1 1 6 0v1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18 11a4 4 0 0 0-4-4h-4a4 4 0 0 0-4 4v3a6.1 6.1 0 0 0 2 4.5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6.53 9C4.6 8.8 3 7.1 3 5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6 13H2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 21c0-2.1 1.7-3.9 3.8-4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M20.97 5c0 2.1-1.6 3.8-3.5 4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m12 12 8 5-8 5Z"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "JS_0");
const LuBug = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m8 2 1.88 1.88"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14.12 3.88 16 2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 7.13v-1a3.003 3.003 0 1 1 6 0v1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 20c-3.3 0-6-2.7-6-6v-3a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v3c0 3.3-2.7 6-6 6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 20v-9"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6.53 9C4.6 8.8 3 7.1 3 5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6 13H2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 21c0-2.1 1.7-3.9 3.8-4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M20.97 5c0 2.1-1.6 3.8-3.5 4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M22 13h-4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17.2 17c2.1.1 3.8 1.9 3.8 4"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "tO_0");
const LuBuilding2 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10 6h4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10 10h4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10 14h4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10 18h4"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "uI_0");
const LuBuilding = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "20",
      rx: "2",
      ry: "2",
      width: "16",
      x: "4",
      y: "2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 22v-4h6v4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 6h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 6h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 6h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 10h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 14h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 10h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 14h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 10h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 14h.01"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "t9_0");
const LuBusFront = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 6 2 7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10 6h4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m22 7-2-1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "16",
      rx: "2",
      width: "16",
      x: "4",
      y: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 11h16"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 15h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 15h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6 19v2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18 21v-2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "uU_0");
const LuBus = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 6v6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M15 6v6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 12h19.6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18 18h3s.5-1.7.8-2.8c.1-.4.2-.8.2-1.2 0-.4-.1-.8-.2-1.2l-1.4-5C20.1 6.8 19.1 6 18 6H4a2 2 0 0 0-2 2v10h3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "7",
      cy: "18",
      r: "2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 18h5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "16",
      cy: "18",
      r: "2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "cU_0");
const LuCableCar = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10 3h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14 2h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m2 9 20-5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 12V6.5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "10",
      rx: "3",
      width: "16",
      x: "4",
      y: "12"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 12v5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M15 12v5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 17h16"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "0d_0");
const LuCable = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 9a2 2 0 0 1-2-2V5h6v2a2 2 0 0 1-2 2Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 5V3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 5V3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M19 15V6.5a3.5 3.5 0 0 0-7 0v11a3.5 3.5 0 0 1-7 0V9"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17 21v-2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 21v-2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M22 19h-6v-2a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2Z"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "YD_0");
const LuCakeSlice = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "9",
      cy: "7",
      r: "2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7.2 7.9 3 11v9c0 .6.4 1 1 1h16c.6 0 1-.4 1-1v-9c0-2-3-6-7-8l-3.6 2.6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 13H3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 17H3"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Rb_0");
const LuCake = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M20 21v-8a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 16s.5-1 2-1 2.5 2 4 2 2.5-2 4-2 2.5 2 4 2 2-1 2-1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 21h20"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 8v2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 8v2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17 8v2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 4h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 4h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17 4h.01"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "bb_0");
const LuCalculator = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "20",
      rx: "2",
      width: "16",
      x: "4",
      y: "2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "8",
      x2: "16",
      y1: "6",
      y2: "6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "16",
      x2: "16",
      y1: "14",
      y2: "18"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 10h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 10h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 10h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 14h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 14h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 18h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 18h.01"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "T7_0");
const LuCalendarCheck2 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 14V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "16",
      x2: "16",
      y1: "2",
      y2: "6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "8",
      x2: "8",
      y1: "2",
      y2: "6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "3",
      x2: "21",
      y1: "10",
      y2: "10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m16 20 2 2 4-4"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "iW_0");
const LuCalendarCheck = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "18",
      rx: "2",
      ry: "2",
      width: "18",
      x: "3",
      y: "4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "16",
      x2: "16",
      y1: "2",
      y2: "6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "8",
      x2: "8",
      y1: "2",
      y2: "6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "3",
      x2: "21",
      y1: "10",
      y2: "10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m9 16 2 2 4-4"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "3s_0");
const LuCalendarClock = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 7.5V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h3.5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 2v4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 2v4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 10h5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17.5 17.5 16 16.25V14"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M22 16a6 6 0 1 1-12 0 6 6 0 0 1 12 0Z"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "X1_0");
const LuCalendarDays = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "18",
      rx: "2",
      ry: "2",
      width: "18",
      x: "3",
      y: "4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "16",
      x2: "16",
      y1: "2",
      y2: "6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "8",
      x2: "8",
      y1: "2",
      y2: "6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "3",
      x2: "21",
      y1: "10",
      y2: "10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 14h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 14h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 14h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 18h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 18h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 18h.01"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "R5_0");
const LuCalendarHeart = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 10V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14c0 1.1.9 2 2 2h7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 2v4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 2v4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 10h18"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21.29 14.7a2.43 2.43 0 0 0-2.65-.52c-.3.12-.57.3-.8.53l-.34.34-.35-.34a2.43 2.43 0 0 0-2.65-.53c-.3.12-.56.3-.79.53-.95.94-1 2.53.2 3.74L17.5 22l3.6-3.55c1.2-1.21 1.14-2.8.19-3.74Z"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "e8_0");
const LuCalendarMinus = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 13V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "16",
      x2: "16",
      y1: "2",
      y2: "6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "8",
      x2: "8",
      y1: "2",
      y2: "6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "3",
      x2: "21",
      y1: "10",
      y2: "10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "16",
      x2: "22",
      y1: "19",
      y2: "19"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "6v_0");
const LuCalendarOff = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4.18 4.18A2 2 0 0 0 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 1.82-1.18"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 15.5V6a2 2 0 0 0-2-2H9.5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 2v4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 10h7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 10h-5.5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "2",
      x2: "22",
      y1: "2",
      y2: "22"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "1P_0");
const LuCalendarPlus = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 13V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "16",
      x2: "16",
      y1: "2",
      y2: "6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "8",
      x2: "8",
      y1: "2",
      y2: "6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "3",
      x2: "21",
      y1: "10",
      y2: "10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "19",
      x2: "19",
      y1: "16",
      y2: "22"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "16",
      x2: "22",
      y1: "19",
      y2: "19"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "fd_0");
const LuCalendarRange = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "18",
      rx: "2",
      ry: "2",
      width: "18",
      x: "3",
      y: "4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "16",
      x2: "16",
      y1: "2",
      y2: "6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "8",
      x2: "8",
      y1: "2",
      y2: "6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "3",
      x2: "21",
      y1: "10",
      y2: "10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17 14h-6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M13 18H7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 14h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17 18h.01"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "iI_0");
const LuCalendarSearch = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 12V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14c0 1.1.9 2 2 2h7.5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 2v4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 2v4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 10h18"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18 21a3 3 0 1 0 0-6 3 3 0 0 0 0 6v0Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m22 22-1.5-1.5"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "jY_0");
const LuCalendarX2 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 13V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "16",
      x2: "16",
      y1: "2",
      y2: "6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "8",
      x2: "8",
      y1: "2",
      y2: "6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "3",
      x2: "21",
      y1: "10",
      y2: "10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "17",
      x2: "22",
      y1: "17",
      y2: "22"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "17",
      x2: "22",
      y1: "22",
      y2: "17"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "l3_0");
const LuCalendarX = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "18",
      rx: "2",
      ry: "2",
      width: "18",
      x: "3",
      y: "4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "16",
      x2: "16",
      y1: "2",
      y2: "6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "8",
      x2: "8",
      y1: "2",
      y2: "6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "3",
      x2: "21",
      y1: "10",
      y2: "10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "10",
      x2: "14",
      y1: "14",
      y2: "18"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "14",
      x2: "10",
      y1: "14",
      y2: "18"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Rz_0");
const LuCalendar = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "18",
      rx: "2",
      ry: "2",
      width: "18",
      x: "3",
      y: "4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "16",
      x2: "16",
      y1: "2",
      y2: "6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "8",
      x2: "8",
      y1: "2",
      y2: "6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "3",
      x2: "21",
      y1: "10",
      y2: "10"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "34_0");
const LuCameraOff = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "2",
      x2: "22",
      y1: "2",
      y2: "22"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9.5 4h5L17 7h3a2 2 0 0 1 2 2v7.5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14.121 15.121A3 3 0 1 1 9.88 10.88"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Pn_0");
const LuCamera = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "13",
      r: "3"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "XD_0");
const LuCandlestickChart = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 5v4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "6",
      rx: "1",
      width: "4",
      x: "7",
      y: "9"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 15v2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17 3v2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "8",
      rx: "1",
      width: "4",
      x: "15",
      y: "5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17 13v3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 3v18h18"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "OZ_0");
const LuCandyCane = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M5.7 21a2 2 0 0 1-3.5-2l8.6-14a6 6 0 0 1 10.4 6 2 2 0 1 1-3.464-2 2 2 0 1 0-3.464-2Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17.75 7 15 2.1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10.9 4.8 13 9"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m7.9 9.7 2 4.4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4.9 14.7 7 18.9"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "tM_0");
const LuCandyOff = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m8.5 8.5-1 1a4.95 4.95 0 0 0 7 7l1-1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M11.843 6.187A4.947 4.947 0 0 1 16.5 7.5a4.947 4.947 0 0 1 1.313 4.657"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14 16.5V14"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14 6.5v1.843"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10 10v7.5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m16 7 1-5 1.367.683A3 3 0 0 0 19.708 3H21v1.292a3 3 0 0 0 .317 1.341L22 7l-5 1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m8 17-1 5-1.367-.683A3 3 0 0 0 4.292 21H3v-1.292a3 3 0 0 0-.317-1.341L2 17l5-1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "2",
      x2: "22",
      y1: "2",
      y2: "22"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Ri_0");
const LuCandy = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m9.5 7.5-2 2a4.95 4.95 0 1 0 7 7l2-2a4.95 4.95 0 1 0-7-7Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14 6.5v10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10 7.5v10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m16 7 1-5 1.37.68A3 3 0 0 0 19.7 3H21v1.3c0 .46.1.92.32 1.33L22 7l-5 1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m8 17-1 5-1.37-.68A3 3 0 0 0 4.3 21H3v-1.3a3 3 0 0 0-.32-1.33L2 17l5-1"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "nu_0");
const LuCarFront = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m21 8-2 2-1.5-3.7A2 2 0 0 0 15.646 5H8.4a2 2 0 0 0-1.903 1.257L5 10 3 8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 14h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17 14h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "8",
      rx: "2",
      width: "18",
      x: "3",
      y: "10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M5 18v2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M19 18v2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Y1_0");
const LuCarTaxiFront = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10 2h4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m21 8-2 2-1.5-3.7A2 2 0 0 0 15.646 5H8.4a2 2 0 0 0-1.903 1.257L5 10 3 8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 14h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17 14h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "8",
      rx: "2",
      width: "18",
      x: "3",
      y: "10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M5 18v2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M19 18v2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "KX_0");
const LuCar = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M19 17h2c.6 0 1-.4 1-1v-3c0-.9-.7-1.7-1.5-1.9C18.7 10.6 16 10 16 10s-1.3-1.4-2.2-2.3c-.5-.4-1.1-.7-1.8-.7H5c-.6 0-1.1.4-1.4.9l-1.4 2.9A3.7 3.7 0 0 0 2 12v4c0 .6.4 1 1 1h2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "7",
      cy: "17",
      r: "2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 17h6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "17",
      cy: "17",
      r: "2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "cw_0");
const LuCaravan = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "4",
      width: "4",
      x: "2",
      y: "9"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "10",
      width: "4",
      x: "10",
      y: "9"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18 19V9a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v8a2 2 0 0 0 2 2h2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "8",
      cy: "19",
      r: "2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10 19h12v-2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "GX_0");
const LuCarrot = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2.27 21.7s9.87-3.5 12.73-6.36a4.5 4.5 0 0 0-6.36-6.37C5.77 11.84 2.27 21.7 2.27 21.7zM8.64 14l-2.05-2.04M15.34 15l-2.46-2.46"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M22 9s-1.33-2-3.5-2C16.86 7 15 9 15 9s1.33 2 3.5 2S22 9 22 9z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M15 2s-2 1.33-2 3.5S15 9 15 9s2-1.84 2-3.5C17 3.33 15 2 15 2z"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "kq_0");
const LuCaseLower = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "7",
      cy: "12",
      r: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10 9v6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "17",
      cy: "12",
      r: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14 7v8"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "gD_0");
const LuCaseSensitive = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m3 15 4-8 4 8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 13h6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "18",
      cy: "12",
      r: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 9v6"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "ON_0");
const LuCaseUpper = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m3 15 4-8 4 8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 13h6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M15 11h4.5a2 2 0 0 1 0 4H15V7h4a2 2 0 0 1 0 4"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "JW_0");
const LuCassetteTape = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "16",
      rx: "2",
      width: "20",
      x: "2",
      y: "4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "8",
      cy: "10",
      r: "2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 12h8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "16",
      cy: "10",
      r: "2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m6 20 .7-2.9A1.4 1.4 0 0 1 8.1 16h7.8a1.4 1.4 0 0 1 1.4 1l.7 3"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "0s_0");
const LuCast = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 8V6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 12a9 9 0 0 1 8 8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 16a5 5 0 0 1 4 4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "2",
      x2: "2.01",
      y1: "20",
      y2: "20"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "a6_0");
const LuCastle = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M22 20v-9H2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18 11V4H6v7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M15 22v-4a3 3 0 0 0-3-3v0a3 3 0 0 0-3 3v4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M22 11V9"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 11V9"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6 4V2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18 4V2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10 4V2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14 4V2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Jx_0");
const LuCat = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 5c.67 0 1.35.09 2 .26 1.78-2 5.03-2.84 6.42-2.26 1.4.58-.42 7-.42 7 .57 1.07 1 2.24 1 3.44C21 17.9 16.97 21 12 21s-9-3-9-7.56c0-1.25.5-2.4 1-3.44 0 0-1.89-6.42-.5-7 1.39-.58 4.72.23 6.5 2.23A9.04 9.04 0 0 1 12 5Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 14v.5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 14v.5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M11.25 16.25h1.5L12 17l-.75-.75Z"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "0U_0");
const LuCheckCheck = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18 6 7 17l-5-5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m22 10-7.5 7.5L13 16"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "t4_0");
const LuCheckCircle2 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m9 12 2 2 4-4"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "IH_0");
const LuCheckCircle = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M22 11.08V12a10 10 0 1 1-5.93-9.14"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "22 4 12 14.01 9 11.01"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Jy_0");
const LuCheckSquare = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "9 11 12 14 22 4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "0r_0");
const LuCheck = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: /* @__PURE__ */ _jsxQ("polyline", null, {
    points: "20 6 9 17 4 12"
  }, null, 3, null)
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "R2_0");
const LuChefHat = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6 13.87A4 4 0 0 1 7.41 6a5.11 5.11 0 0 1 1.05-1.54 5 5 0 0 1 7.08 0A5.11 5.11 0 0 1 16.59 6 4 4 0 0 1 18 13.87V21H6Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "6",
      x2: "18",
      y1: "17",
      y2: "17"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "qI_0");
const LuCherry = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 17a5 5 0 0 0 10 0c0-2.76-2.5-5-5-3-2.5-2-5 .24-5 3Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 17a5 5 0 0 0 10 0c0-2.76-2.5-5-5-3-2.5-2-5 .24-5 3Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 14c3.22-2.91 4.29-8.75 5-12 1.66 2.38 4.94 9 5 12"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M22 9c-4.29 0-7.14-2.33-10-7 5.71 0 10 4.67 10 7Z"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "MW_0");
const LuChevronDownCircle = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m16 10-4 4-4-4"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "20_0");
const LuChevronDownSquare = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "18",
      rx: "2",
      width: "18",
      x: "3",
      y: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m16 10-4 4-4-4"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "zL_0");
const LuChevronDown = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: /* @__PURE__ */ _jsxQ("path", null, {
    d: "m6 9 6 6 6-6"
  }, null, 3, null)
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "8g_0");
const LuChevronFirst = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m17 18-6-6 6-6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 6v12"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "iN_0");
const LuChevronLast = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m7 18 6-6-6-6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17 6v12"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "a0_0");
const LuChevronLeftCircle = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m14 16-4-4 4-4"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Ye_0");
const LuChevronLeftSquare = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "18",
      rx: "2",
      width: "18",
      x: "3",
      y: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m14 16-4-4 4-4"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "03_0");
const LuChevronLeft = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: /* @__PURE__ */ _jsxQ("path", null, {
    d: "m15 18-6-6 6-6"
  }, null, 3, null)
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "5O_0");
const LuChevronRightCircle = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m10 8 4 4-4 4"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "AC_0");
const LuChevronRightSquare = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "18",
      rx: "2",
      width: "18",
      x: "3",
      y: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m10 8 4 4-4 4"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "93_0");
const LuChevronRight = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: /* @__PURE__ */ _jsxQ("path", null, {
    d: "m9 18 6-6-6-6"
  }, null, 3, null)
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Rc_0");
const LuChevronUpCircle = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m8 14 4-4 4 4"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "KW_0");
const LuChevronUpSquare = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "18",
      rx: "2",
      width: "18",
      x: "3",
      y: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m8 14 4-4 4 4"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "CJ_0");
const LuChevronUp = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: /* @__PURE__ */ _jsxQ("path", null, {
    d: "m18 15-6-6-6 6"
  }, null, 3, null)
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Kp_0");
const LuChevronsDownUp = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m7 20 5-5 5 5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m7 4 5 5 5-5"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Ih_0");
const LuChevronsDown = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m7 6 5 5 5-5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m7 13 5 5 5-5"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "qA_0");
const LuChevronsLeftRight = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m9 7-5 5 5 5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m15 7 5 5-5 5"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "8b_0");
const LuChevronsLeft = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m11 17-5-5 5-5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m18 17-5-5 5-5"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "uz_0");
const LuChevronsRightLeft = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m20 17-5-5 5-5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m4 17 5-5-5-5"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "ZJ_0");
const LuChevronsRight = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m6 17 5-5-5-5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m13 17 5-5-5-5"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "70_0");
const LuChevronsUpDown = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m7 15 5 5 5-5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m7 9 5-5 5 5"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Nz_0");
const LuChevronsUp = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m17 11-5-5-5 5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m17 18-5-5-5 5"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "7Z_0");
const LuChrome = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "21.17",
      x2: "12",
      y1: "8",
      y2: "8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "3.95",
      x2: "8.54",
      y1: "6.06",
      y2: "14"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "10.88",
      x2: "15.46",
      y1: "21.94",
      y2: "14"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "hc_0");
const LuChurch = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m18 7 4 2v11a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9l4-2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14 22v-4a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18 22V5l-6-3-6 3v17"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 7v5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10 9h4"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Te_0");
const LuCigaretteOff = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "2",
      x2: "22",
      y1: "2",
      y2: "22"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 12H2v4h14"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M22 12v4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18 12h-.5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 12v4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18 8c0-2.5-2-2.5-2-5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M22 8c0-2.5-2-2.5-2-5"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "8w_0");
const LuCigarette = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18 12H2v4h16"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M22 12v4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 12v4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18 8c0-2.5-2-2.5-2-5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M22 8c0-2.5-2-2.5-2-5"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Ct_0");
const LuCircleDashed = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10.1 2.18a9.93 9.93 0 0 1 3.8 0"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17.6 3.71a9.95 9.95 0 0 1 2.69 2.7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21.82 10.1a9.93 9.93 0 0 1 0 3.8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M20.29 17.6a9.95 9.95 0 0 1-2.7 2.69"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M13.9 21.82a9.94 9.94 0 0 1-3.8 0"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6.4 20.29a9.95 9.95 0 0 1-2.69-2.7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2.18 13.9a9.93 9.93 0 0 1 0-3.8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3.71 6.4a9.95 9.95 0 0 1 2.7-2.69"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "XA_0");
const LuCircleDollarSign = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 18V6"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "pA_0");
const LuCircleDotDashed = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10.1 2.18a9.93 9.93 0 0 1 3.8 0"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17.6 3.71a9.95 9.95 0 0 1 2.69 2.7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21.82 10.1a9.93 9.93 0 0 1 0 3.8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M20.29 17.6a9.95 9.95 0 0 1-2.7 2.69"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M13.9 21.82a9.94 9.94 0 0 1-3.8 0"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6.4 20.29a9.95 9.95 0 0 1-2.69-2.7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2.18 13.9a9.93 9.93 0 0 1 0-3.8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3.71 6.4a9.95 9.95 0 0 1 2.7-2.69"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "1"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "de_0");
const LuCircleDot = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "1"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "56_0");
const LuCircleEllipsis = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17 12h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 12h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 12h.01"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "J0_0");
const LuCircleEqual = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 10h10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 14h10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "10"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "7k_0");
const LuCircleOff = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m2 2 20 20"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8.35 2.69A10 10 0 0 1 21.3 15.65"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M19.08 19.08A10 10 0 1 1 4.92 4.92"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "gZ_0");
const LuCircleSlash2 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M22 2 2 22"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "3I_0");
const LuCircleSlash = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "9",
      x2: "15",
      y1: "15",
      y2: "9"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "10"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "UW_0");
const LuCircle = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: /* @__PURE__ */ _jsxQ("circle", null, {
    cx: "12",
    cy: "12",
    r: "10"
  }, null, 3, null)
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Fa_0");
const LuCircuitBoard = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "18",
      rx: "2",
      width: "18",
      x: "3",
      y: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M11 9h4a2 2 0 0 0 2-2V3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "9",
      cy: "9",
      r: "2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 21v-4a2 2 0 0 1 2-2h4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "15",
      cy: "15",
      r: "2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "iK_0");
const LuCitrus = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21.66 17.67a1.08 1.08 0 0 1-.04 1.6A12 12 0 0 1 4.73 2.38a1.1 1.1 0 0 1 1.61-.04z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M19.65 15.66A8 8 0 0 1 8.35 4.34"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m14 10-5.5 5.5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14 17.85V10H6.15"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Vu_0");
const LuClapperboard = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M20.2 6 3 11l-.9-2.4c-.3-1.1.3-2.2 1.3-2.5l13.5-4c1.1-.3 2.2.3 2.5 1.3Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m6.2 5.3 3.1 3.9"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m12.4 3.4 3.1 4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 11h18v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2Z"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "W3_0");
const LuClipboardCheck = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "4",
      rx: "1",
      ry: "1",
      width: "8",
      x: "8",
      y: "2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m9 14 2 2 4-4"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "xr_0");
const LuClipboardCopy = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "4",
      rx: "1",
      ry: "1",
      width: "8",
      x: "8",
      y: "2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 4H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 4h2a2 2 0 0 1 2 2v4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 14H11"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m15 10-4 4 4 4"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "bT_0");
const LuClipboardEdit = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "4",
      rx: "1",
      ry: "1",
      width: "8",
      x: "8",
      y: "2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10.42 12.61a2.1 2.1 0 1 1 2.97 2.97L7.95 21 4 22l.99-3.95 5.43-5.44Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-5.5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 13.5V6a2 2 0 0 1 2-2h2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "sl_0");
const LuClipboardList = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "4",
      rx: "1",
      ry: "1",
      width: "8",
      x: "8",
      y: "2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 11h4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 16h4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 11h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 16h.01"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "kq_0");
const LuClipboardPaste = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M15 2H9a1 1 0 0 0-1 1v2c0 .6.4 1 1 1h6c.6 0 1-.4 1-1V3c0-.6-.4-1-1-1Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 4H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2M16 4h2a2 2 0 0 1 2 2v2M11 14h10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m17 10 4 4-4 4"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "M7_0");
const LuClipboardSignature = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "4",
      rx: "1",
      ry: "1",
      width: "8",
      x: "8",
      y: "2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 4H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-.5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 4h2a2 2 0 0 1 1.73 1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18.42 9.61a2.1 2.1 0 1 1 2.97 2.97L16.95 17 13 18l.99-3.95 4.43-4.44Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 18h1"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Qw_0");
const LuClipboardType = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "4",
      rx: "1",
      ry: "1",
      width: "8",
      x: "8",
      y: "2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 12v-1h6v1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M11 17h2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 11v6"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "uF_0");
const LuClipboardX = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "4",
      rx: "1",
      ry: "1",
      width: "8",
      x: "8",
      y: "2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m15 11-6 6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m9 11 6 6"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "mX_0");
const LuClipboard = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "4",
      rx: "1",
      ry: "1",
      width: "8",
      x: "8",
      y: "2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "uz_0");
const LuClock1 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "12 6 12 12 14.5 8"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "CW_0");
const LuClock10 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "12 6 12 12 8 10"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "gl_0");
const LuClock11 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "12 6 12 12 9.5 8"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "eU_0");
const LuClock12 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "12 6 12 12"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "dU_0");
const LuClock2 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "12 6 12 12 16 10"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Sr_0");
const LuClock3 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "12 6 12 12 16.5 12"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "wI_0");
const LuClock4 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "12 6 12 12 16 14"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Xw_0");
const LuClock5 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "12 6 12 12 14.5 16"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Rf_0");
const LuClock6 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "12 6 12 12 12 16.5"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "EC_0");
const LuClock7 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "12 6 12 12 9.5 16"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Ie_0");
const LuClock8 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "12 6 12 12 8 14"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Rs_0");
const LuClock9 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "12 6 12 12 7.5 12"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "4J_0");
const LuClock = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "12 6 12 12 16 14"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "PM_0");
const LuCloudCog = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "17",
      r: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4.2 15.1A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m15.7 18.4-.9-.3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m9.2 15.9-.9-.3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m10.6 20.7.3-.9"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m13.1 14.2.3-.9"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m13.6 20.7-.4-1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m10.8 14.3-.4-1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m8.3 18.6 1-.4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m14.7 15.8 1-.4"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "8h_0");
const LuCloudDrizzle = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 19v1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 14v1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 19v1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 14v1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 21v1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 16v1"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "VY_0");
const LuCloudFog = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 17H7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17 21H9"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "0w_0");
const LuCloudHail = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 14v2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 14v2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 20h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 20h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 16v2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 22h.01"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "BS_0");
const LuCloudLightning = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6 16.326A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 .5 8.973"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m13 12-3 5h4l-3 5"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "hR_0");
const LuCloudMoonRain = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10.083 9A6.002 6.002 0 0 1 16 4a4.243 4.243 0 0 0 6 6c0 2.22-1.206 4.16-3 5.197"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 20a5 5 0 1 1 8.9-4H13a3 3 0 0 1 2 5.24"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M11 20v2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 19v2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "gM_0");
const LuCloudMoon = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M13 16a3 3 0 1 1 0 6H7a5 5 0 1 1 4.9-6Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10.1 9A6 6 0 0 1 16 4a4.24 4.24 0 0 0 6 6 6 6 0 0 1-3 5.197"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "7W_0");
const LuCloudOff = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m2 2 20 20"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M5.782 5.782A7 7 0 0 0 9 19h8.5a4.5 4.5 0 0 0 1.307-.193"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21.532 16.5A4.5 4.5 0 0 0 17.5 10h-1.79A7.008 7.008 0 0 0 10 5.07"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Zd_0");
const LuCloudRainWind = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m9.2 22 3-7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m9 13-3 7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m17 13-3 7"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "7O_0");
const LuCloudRain = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 14v6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 14v6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 16v6"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "IZ_0");
const LuCloudSnow = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 15h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 19h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 17h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 21h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 15h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 19h.01"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "7B_0");
const LuCloudSunRain = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 2v2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m4.93 4.93 1.41 1.41"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M20 12h2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m19.07 4.93-1.41 1.41"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M15.947 12.65a4 4 0 0 0-5.925-4.128"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 20a5 5 0 1 1 8.9-4H13a3 3 0 0 1 2 5.24"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M11 20v2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 19v2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "fG_0");
const LuCloudSun = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 2v2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m4.93 4.93 1.41 1.41"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M20 12h2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m19.07 4.93-1.41 1.41"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M15.947 12.65a4 4 0 0 0-5.925-4.128"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M13 22H7a5 5 0 1 1 4.9-6H13a3 3 0 0 1 0 6Z"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "bd_0");
const LuCloud = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: /* @__PURE__ */ _jsxQ("path", null, {
    d: "M17.5 19H9a7 7 0 1 1 6.71-9h1.79a4.5 4.5 0 1 1 0 9Z"
  }, null, 3, null)
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "gV_0");
const LuCloudy = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17.5 21H9a7 7 0 1 1 6.71-9h1.79a4.5 4.5 0 1 1 0 9Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M22 10a3 3 0 0 0-3-3h-2.207a5.502 5.502 0 0 0-10.702.5"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "K4_0");
const LuClover = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16.2 3.8a2.7 2.7 0 0 0-3.81 0l-.4.38-.4-.4a2.7 2.7 0 0 0-3.82 0C6.73 4.85 6.67 6.64 8 8l4 4 4-4c1.33-1.36 1.27-3.15.2-4.2z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 8c-1.36-1.33-3.15-1.27-4.2-.2a2.7 2.7 0 0 0 0 3.81l.38.4-.4.4a2.7 2.7 0 0 0 0 3.82C4.85 17.27 6.64 17.33 8 16"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 16c1.36 1.33 3.15 1.27 4.2.2a2.7 2.7 0 0 0 0-3.81l-.38-.4.4-.4a2.7 2.7 0 0 0 0-3.82C19.15 6.73 17.36 6.67 16 8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7.8 20.2a2.7 2.7 0 0 0 3.81 0l.4-.38.4.4a2.7 2.7 0 0 0 3.82 0c1.06-1.06 1.12-2.85-.21-4.21l-4-4-4 4c-1.33 1.36-1.27 3.15-.2 4.2z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m7 17-5 5"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Op_0");
const LuClub = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17.28 9.05a5.5 5.5 0 1 0-10.56 0A5.5 5.5 0 1 0 12 17.66a5.5 5.5 0 1 0 5.28-8.6Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 17.66L12 22"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "OA_0");
const LuCode2 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m18 16 4-4-4-4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m6 8-4 4 4 4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m14.5 4-5 16"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Ac_0");
const LuCode = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "16 18 22 12 16 6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "8 6 2 12 8 18"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "wC_0");
const LuCodepen = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("polygon", null, {
      points: "12 2 22 8.5 22 15.5 12 22 2 15.5 2 8.5 12 2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "12",
      x2: "12",
      y1: "22",
      y2: "15.5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "22 8.5 12 15.5 2 8.5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "2 15.5 12 8.5 22 15.5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "12",
      x2: "12",
      y1: "2",
      y2: "8.5"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "hF_0");
const LuCodesandbox = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "7.5 4.21 12 6.81 16.5 4.21"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "7.5 19.79 7.5 14.6 3 12"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "21 12 16.5 14.6 16.5 19.79"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "3.27 6.96 12 12.01 20.73 6.96"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "12",
      x2: "12",
      y1: "22.08",
      y2: "12"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "GK_0");
const LuCoffee = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17 8h1a4 4 0 1 1 0 8h-1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 8h14v9a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "6",
      x2: "6",
      y1: "2",
      y2: "4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "10",
      x2: "10",
      y1: "2",
      y2: "4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "14",
      x2: "14",
      y1: "2",
      y2: "4"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "3p_0");
const LuCog = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 2v2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 22v-2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m17 20.66-1-1.73"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M11 10.27 7 3.34"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m20.66 17-1.73-1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m3.34 7 1.73 1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14 12h8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 12h2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m20.66 7-1.73 1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m3.34 17 1.73-1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m17 3.34-1 1.73"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m11 13.73-4 6.93"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "nn_0");
const LuCoins = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "8",
      cy: "8",
      r: "6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18.09 10.37A6 6 0 1 1 10.34 18"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 6h1v4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m16.71 13.88.7.71-2.82 2.82"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "gi_0");
const LuColumns = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "18",
      rx: "2",
      ry: "2",
      width: "18",
      x: "3",
      y: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "12",
      x2: "12",
      y1: "3",
      y2: "21"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "01_0");
const LuCombine = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "8",
      rx: "2",
      width: "8",
      x: "2",
      y: "2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14 2c1.1 0 2 .9 2 2v4c0 1.1-.9 2-2 2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M20 2c1.1 0 2 .9 2 2v4c0 1.1-.9 2-2 2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10 18H5c-1.7 0-3-1.3-3-3v-1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "7 21 10 18 7 15"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "8",
      rx: "2",
      width: "8",
      x: "14",
      y: "14"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "YP_0");
const LuCommand = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: /* @__PURE__ */ _jsxQ("path", null, {
    d: "M15 6v12a3 3 0 1 0 3-3H6a3 3 0 1 0 3 3V6a3 3 0 1 0-3 3h12a3 3 0 1 0-3-3"
  }, null, 3, null)
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "RZ_0");
const LuCompass = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polygon", null, {
      points: "16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Y4_0");
const LuComponent = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M5.5 8.5 9 12l-3.5 3.5L2 12l3.5-3.5Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m12 2 3.5 3.5L12 9 8.5 5.5 12 2Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18.5 8.5 22 12l-3.5 3.5L15 12l3.5-3.5Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m12 15 3.5 3.5L12 22l-3.5-3.5L12 15Z"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "kk_0");
const LuComputer = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "8",
      rx: "2",
      width: "14",
      x: "5",
      y: "2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "8",
      rx: "2",
      width: "20",
      x: "2",
      y: "14"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6 18h2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 18h6"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "SD_0");
const LuConciergeBell = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 18a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v2H2v-2Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M20 16a8 8 0 1 0-16 0"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 4v4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10 4h4"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "wG_0");
const LuCone = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m20.9 18.55-8-15.98a1 1 0 0 0-1.8 0l-8 15.98"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("ellipse", null, {
      cx: "12",
      cy: "19",
      rx: "9",
      ry: "3"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Mv_0");
const LuConstruction = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "8",
      rx: "1",
      width: "20",
      x: "2",
      y: "6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17 14v7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 14v7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17 3v3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 3v3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10 14 2.3 6.3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m14 6 7.7 7.7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m8 6 8 8"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "63_0");
const LuContact2 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 18a4 4 0 0 0-8 0"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "11",
      r: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "18",
      rx: "2",
      width: "18",
      x: "3",
      y: "4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "8",
      x2: "8",
      y1: "2",
      y2: "4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "16",
      x2: "16",
      y1: "2",
      y2: "4"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "4z_0");
const LuContact = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17 18a2 2 0 0 0-2-2H9a2 2 0 0 0-2 2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "18",
      rx: "2",
      width: "18",
      x: "3",
      y: "4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "10",
      r: "2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "8",
      x2: "8",
      y1: "2",
      y2: "4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "16",
      x2: "16",
      y1: "2",
      y2: "4"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "bA_0");
const LuContainer = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M22 7.7c0-.6-.4-1.2-.8-1.5l-6.3-3.9a1.72 1.72 0 0 0-1.7 0l-10.3 6c-.5.2-.9.8-.9 1.4v6.6c0 .5.4 1.2.8 1.5l6.3 3.9a1.72 1.72 0 0 0 1.7 0l10.3-6c.5-.3.9-1 .9-1.5Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10 21.9V14L2.1 9.1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m10 14 11.9-6.9"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14 19.8v-8.1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18 17.5V9.4"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "91_0");
const LuContrast = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 18a6 6 0 0 0 0-12v12z"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "nh_0");
const LuCookie = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 2a10 10 0 1 0 10 10 4 4 0 0 1-5-5 4 4 0 0 1-5-5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8.5 8.5v.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 15.5v.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 12v.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M11 17v.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 14v.01"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "00_0");
const LuCopyCheck = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m12 15 2 2 4-4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "14",
      rx: "2",
      ry: "2",
      width: "14",
      x: "8",
      y: "8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "SY_0");
const LuCopyMinus = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "12",
      x2: "18",
      y1: "15",
      y2: "15"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "14",
      rx: "2",
      ry: "2",
      width: "14",
      x: "8",
      y: "8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "cR_0");
const LuCopyPlus = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "15",
      x2: "15",
      y1: "12",
      y2: "18"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "12",
      x2: "18",
      y1: "15",
      y2: "15"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "14",
      rx: "2",
      ry: "2",
      width: "14",
      x: "8",
      y: "8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "iA_0");
const LuCopySlash = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "12",
      x2: "18",
      y1: "18",
      y2: "12"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "14",
      rx: "2",
      ry: "2",
      width: "14",
      x: "8",
      y: "8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "YW_0");
const LuCopyX = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "12",
      x2: "18",
      y1: "12",
      y2: "18"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "12",
      x2: "18",
      y1: "18",
      y2: "12"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "14",
      rx: "2",
      ry: "2",
      width: "14",
      x: "8",
      y: "8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "w0_0");
const LuCopy = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "14",
      rx: "2",
      ry: "2",
      width: "14",
      x: "8",
      y: "8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "PY_0");
const LuCopyleft = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9.17 14.83a4 4 0 1 0 0-5.66"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Sj_0");
const LuCopyright = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14.83 14.83a4 4 0 1 1 0-5.66"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "fP_0");
const LuCornerDownLeft = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "9 10 4 15 9 20"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M20 4v7a4 4 0 0 1-4 4H4"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "NM_0");
const LuCornerDownRight = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "15 10 20 15 15 20"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 4v7a4 4 0 0 0 4 4h12"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "MI_0");
const LuCornerLeftDown = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "14 15 9 20 4 15"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M20 4h-7a4 4 0 0 0-4 4v12"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "4H_0");
const LuCornerLeftUp = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "14 9 9 4 4 9"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M20 20h-7a4 4 0 0 1-4-4V4"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "iX_0");
const LuCornerRightDown = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "10 15 15 20 20 15"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 4h7a4 4 0 0 1 4 4v12"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "5Q_0");
const LuCornerRightUp = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "10 9 15 4 20 9"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 20h7a4 4 0 0 0 4-4V4"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "AT_0");
const LuCornerUpLeft = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "9 14 4 9 9 4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M20 20v-7a4 4 0 0 0-4-4H4"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Pu_0");
const LuCornerUpRight = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "15 14 20 9 15 4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 20v-7a4 4 0 0 1 4-4h12"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "ir_0");
const LuCpu = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "16",
      rx: "2",
      width: "16",
      x: "4",
      y: "4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "6",
      width: "6",
      x: "9",
      y: "9"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M15 2v2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M15 20v2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 15h2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 9h2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M20 15h2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M20 9h2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 2v2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 20v2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "y8_0");
const LuCreativeCommons = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10 9.3a2.8 2.8 0 0 0-3.5 1 3.1 3.1 0 0 0 0 3.4 2.7 2.7 0 0 0 3.5 1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17 9.3a2.8 2.8 0 0 0-3.5 1 3.1 3.1 0 0 0 0 3.4 2.7 2.7 0 0 0 3.5 1"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "7Z_0");
const LuCreditCard = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "14",
      rx: "2",
      width: "20",
      x: "2",
      y: "5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "2",
      x2: "22",
      y1: "10",
      y2: "10"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "UR_0");
const LuCroissant = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m4.6 13.11 5.79-3.21c1.89-1.05 4.79 1.78 3.71 3.71l-3.22 5.81C8.8 23.16.79 15.23 4.6 13.11Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m10.5 9.5-1-2.29C9.2 6.48 8.8 6 8 6H4.5C2.79 6 2 6.5 2 8.5a7.71 7.71 0 0 0 2 4.83"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 6c0-1.55.24-4-2-4-2 0-2.5 2.17-2.5 4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m14.5 13.5 2.29 1c.73.3 1.21.7 1.21 1.5v3.5c0 1.71-.5 2.5-2.5 2.5a7.71 7.71 0 0 1-4.83-2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18 16c1.55 0 4-.24 4 2 0 2-2.17 2.5-4 2.5"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Mp_0");
const LuCrop = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6 2v14a2 2 0 0 0 2 2h14"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18 22V8a2 2 0 0 0-2-2H2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "IZ_0");
const LuCross = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: /* @__PURE__ */ _jsxQ("path", null, {
    d: "M11 2a2 2 0 0 0-2 2v5H4a2 2 0 0 0-2 2v2c0 1.1.9 2 2 2h5v5c0 1.1.9 2 2 2h2a2 2 0 0 0 2-2v-5h5a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2h-5V4a2 2 0 0 0-2-2h-2z"
  }, null, 3, null)
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "c0_0");
const LuCrosshair = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "22",
      x2: "18",
      y1: "12",
      y2: "12"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "6",
      x2: "2",
      y1: "12",
      y2: "12"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "12",
      x2: "12",
      y1: "6",
      y2: "2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "12",
      x2: "12",
      y1: "22",
      y2: "18"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "tT_0");
const LuCrown = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: /* @__PURE__ */ _jsxQ("path", null, {
    d: "m2 4 3 12h14l3-12-6 7-4-7-4 7-6-7zm3 16h14"
  }, null, 3, null)
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Iy_0");
const LuCuboid = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m21.12 6.4-6.05-4.06a2 2 0 0 0-2.17-.05L2.95 8.41a2 2 0 0 0-.95 1.7v5.82a2 2 0 0 0 .88 1.66l6.05 4.07a2 2 0 0 0 2.17.05l9.95-6.12a2 2 0 0 0 .95-1.7V8.06a2 2 0 0 0-.88-1.66Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10 22v-8L2.25 9.15"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m10 14 11.77-6.87"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Sh_0");
const LuCupSoda = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m6 8 1.75 12.28a2 2 0 0 0 2 1.72h4.54a2 2 0 0 0 2-1.72L18 8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M5 8h14"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 15a6.47 6.47 0 0 1 5 0 6.47 6.47 0 0 0 5 0"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m12 8 1-6h2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "RL_0");
const LuCurrency = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "3",
      x2: "6",
      y1: "3",
      y2: "6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "21",
      x2: "18",
      y1: "3",
      y2: "6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "3",
      x2: "6",
      y1: "21",
      y2: "18"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "21",
      x2: "18",
      y1: "21",
      y2: "18"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "px_0");
const LuCylinder = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("ellipse", null, {
      cx: "12",
      cy: "5",
      rx: "9",
      ry: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 5v14a9 3 0 0 0 18 0V5"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "cu_0");
const LuDatabaseBackup = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("ellipse", null, {
      cx: "12",
      cy: "5",
      rx: "9",
      ry: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 12a9 3 0 0 0 5 2.69"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 9.3V5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 5v14a9 3 0 0 0 6.47 2.88"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 12v4h4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M13 20a5 5 0 0 0 9-3 4.5 4.5 0 0 0-4.5-4.5c-1.33 0-2.54.54-3.41 1.41L12 16"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "8o_0");
const LuDatabaseZap = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("ellipse", null, {
      cx: "12",
      cy: "5",
      rx: "9",
      ry: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 5V19A9 3 0 0 0 15 21.84"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 5V8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 12L18 17H22L19 22"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 12A9 3 0 0 0 14.59 14.87"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "mV_0");
const LuDatabase = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("ellipse", null, {
      cx: "12",
      cy: "5",
      rx: "9",
      ry: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 5V19A9 3 0 0 0 21 19V5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 12A9 3 0 0 0 21 12"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "0K_0");
const LuDelete = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M20 5H9l-7 7 7 7h11a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "18",
      x2: "12",
      y1: "9",
      y2: "15"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "12",
      x2: "18",
      y1: "9",
      y2: "15"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Mf_0");
const LuDessert = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "4",
      r: "2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10.2 3.2C5.5 4 2 8.1 2 13a2 2 0 0 0 4 0v-1a2 2 0 0 1 4 0v4a2 2 0 0 0 4 0v-4a2 2 0 0 1 4 0v1a2 2 0 0 0 4 0c0-4.9-3.5-9-8.2-9.8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3.2 14.8a9 9 0 0 0 17.6 0"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "4T_0");
const LuDiameter = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "19",
      cy: "19",
      r: "2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "5",
      cy: "5",
      r: "2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6.48 3.66a10 10 0 0 1 13.86 13.86"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m6.41 6.41 11.18 11.18"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3.66 6.48a10 10 0 0 0 13.86 13.86"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "oA_0");
const LuDiamond = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: /* @__PURE__ */ _jsxQ("path", null, {
    d: "M2.7 10.3a2.41 2.41 0 0 0 0 3.41l7.59 7.59a2.41 2.41 0 0 0 3.41 0l7.59-7.59a2.41 2.41 0 0 0 0-3.41l-7.59-7.59a2.41 2.41 0 0 0-3.41 0Z"
  }, null, 3, null)
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "08_0");
const LuDice1 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "18",
      rx: "2",
      ry: "2",
      width: "18",
      x: "3",
      y: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 12h.01"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Te_0");
const LuDice2 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "18",
      rx: "2",
      ry: "2",
      width: "18",
      x: "3",
      y: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M15 9h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 15h.01"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "fn_0");
const LuDice3 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "18",
      rx: "2",
      ry: "2",
      width: "18",
      x: "3",
      y: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 8h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 12h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 16h.01"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "pP_0");
const LuDice4 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "18",
      rx: "2",
      ry: "2",
      width: "18",
      x: "3",
      y: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 8h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 8h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 16h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 16h.01"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Ua_0");
const LuDice5 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "18",
      rx: "2",
      ry: "2",
      width: "18",
      x: "3",
      y: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 8h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 8h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 16h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 16h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 12h.01"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "4W_0");
const LuDice6 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "18",
      rx: "2",
      ry: "2",
      width: "18",
      x: "3",
      y: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 8h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 12h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 16h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 8h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 12h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 16h.01"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "9g_0");
const LuDices = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "12",
      rx: "2",
      ry: "2",
      width: "12",
      x: "2",
      y: "10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m17.92 14 3.5-3.5a2.24 2.24 0 0 0 0-3l-5-4.92a2.24 2.24 0 0 0-3 0L10 6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6 18h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10 14h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M15 6h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18 9h.01"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Il_0");
const LuDiff = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 3v14"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M5 10h14"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M5 21h14"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "WS_0");
const LuDisc2 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 12h.01"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "tl_0");
const LuDisc3 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6 12c0-1.7.7-3.2 1.8-4.2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18 12c0 1.7-.7 3.2-1.8 4.2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "q3_0");
const LuDisc = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "6o_0");
const LuDivideCircle = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "8",
      x2: "16",
      y1: "12",
      y2: "12"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "12",
      x2: "12",
      y1: "16",
      y2: "16"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "12",
      x2: "12",
      y1: "8",
      y2: "8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "10"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "aI_0");
const LuDivideSquare = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "18",
      rx: "2",
      ry: "2",
      width: "18",
      x: "3",
      y: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "8",
      x2: "16",
      y1: "12",
      y2: "12"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "12",
      x2: "12",
      y1: "16",
      y2: "16"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "12",
      x2: "12",
      y1: "8",
      y2: "8"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Is_0");
const LuDivide = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "6",
      r: "1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "5",
      x2: "19",
      y1: "12",
      y2: "12"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "18",
      r: "1"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "wc_0");
const LuDnaOff = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M15 2c-1.35 1.5-2.092 3-2.5 4.5M9 22c1.35-1.5 2.092-3 2.5-4.5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 15c3.333-3 6.667-3 10-3m10-3c-1.5 1.35-3 2.092-4.5 2.5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m17 6-2.5-2.5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m14 8-1.5-1.5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m7 18 2.5 2.5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m3.5 14.5.5.5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m20 9 .5.5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m6.5 12.5 1 1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m16.5 10.5 1 1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m10 16 1.5 1.5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "2",
      x2: "22",
      y1: "2",
      y2: "22"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "fp_0");
const LuDna = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 15c6.667-6 13.333 0 20-6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 22c1.798-1.998 2.518-3.995 2.807-5.993"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M15 2c-1.798 1.998-2.518 3.995-2.807 5.993"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m17 6-2.5-2.5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m14 8-1-1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m7 18 2.5 2.5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m3.5 14.5.5.5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m20 9 .5.5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m6.5 12.5 1 1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m16.5 10.5 1 1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m10 16 1.5 1.5"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "GK_0");
const LuDog = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10 5.172C10 3.782 8.423 2.679 6.5 3c-2.823.47-4.113 6.006-4 7 .08.703 1.725 1.722 3.656 1 1.261-.472 1.96-1.45 2.344-2.5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14.267 5.172c0-1.39 1.577-2.493 3.5-2.172 2.823.47 4.113 6.006 4 7-.08.703-1.725 1.722-3.656 1-1.261-.472-1.855-1.45-2.239-2.5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 14v.5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 14v.5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M11.25 16.25h1.5L12 17l-.75-.75Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4.42 11.247A13.152 13.152 0 0 0 4 14.556C4 18.728 7.582 21 12 21s8-2.272 8-6.444c0-1.061-.162-2.2-.493-3.309m-9.243-6.082A8.801 8.801 0 0 1 12 5c.78 0 1.5.108 2.161.306"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "5A_0");
const LuDollarSign = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "12",
      x2: "12",
      y1: "2",
      y2: "22"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "0T_0");
const LuDonut = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M20.5 10a2.5 2.5 0 0 1-2.4-3H18a2.95 2.95 0 0 1-2.6-4.4 10 10 0 1 0 6.3 7.1c-.3.2-.8.3-1.2.3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "3"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "nu_0");
const LuDoorClosed = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18 20V6a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v14"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 20h20"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14 12v.01"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "vM_0");
const LuDoorOpen = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M13 4h3a2 2 0 0 1 2 2v14"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 20h3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M13 20h9"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10 12v.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M13 4.562v16.157a1 1 0 0 1-1.242.97L5 20V5.562a2 2 0 0 1 1.515-1.94l4-1A2 2 0 0 1 13 4.561Z"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "0g_0");
const LuDot = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: /* @__PURE__ */ _jsxQ("circle", null, {
    cx: "12.1",
    cy: "12.1",
    r: "1"
  }, null, 3, null)
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "eE_0");
const LuDownloadCloud = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 12v9"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m8 17 4 4 4-4"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "e6_0");
const LuDownload = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "7 10 12 15 17 10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "12",
      x2: "12",
      y1: "15",
      y2: "3"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "f4_0");
const LuDraftingCompass = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "5",
      r: "2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m3 21 8.02-14.26"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m12.99 6.74 1.93 3.44"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M19 12c-3.87 4-10.13 4-14 0"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m21 21-2.16-3.84"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "KD_0");
const LuDrama = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M 10 11h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M 14 6h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M 18 6h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M 6.5 13.1h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M22 5c0 9-4 12-6 12s-6-3-6-12c0-2 2-3 6-3s6 1 6 3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17.4 9.9c-.8.8-2 .8-2.8 0"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10.1 7.1C9 7.2 7.7 7.7 6 8.6c-3.5 2-4.7 3.9-3.7 5.6 4.5 7.8 9.5 8.4 11.2 7.4.9-.5 1.9-2.1 1.9-4.7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9.1 16.5c.3-1.1 1.4-1.7 2.4-1.4"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "M0_0");
const LuDribbble = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M19.13 5.09C15.22 9.14 10 10.44 2.25 10.94"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21.75 12.84c-6.62-1.41-12.14 1-16.38 6.32"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8.56 2.75c4.37 6 6 9.42 8 17.72"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "S7_0");
const LuDroplet = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: /* @__PURE__ */ _jsxQ("path", null, {
    d: "M12 22a7 7 0 0 0 7-7c0-2-1-3.9-3-5.5s-3.5-4-4-6.5c-.5 2.5-2 4.9-4 6.5C6 11.1 5 13 5 15a7 7 0 0 0 7 7z"
  }, null, 3, null)
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "lM_0");
const LuDroplets = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 16.3c2.2 0 4-1.83 4-4.05 0-1.16-.57-2.26-1.71-3.19S7.29 6.75 7 5.3c-.29 1.45-1.14 2.84-2.29 3.76S3 11.1 3 12.25c0 2.22 1.8 4.05 4 4.05z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12.56 6.6A10.97 10.97 0 0 0 14 3.02c.5 2.5 2 4.9 4 6.5s3 3.5 3 5.5a6.98 6.98 0 0 1-11.91 4.97"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Xa_0");
const LuDrumstick = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M15.45 15.4c-2.13.65-4.3.32-5.7-1.1-2.29-2.27-1.76-6.5 1.17-9.42 2.93-2.93 7.15-3.46 9.43-1.18 1.41 1.41 1.74 3.57 1.1 5.71-1.4-.51-3.26-.02-4.64 1.36-1.38 1.38-1.87 3.23-1.36 4.63z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m11.25 15.6-2.16 2.16a2.5 2.5 0 1 1-4.56 1.73 2.49 2.49 0 0 1-1.41-4.24 2.5 2.5 0 0 1 3.14-.32l2.16-2.16"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "pb_0");
const LuDumbbell = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m6.5 6.5 11 11"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m21 21-1-1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m3 3 1 1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m18 22 4-4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m2 6 4-4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m3 10 7-7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m14 21 7-7"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "31_0");
const LuEarOff = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6 18.5a3.5 3.5 0 1 0 7 0c0-1.57.92-2.52 2.04-3.46"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6 8.5c0-.75.13-1.47.36-2.14"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8.8 3.15A6.5 6.5 0 0 1 19 8.5c0 1.63-.44 2.81-1.09 3.76"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12.5 6A2.5 2.5 0 0 1 15 8.5M10 13a2 2 0 0 0 1.82-1.18"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "2",
      x2: "22",
      y1: "2",
      y2: "22"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "bO_0");
const LuEar = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6 8.5a6.5 6.5 0 1 1 13 0c0 6-6 6-6 10a3.5 3.5 0 1 1-7 0"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M15 8.5a2.5 2.5 0 0 0-5 0v1a2 2 0 1 1 0 4"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Zj_0");
const LuEggFried = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "11.5",
      cy: "12.5",
      r: "3.5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 8c0-3.5 2.5-6 6.5-6 5 0 4.83 3 7.5 5s5 2 5 6c0 4.5-2.5 6.5-7 6.5-2.5 0-2.5 2.5-6 2.5s-7-2-7-5.5c0-3 1.5-3 1.5-5C3.5 10 3 9 3 8Z"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "cx_0");
const LuEggOff = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6.399 6.399C5.362 8.157 4.65 10.189 4.5 12c-.37 4.43 1.27 9.95 7.5 10 3.256-.026 5.259-1.547 6.375-3.625"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M19.532 13.875A14.07 14.07 0 0 0 19.5 12c-.36-4.34-3.95-9.96-7.5-10-1.04.012-2.082.502-3.046 1.297"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "2",
      x2: "22",
      y1: "2",
      y2: "22"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "hm_0");
const LuEgg = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: /* @__PURE__ */ _jsxQ("path", null, {
    d: "M12 22c6.23-.05 7.87-5.57 7.5-10-.36-4.34-3.95-9.96-7.5-10-3.55.04-7.14 5.66-7.5 10-.37 4.43 1.27 9.95 7.5 10z"
  }, null, 3, null)
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "xT_0");
const LuEqualNot = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "5",
      x2: "19",
      y1: "9",
      y2: "9"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "5",
      x2: "19",
      y1: "15",
      y2: "15"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "19",
      x2: "5",
      y1: "5",
      y2: "19"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "WN_0");
const LuEqual = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "5",
      x2: "19",
      y1: "9",
      y2: "9"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "5",
      x2: "19",
      y1: "15",
      y2: "15"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "oD_0");
const LuEraser = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m7 21-4.3-4.3c-1-1-1-2.5 0-3.4l9.6-9.6c1-1 2.5-1 3.4 0l5.6 5.6c1 1 1 2.5 0 3.4L13 21"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M22 21H7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m5 11 9 9"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "TS_0");
const LuEuro = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 10h12"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 14h9"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M19 6a7.7 7.7 0 0 0-5.2-2A7.9 7.9 0 0 0 6 12c0 4.4 3.5 8 7.8 8 2 0 3.8-.8 5.2-2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "cC_0");
const LuExpand = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m21 21-6-6m6 6v-4.8m0 4.8h-4.8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 16.2V21m0 0h4.8M3 21l6-6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 7.8V3m0 0h-4.8M21 3l-6 6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 7.8V3m0 0h4.8M3 3l6 6"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "3f_0");
const LuExternalLink = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "15 3 21 3 21 9"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "10",
      x2: "21",
      y1: "14",
      y2: "3"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Oq_0");
const LuEyeOff = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9.88 9.88a3 3 0 1 0 4.24 4.24"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10.73 5.08A10.43 10.43 0 0 1 12 5c7 0 10 7 10 7a13.16 13.16 0 0 1-1.67 2.68"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6.61 6.61A13.526 13.526 0 0 0 2 12s3 7 10 7a9.74 9.74 0 0 0 5.39-1.61"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "2",
      x2: "22",
      y1: "2",
      y2: "22"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "eh_0");
const LuEye = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "3"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "jA_0");
const LuFacebook = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: /* @__PURE__ */ _jsxQ("path", null, {
    d: "M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"
  }, null, 3, null)
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "bG_0");
const LuFactory = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 20a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8l-7 5V8l-7 5V4a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17 18h1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 18h1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 18h1"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "dt_0");
const LuFan = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10.827 16.379a6.082 6.082 0 0 1-8.618-7.002l5.412 1.45a6.082 6.082 0 0 1 7.002-8.618l-1.45 5.412a6.082 6.082 0 0 1 8.618 7.002l-5.412-1.45a6.082 6.082 0 0 1-7.002 8.618l1.45-5.412Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 12v.01"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "cW_0");
const LuFastForward = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("polygon", null, {
      points: "13 19 22 12 13 5 13 19"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polygon", null, {
      points: "2 19 11 12 2 5 2 19"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "EI_0");
const LuFeather = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M20.24 12.24a6 6 0 0 0-8.49-8.49L5 10.5V19h8.5z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "16",
      x2: "2",
      y1: "8",
      y2: "22"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "17.5",
      x2: "9",
      y1: "15",
      y2: "15"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "O1_0");
const LuFerrisWheel = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 2v4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m6.8 15-3.5 2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m20.7 7-3.5 2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6.8 9 3.3 7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m20.7 17-3.5-2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m9 22 3-8 3 8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 22h8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18 18.7a9 9 0 1 0-12 0"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "jH_0");
const LuFigma = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M5 5.5A3.5 3.5 0 0 1 8.5 2H12v7H8.5A3.5 3.5 0 0 1 5 5.5z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 2h3.5a3.5 3.5 0 1 1 0 7H12V2z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 12.5a3.5 3.5 0 1 1 7 0 3.5 3.5 0 1 1-7 0z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M5 19.5A3.5 3.5 0 0 1 8.5 16H12v3.5a3.5 3.5 0 1 1-7 0z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M5 12.5A3.5 3.5 0 0 1 8.5 9H12v7H8.5A3.5 3.5 0 0 1 5 12.5z"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "4F_0");
const LuFileArchive = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 22V4c0-.5.2-1 .6-1.4C5 2.2 5.5 2 6 2h8.5L20 7.5V20c0 .5-.2 1-.6 1.4-.4.4-.9.6-1.4.6h-2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "14 2 14 8 20 8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "10",
      cy: "20",
      r: "2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10 7V6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10 12v-1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10 18v-2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "0S_0");
const LuFileAudio2 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 22h14a2 2 0 0 0 2-2V7.5L14.5 2H6a2 2 0 0 0-2 2v2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "14 2 14 8 20 8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 17v-3a4 4 0 0 1 8 0v3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "9",
      cy: "17",
      r: "1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "3",
      cy: "17",
      r: "1"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "wP_0");
const LuFileAudio = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17.5 22h.5c.5 0 1-.2 1.4-.6.4-.4.6-.9.6-1.4V7.5L14.5 2H6c-.5 0-1 .2-1.4.6C4.2 3 4 3.5 4 4v3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "14 2 14 8 20 8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10 20v-1a2 2 0 1 1 4 0v1a2 2 0 1 1-4 0Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6 20v-1a2 2 0 1 0-4 0v1a2 2 0 1 0 4 0Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 19v-3a6 6 0 0 1 12 0v3"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "aa_0");
const LuFileAxis3D = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "14 2 14 8 20 8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 10v8h8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m8 18 4-4"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "qm_0");
const LuFileBadge2 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 13a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m14 12.5 1 5.5-3-1-3 1 1-5.5"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "9k_0");
const LuFileBadge = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 7V4a2 2 0 0 1 2-2h8.5L20 7.5V20a2 2 0 0 1-2 2h-6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "14 2 14 8 20 8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M5 17a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 16.5 8 22l-3-1-3 1 1-5.5"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Ye_0");
const LuFileBarChart2 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "14 2 14 8 20 8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 18v-6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 18v-1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 18v-3"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "lr_0");
const LuFileBarChart = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "14 2 14 8 20 8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 18v-4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 18v-2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 18v-6"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "cs_0");
const LuFileBox = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14.5 22H18a2 2 0 0 0 2-2V7.5L14.5 2H6a2 2 0 0 0-2 2v4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "14 2 14 8 20 8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2.97 13.12c-.6.36-.97 1.02-.97 1.74v3.28c0 .72.37 1.38.97 1.74l3 1.83c.63.39 1.43.39 2.06 0l3-1.83c.6-.36.97-1.02.97-1.74v-3.28c0-.72-.37-1.38-.97-1.74l-3-1.83a1.97 1.97 0 0 0-2.06 0l-3 1.83Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m7 17-4.74-2.85"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m7 17 4.74-2.85"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 17v5"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Bv_0");
const LuFileCheck2 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 22h14a2 2 0 0 0 2-2V7.5L14.5 2H6a2 2 0 0 0-2 2v4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "14 2 14 8 20 8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m3 15 2 2 4-4"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "1X_0");
const LuFileCheck = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "14 2 14 8 20 8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m9 15 2 2 4-4"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "jl_0");
const LuFileClock = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 22h2c.5 0 1-.2 1.4-.6.4-.4.6-.9.6-1.4V7.5L14.5 2H6c-.5 0-1 .2-1.4.6C4.2 3 4 3.5 4 4v3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "14 2 14 8 20 8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "8",
      cy: "16",
      r: "6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9.5 17.5 8 16.25V14"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "NQ_0");
const LuFileCode2 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 22h14a2 2 0 0 0 2-2V7.5L14.5 2H6a2 2 0 0 0-2 2v4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "14 2 14 8 20 8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m9 18 3-3-3-3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m5 12-3 3 3 3"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "dy_0");
const LuFileCode = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "14 2 14 8 20 8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m10 13-2 2 2 2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m14 17 2-2-2-2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "f9_0");
const LuFileCog = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "6",
      cy: "13",
      r: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m9.7 14.4-.9-.3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m3.2 11.9-.9-.3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m4.6 16.7.3-.9"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m7.6 16.7-.4-1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m4.8 10.3-.4-1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m2.3 14.6 1-.4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m8.7 11.8 1-.4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m7.4 9.3-.3.9"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14 2v6h6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 5.5V4a2 2 0 0 1 2-2h8.5L20 7.5V20a2 2 0 0 1-2 2H6a2 2 0 0 1-2-1.5"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Kk_0");
const LuFileDiff = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 13V7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 10h6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 17h6"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "94_0");
const LuFileDigit = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "6",
      rx: "2",
      width: "4",
      x: "2",
      y: "12"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14 2v6h6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 22h14a2 2 0 0 0 2-2V7.5L14.5 2H6a2 2 0 0 0-2 2v4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10 12h2v6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10 18h4"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "1j_0");
const LuFileDown = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "14 2 14 8 20 8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 18v-6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m9 15 3 3 3-3"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Es_0");
const LuFileEdit = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 13.5V4a2 2 0 0 1 2-2h8.5L20 7.5V20a2 2 0 0 1-2 2h-5.5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "14 2 14 8 20 8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10.42 12.61a2.1 2.1 0 1 1 2.97 2.97L7.95 21 4 22l.99-3.95 5.43-5.44Z"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "JS_0");
const LuFileHeart = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 6V4a2 2 0 0 1 2-2h8.5L20 7.5V20a2 2 0 0 1-2 2H4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "14 2 14 8 20 8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10.29 10.7a2.43 2.43 0 0 0-2.66-.52c-.29.12-.56.3-.78.53l-.35.34-.35-.34a2.43 2.43 0 0 0-2.65-.53c-.3.12-.56.3-.79.53-.95.94-1 2.53.2 3.74L6.5 18l3.6-3.55c1.2-1.21 1.14-2.8.19-3.74Z"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "7q_0");
const LuFileImage = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "14 2 14 8 20 8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "10",
      cy: "13",
      r: "2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m20 17-1.09-1.09a2 2 0 0 0-2.82 0L10 22"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "V4_0");
const LuFileInput = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 22h14a2 2 0 0 0 2-2V7.5L14.5 2H6a2 2 0 0 0-2 2v4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "14 2 14 8 20 8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 15h10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m9 18 3-3-3-3"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "eD_0");
const LuFileJson2 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 22h14a2 2 0 0 0 2-2V7.5L14.5 2H6a2 2 0 0 0-2 2v4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "14 2 14 8 20 8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 12a1 1 0 0 0-1 1v1a1 1 0 0 1-1 1 1 1 0 0 1 1 1v1a1 1 0 0 0 1 1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 18a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1 1 1 0 0 1-1-1v-1a1 1 0 0 0-1-1"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "wC_0");
const LuFileJson = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "14 2 14 8 20 8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10 12a1 1 0 0 0-1 1v1a1 1 0 0 1-1 1 1 1 0 0 1 1 1v1a1 1 0 0 0 1 1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14 18a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1 1 1 0 0 1-1-1v-1a1 1 0 0 0-1-1"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Mg_0");
const LuFileKey2 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 10V4a2 2 0 0 1 2-2h8.5L20 7.5V20a2 2 0 0 1-2 2H4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "14 2 14 8 20 8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "4",
      cy: "16",
      r: "2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m10 10-4.5 4.5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m9 11 1 1"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "hc_0");
const LuFileKey = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "10",
      cy: "16",
      r: "2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m16 10-4.5 4.5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m15 11 1 1"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Vg_0");
const LuFileLineChart = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "14 2 14 8 20 8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m16 13-3.5 3.5-2-2L8 17"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "6a_0");
const LuFileLock2 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 5V4a2 2 0 0 1 2-2h8.5L20 7.5V20a2 2 0 0 1-2 2H4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "14 2 14 8 20 8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "5",
      rx: "1",
      width: "8",
      x: "2",
      y: "13"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 13v-2a2 2 0 1 0-4 0v2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "BF_0");
const LuFileLock = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "6",
      rx: "1",
      width: "8",
      x: "8",
      y: "12"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M15 12v-2a3 3 0 1 0-6 0v2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "bu_0");
const LuFileMinus2 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 22h14a2 2 0 0 0 2-2V7.5L14.5 2H6a2 2 0 0 0-2 2v4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "14 2 14 8 20 8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 15h6"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "b6_0");
const LuFileMinus = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "14 2 14 8 20 8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "9",
      x2: "15",
      y1: "15",
      y2: "15"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Om_0");
const LuFileOutput = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 22h14a2 2 0 0 0 2-2V7.5L14.5 2H6a2 2 0 0 0-2 2v4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "14 2 14 8 20 8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 15h10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m5 12-3 3 3 3"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Ab_0");
const LuFilePieChart = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 22h2a2 2 0 0 0 2-2V7.5L14.5 2H6a2 2 0 0 0-2 2v3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "14 2 14 8 20 8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4.04 11.71a5.84 5.84 0 1 0 8.2 8.29"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M13.83 16A5.83 5.83 0 0 0 8 10.17V16h5.83Z"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Mq_0");
const LuFilePlus2 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 22h14a2 2 0 0 0 2-2V7.5L14.5 2H6a2 2 0 0 0-2 2v4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "14 2 14 8 20 8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 15h6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6 12v6"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "uD_0");
const LuFilePlus = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "14 2 14 8 20 8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "12",
      x2: "12",
      y1: "18",
      y2: "12"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "9",
      x2: "15",
      y1: "15",
      y2: "15"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "sV_0");
const LuFileQuestion = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10 10.3c.2-.4.5-.8.9-1a2.1 2.1 0 0 1 2.6.4c.3.4.5.8.5 1.3 0 1.3-2 2-2 2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 17h.01"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "bk_0");
const LuFileScan = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M20 10V7.5L14.5 2H6a2 2 0 0 0-2 2v16c0 1.1.9 2 2 2h4.5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "14 2 14 8 20 8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 22a2 2 0 0 1-2-2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M20 22a2 2 0 0 0 2-2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M20 14a2 2 0 0 1 2 2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 14a2 2 0 0 0-2 2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "JQ_0");
const LuFileSearch2 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "14 2 14 8 20 8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "11.5",
      cy: "14.5",
      r: "2.5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M13.25 16.25 15 18"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "OK_0");
const LuFileSearch = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 22h14a2 2 0 0 0 2-2V7.5L14.5 2H6a2 2 0 0 0-2 2v3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "14 2 14 8 20 8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M5 17a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m9 18-1.5-1.5"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "qA_0");
const LuFileSignature = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M20 19.5v.5a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8.5L18 5.5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 18h1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18.42 9.61a2.1 2.1 0 1 1 2.97 2.97L16.95 17 13 18l.99-3.95 4.43-4.44Z"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "h7_0");
const LuFileSpreadsheet = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "14 2 14 8 20 8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 13h2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 17h2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14 13h2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14 17h2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Au_0");
const LuFileStack = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 2v5h5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 6v6.5c0 .8-.7 1.5-1.5 1.5h-7c-.8 0-1.5-.7-1.5-1.5v-9c0-.8.7-1.5 1.5-1.5H17l4 4z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 8v8.8c0 .3.2.6.4.8.2.2.5.4.8.4H15"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 12v8.8c0 .3.2.6.4.8.2.2.5.4.8.4H11"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "st_0");
const LuFileSymlink = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 22h14a2 2 0 0 0 2-2V7.5L14.5 2H6a2 2 0 0 0-2 2v7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "14 2 14 8 20 8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m10 18 3-3-3-3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 18v-1a2 2 0 0 1 2-2h6"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Un_0");
const LuFileTerminal = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "14 2 14 8 20 8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m8 16 2-2-2-2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 18h4"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Tg_0");
const LuFileText = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "14 2 14 8 20 8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "16",
      x2: "8",
      y1: "13",
      y2: "13"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "16",
      x2: "8",
      y1: "17",
      y2: "17"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "10",
      x2: "8",
      y1: "9",
      y2: "9"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "gd_0");
const LuFileType2 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 22h14a2 2 0 0 0 2-2V7.5L14.5 2H6a2 2 0 0 0-2 2v4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "14 2 14 8 20 8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 13v-1h6v1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 18h2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M5 12v6"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Mo_0");
const LuFileType = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "14 2 14 8 20 8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 13v-1h6v1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M11 18h2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 12v6"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "IF_0");
const LuFileUp = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "14 2 14 8 20 8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 12v6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m15 15-3-3-3 3"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Wk_0");
const LuFileVideo2 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 8V4a2 2 0 0 1 2-2h8.5L20 7.5V20a2 2 0 0 1-2 2H4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "14 2 14 8 20 8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m10 15.5 4 2.5v-6l-4 2.5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "6",
      rx: "1",
      width: "8",
      x: "2",
      y: "12"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Mz_0");
const LuFileVideo = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "14 2 14 8 20 8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m10 11 5 3-5 3v-6Z"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "tK_0");
const LuFileVolume2 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "14 2 14 8 20 8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M11.5 13.5c.32.4.5.94.5 1.5s-.18 1.1-.5 1.5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M15 12c.64.8 1 1.87 1 3s-.36 2.2-1 3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 15h.01"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "U3_0");
const LuFileVolume = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 22h14a2 2 0 0 0 2-2V7.5L14.5 2H6a2 2 0 0 0-2 2v3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "14 2 14 8 20 8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m7 10-3 2H2v4h2l3 2v-8Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M11 11c.64.8 1 1.87 1 3s-.36 2.2-1 3"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "3e_0");
const LuFileWarning = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 9v4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 17h.01"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "cV_0");
const LuFileX2 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 22h14a2 2 0 0 0 2-2V7.5L14.5 2H6a2 2 0 0 0-2 2v4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14 2v6h6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m3 12.5 5 5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m8 12.5-5 5"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "gL_0");
const LuFileX = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "14 2 14 8 20 8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "9.5",
      x2: "14.5",
      y1: "12.5",
      y2: "17.5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "14.5",
      x2: "9.5",
      y1: "12.5",
      y2: "17.5"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "fj_0");
const LuFile = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "14 2 14 8 20 8"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "zd_0");
const LuFiles = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M15.5 2H8.6c-.4 0-.8.2-1.1.5-.3.3-.5.7-.5 1.1v12.8c0 .4.2.8.5 1.1.3.3.7.5 1.1.5h9.8c.4 0 .8-.2 1.1-.5.3-.3.5-.7.5-1.1V6.5L15.5 2z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 7.6v12.8c0 .4.2.8.5 1.1.3.3.7.5 1.1.5h9.8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M15 2v5h5"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "FS_0");
const LuFilm = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "18",
      rx: "2",
      width: "18",
      x: "3",
      y: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 3v18"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 7.5h4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 12h18"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 16.5h4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17 3v18"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17 7.5h4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17 16.5h4"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Ww_0");
const LuFilterX = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M13.013 3H2l8 9.46V19l4 2v-8.54l.9-1.055"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m22 3-5 5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m17 3 5 5"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "uz_0");
const LuFilter = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: /* @__PURE__ */ _jsxQ("polygon", null, {
    points: "22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"
  }, null, 3, null)
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "bo_0");
const LuFingerprint = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 12C2 6.5 6.5 2 12 2a10 10 0 0 1 8 4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M5 19.5C5.5 18 6 15 6 12c0-.7.12-1.37.34-2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17.29 21.02c.12-.6.43-2.3.5-3.02"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 10a2 2 0 0 0-2 2c0 1.02-.1 2.51-.26 4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8.65 22c.21-.66.45-1.32.57-2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14 13.12c0 2.38 0 6.38-1 8.88"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 16h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21.8 16c.2-2 .131-5.354 0-6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 6.8a6 6 0 0 1 9 5.2c0 .47 0 1.17-.02 2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "d9_0");
const LuFishOff = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18 12.47v.03m0-.5v.47m-.475 5.056A6.744 6.744 0 0 1 15 18c-3.56 0-7.56-2.53-8.5-6 .348-1.28 1.114-2.433 2.121-3.38m3.444-2.088A8.802 8.802 0 0 1 15 6c3.56 0 6.06 2.54 7 6-.309 1.14-.786 2.177-1.413 3.058"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 10.67C7 8 5.58 5.97 2.73 5.5c-1 1.5-1 5 .23 6.5-1.24 1.5-1.24 5-.23 6.5C5.58 18.03 7 16 7 13.33m7.48-4.372A9.77 9.77 0 0 1 16 6.07m0 11.86a9.77 9.77 0 0 1-1.728-3.618"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m16.01 17.93-.23 1.4A2 2 0 0 1 13.8 21H9.5a5.96 5.96 0 0 0 1.49-3.98M8.53 3h5.27a2 2 0 0 1 1.98 1.67l.23 1.4M2 2l20 20"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "kw_0");
const LuFishSymbol = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: /* @__PURE__ */ _jsxQ("path", null, {
    d: "M2 16s9-15 20-4C11 23 2 8 2 8"
  }, null, 3, null)
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "x6_0");
const LuFish = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6.5 12c.94-3.46 4.94-6 8.5-6 3.56 0 6.06 2.54 7 6-.94 3.47-3.44 6-7 6s-7.56-2.53-8.5-6Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18 12v.5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 17.93a9.77 9.77 0 0 1 0-11.86"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 10.67C7 8 5.58 5.97 2.73 5.5c-1 1.5-1 5 .23 6.5-1.24 1.5-1.24 5-.23 6.5C5.58 18.03 7 16 7 13.33"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10.46 7.26C10.2 5.88 9.17 4.24 8 3h5.8a2 2 0 0 1 1.98 1.67l.23 1.4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m16.01 17.93-.23 1.4A2 2 0 0 1 13.8 21H9.5a5.96 5.96 0 0 0 1.49-3.98"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "2v_0");
const LuFlagOff = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 2c3 0 5 2 8 2s4-1 4-1v11"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 22V4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 15s1-1 4-1 5 2 8 2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "2",
      x2: "22",
      y1: "2",
      y2: "22"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "fJ_0");
const LuFlagTriangleLeft = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: /* @__PURE__ */ _jsxQ("path", null, {
    d: "M17 22V2L7 7l10 5"
  }, null, 3, null)
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "UN_0");
const LuFlagTriangleRight = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: /* @__PURE__ */ _jsxQ("path", null, {
    d: "M7 22V2l10 5-10 5"
  }, null, 3, null)
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "mR_0");
const LuFlag = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "4",
      x2: "4",
      y1: "22",
      y2: "15"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Y0_0");
const LuFlameKindling = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 2c1 3 2.5 3.5 3.5 4.5A5 5 0 0 1 17 10a5 5 0 1 1-10 0c0-.3 0-.6.1-.9a2 2 0 1 0 3.3-2C8 4.5 11 2 12 2Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m5 22 14-4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m5 18 14 4"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "J0_0");
const LuFlame = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: /* @__PURE__ */ _jsxQ("path", null, {
    d: "M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 0 0 2.5 2.5z"
  }, null, 3, null)
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Wb_0");
const LuFlashlightOff = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 16v4a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2V10c0-2-2-2-2-4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 2h11v4c0 2-2 2-2 4v1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "11",
      x2: "18",
      y1: "6",
      y2: "6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "2",
      x2: "22",
      y1: "2",
      y2: "22"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "7N_0");
const LuFlashlight = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18 6c0 2-2 2-2 4v10a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2V10c0-2-2-2-2-4V2h12z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "6",
      x2: "18",
      y1: "6",
      y2: "6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "12",
      x2: "12",
      y1: "12",
      y2: "12"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "km_0");
const LuFlaskConicalOff = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10 10 4.72 20.55a1 1 0 0 0 .9 1.45h12.76a1 1 0 0 0 .9-1.45l-1.272-2.542"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10 2v2.343"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14 2v6.343"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8.5 2h7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 16h9"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "2",
      x2: "22",
      y1: "2",
      y2: "22"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "69_0");
const LuFlaskConical = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10 2v7.527a2 2 0 0 1-.211.896L4.72 20.55a1 1 0 0 0 .9 1.45h12.76a1 1 0 0 0 .9-1.45l-5.069-10.127A2 2 0 0 1 14 9.527V2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8.5 2h7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 16h10"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "U8_0");
const LuFlaskRound = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10 2v7.31"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14 9.3V1.99"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8.5 2h7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14 9.3a6.5 6.5 0 1 1-4 0"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M5.52 16h12.96"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "QA_0");
const LuFlipHorizontal2 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m3 7 5 5-5 5V7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m21 7-5 5 5 5V7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 20v2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 14v2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 8v2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 2v2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "fw_0");
const LuFlipHorizontal = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 3H5a2 2 0 0 0-2 2v14c0 1.1.9 2 2 2h3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 3h3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 20v2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 14v2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 8v2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 2v2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "MJ_0");
const LuFlipVertical2 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m17 3-5 5-5-5h10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m17 21-5-5-5 5h10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 12H2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10 12H8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 12h-2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M22 12h-2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "kv_0");
const LuFlipVertical = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 8V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 16v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 12H2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10 12H8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 12h-2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M22 12h-2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "wc_0");
const LuFlower2 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 5a3 3 0 1 1 3 3m-3-3a3 3 0 1 0-3 3m3-3v1M9 8a3 3 0 1 0 3 3M9 8h1m5 0a3 3 0 1 1-3 3m3-3h-1m-2 3v-1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "8",
      r: "2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 10v12"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 22c4.2 0 7-1.667 7-5-4.2 0-7 1.667-7 5Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 22c-4.2 0-7-1.667-7-5 4.2 0 7 1.667 7 5Z"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "IB_0");
const LuFlower = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 7.5a4.5 4.5 0 1 1 4.5 4.5M12 7.5A4.5 4.5 0 1 0 7.5 12M12 7.5V9m-4.5 3a4.5 4.5 0 1 0 4.5 4.5M7.5 12H9m7.5 0a4.5 4.5 0 1 1-4.5 4.5m4.5-4.5H15m-3 4.5V15"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m8 16 1.5-1.5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14.5 9.5 16 8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m8 8 1.5 1.5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14.5 14.5 16 16"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "dm_0");
const LuFocus = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 7V5a2 2 0 0 1 2-2h2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17 3h2a2 2 0 0 1 2 2v2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 17v2a2 2 0 0 1-2 2h-2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 21H5a2 2 0 0 1-2-2v-2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "fX_0");
const LuFoldHorizontal = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 12h6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M22 12h-6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 2v2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 8v2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 14v2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 20v2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m19 9-3 3 3 3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m5 15 3-3-3-3"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "ka_0");
const LuFoldVertical = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 22v-6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 8V2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 12H2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10 12H8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 12h-2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M22 12h-2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m15 19-3-3-3 3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m15 5-3 3-3-3"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "mY_0");
const LuFolderArchive = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M22 20V8a2 2 0 0 0-2-2h-7.93a2 2 0 0 1-1.66-.9l-.82-1.2A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13c0 1.1.9 2 2 2h6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "16",
      cy: "19",
      r: "2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 11v-1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 17v-2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Ah_0");
const LuFolderCheck = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 20h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.93a2 2 0 0 1-1.66-.9l-.82-1.2A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13c0 1.1.9 2 2 2Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m9 13 2 2 4-4"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "BE_0");
const LuFolderClock = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 20H4a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2h3.93a2 2 0 0 1 1.66.9l.82 1.2a2 2 0 0 0 1.66.9H20a2 2 0 0 1 2 2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "16",
      cy: "16",
      r: "6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 14v2l1 1"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Kj_0");
const LuFolderClosed = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 20h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.93a2 2 0 0 1-1.66-.9l-.82-1.2A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13c0 1.1.9 2 2 2Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 10h20"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "4E_0");
const LuFolderCog = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "18",
      cy: "18",
      r: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10.5 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v3.5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m21.7 19.4-.9-.3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m15.2 16.9-.9-.3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m16.6 21.7.3-.9"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m19.1 15.2.3-.9"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m19.6 21.7-.4-1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m16.8 15.3-.4-1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m14.3 19.6 1-.4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m20.7 16.8 1-.4"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "1L_0");
const LuFolderDot = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 20h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.93a2 2 0 0 1-1.66-.9l-.82-1.2A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13c0 1.1.9 2 2 2Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "13",
      r: "1"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "7N_0");
const LuFolderDown = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 20h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.93a2 2 0 0 1-1.66-.9l-.82-1.2A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13c0 1.1.9 2 2 2Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 10v6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m15 13-3 3-3-3"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "fK_0");
const LuFolderEdit = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8.42 10.61a2.1 2.1 0 1 1 2.97 2.97L5.95 19 2 20l.99-3.95 5.43-5.44Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 11.5V5c0-1.1.9-2 2-2h3.93a2 2 0 0 1 1.66.9l.82 1.2a2 2 0 0 0 1.66.9H20a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-9.5"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "DL_0");
const LuFolderGit2 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "13",
      cy: "12",
      r: "2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18 19c-2.8 0-5-2.2-5-5v8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "20",
      cy: "19",
      r: "2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "z3_0");
const LuFolderGit = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 20h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.93a2 2 0 0 1-1.66-.9l-.82-1.2A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13c0 1.1.9 2 2 2Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "13",
      r: "2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14 13h3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 13h3"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "JH_0");
const LuFolderHeart = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M11 20H4a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2h3.93a2 2 0 0 1 1.66.9l.82 1.2a2 2 0 0 0 1.66.9H20a2 2 0 0 1 2 2v1.5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21.29 13.7a2.43 2.43 0 0 0-2.65-.52c-.3.12-.57.3-.8.53l-.34.34-.35-.34a2.43 2.43 0 0 0-2.65-.53c-.3.12-.56.3-.79.53-.95.94-1 2.53.2 3.74L17.5 21l3.6-3.55c1.2-1.21 1.14-2.8.19-3.74Z"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Gr_0");
const LuFolderInput = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 9V5c0-1.1.9-2 2-2h3.93a2 2 0 0 1 1.66.9l.82 1.2a2 2 0 0 0 1.66.9H20a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 13h10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m9 16 3-3-3-3"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "vH_0");
const LuFolderKanban = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 20h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.93a2 2 0 0 1-1.66-.9l-.82-1.2A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13c0 1.1.9 2 2 2Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 10v4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 10v2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 10v6"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "5B_0");
const LuFolderKey = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10 20H4a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2h3.93a2 2 0 0 1 1.66.9l.82 1.2a2 2 0 0 0 1.66.9H20a2 2 0 0 1 2 2v2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "16",
      cy: "20",
      r: "2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m22 14-4.5 4.5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m21 15 1 1"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "8d_0");
const LuFolderLock = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10 20H4a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2h3.93a2 2 0 0 1 1.66.9l.82 1.2a2 2 0 0 0 1.66.9H20a2 2 0 0 1 2 2v2.5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "5",
      rx: "1",
      width: "8",
      x: "14",
      y: "17"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M20 17v-2a2 2 0 1 0-4 0v2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "V9_0");
const LuFolderMinus = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 20h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.93a2 2 0 0 1-1.66-.9l-.82-1.2A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13c0 1.1.9 2 2 2Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "9",
      x2: "15",
      y1: "13",
      y2: "13"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "pD_0");
const LuFolderOpenDot = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m6 14 1.45-2.9A2 2 0 0 1 9.24 10H20a2 2 0 0 1 1.94 2.5l-1.55 6a2 2 0 0 1-1.94 1.5H4a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2h3.93a2 2 0 0 1 1.66.9l.82 1.2a2 2 0 0 0 1.66.9H18a2 2 0 0 1 2 2v2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "14",
      cy: "15",
      r: "1"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "VT_0");
const LuFolderOpen = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: /* @__PURE__ */ _jsxQ("path", null, {
    d: "m6 14 1.45-2.9A2 2 0 0 1 9.24 10H20a2 2 0 0 1 1.94 2.5l-1.55 6a2 2 0 0 1-1.94 1.5H4a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2h3.93a2 2 0 0 1 1.66.9l.82 1.2a2 2 0 0 0 1.66.9H18a2 2 0 0 1 2 2v2"
  }, null, 3, null)
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "dL_0");
const LuFolderOutput = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 7.5V5c0-1.1.9-2 2-2h3.93a2 2 0 0 1 1.66.9l.82 1.2a2 2 0 0 0 1.66.9H20a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 13h10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m5 10-3 3 3 3"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Px_0");
const LuFolderPlus = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 20h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.93a2 2 0 0 1-1.66-.9l-.82-1.2A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13c0 1.1.9 2 2 2Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "12",
      x2: "12",
      y1: "10",
      y2: "16"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "9",
      x2: "15",
      y1: "13",
      y2: "13"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "05_0");
const LuFolderRoot = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 20h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.93a2 2 0 0 1-1.66-.9l-.82-1.2A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13c0 1.1.9 2 2 2Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "13",
      r: "2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 15v5"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "GT_0");
const LuFolderSearch2 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 20h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.93a2 2 0 0 1-1.66-.9l-.82-1.2A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13c0 1.1.9 2 2 2Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "11.5",
      cy: "12.5",
      r: "2.5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M13.27 14.27 15 16"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "mK_0");
const LuFolderSearch = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M11 20H4a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2h3.93a2 2 0 0 1 1.66.9l.82 1.2a2 2 0 0 0 1.66.9H20a2 2 0 0 1 2 2v4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "17",
      cy: "17",
      r: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m21 21-1.5-1.5"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Lq_0");
const LuFolderSymlink = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 9V5c0-1.1.9-2 2-2h3.93a2 2 0 0 1 1.66.9l.82 1.2a2 2 0 0 0 1.66.9H20a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m8 16 3-3-3-3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 16v-1a2 2 0 0 1 2-2h6"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "lD_0");
const LuFolderSync = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 10v4h4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m12 14 1.5-1.5c.9-.9 2.2-1.5 3.5-1.5s2.6.6 3.5 1.5c.4.4.8 1 1 1.5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M22 22v-4h-4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m22 18-1.5 1.5c-.9.9-2.1 1.5-3.5 1.5s-2.6-.6-3.5-1.5c-.4-.4-.8-1-1-1.5"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "ZI_0");
const LuFolderTree = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M13 10h7a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1h-2.5a1 1 0 0 1-.8-.4l-.9-1.2A1 1 0 0 0 15 3h-2a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M13 21h7a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1h-2.88a1 1 0 0 1-.9-.55l-.44-.9a1 1 0 0 0-.9-.55H13a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 3v2c0 1.1.9 2 2 2h3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 3v13c0 1.1.9 2 2 2h3"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Sp_0");
const LuFolderUp = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 20h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.93a2 2 0 0 1-1.66-.9l-.82-1.2A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13c0 1.1.9 2 2 2Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 10v6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m9 13 3-3 3 3"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "ED_0");
const LuFolderX = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 20h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.93a2 2 0 0 1-1.66-.9l-.82-1.2A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13c0 1.1.9 2 2 2Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m9.5 10.5 5 5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m14.5 10.5-5 5"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "J0_0");
const LuFolder = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: /* @__PURE__ */ _jsxQ("path", null, {
    d: "M4 20h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.93a2 2 0 0 1-1.66-.9l-.82-1.2A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13c0 1.1.9 2 2 2Z"
  }, null, 3, null)
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Bq_0");
const LuFolders = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 17h12a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3.93a2 2 0 0 1-1.66-.9l-.82-1.2a2 2 0 0 0-1.66-.9H8a2 2 0 0 0-2 2v9c0 1.1.9 2 2 2Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 8v11c0 1.1.9 2 2 2h14"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "rq_0");
const LuFootprints = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 16v-2.38C4 11.5 2.97 10.5 3 8c.03-2.72 1.49-6 4.5-6C9.37 2 10 3.8 10 5.5c0 3.11-2 5.66-2 8.68V16a2 2 0 1 1-4 0Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M20 20v-2.38c0-2.12 1.03-3.12 1-5.62-.03-2.72-1.49-6-4.5-6C14.63 6 14 7.8 14 9.5c0 3.11 2 5.66 2 8.68V20a2 2 0 1 0 4 0Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 17h4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 13h4"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Jf_0");
const LuForklift = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 12H5a2 2 0 0 0-2 2v5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "13",
      cy: "19",
      r: "2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "5",
      cy: "19",
      r: "2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 19h3m5-17v17h6M6 12V7c0-1.1.9-2 2-2h3l5 5"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "rL_0");
const LuFormInput = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "12",
      rx: "2",
      width: "20",
      x: "2",
      y: "6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 12h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17 12h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 12h.01"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "30_0");
const LuForward = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "15 17 20 12 15 7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 18v-2a4 4 0 0 1 4-4h12"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "rZ_0");
const LuFrame = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "22",
      x2: "2",
      y1: "6",
      y2: "6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "22",
      x2: "2",
      y1: "18",
      y2: "18"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "6",
      x2: "6",
      y1: "2",
      y2: "22"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "18",
      x2: "18",
      y1: "2",
      y2: "22"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "w4_0");
const LuFramer = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: /* @__PURE__ */ _jsxQ("path", null, {
    d: "M5 16V9h14V2H5l14 14h-7m-7 0 7 7v-7m-7 0h7"
  }, null, 3, null)
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "5M_0");
const LuFrown = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 16s-1.5-2-4-2-4 2-4 2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "9",
      x2: "9.01",
      y1: "9",
      y2: "9"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "15",
      x2: "15.01",
      y1: "9",
      y2: "9"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "ig_0");
const LuFuel = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "3",
      x2: "15",
      y1: "22",
      y2: "22"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "4",
      x2: "14",
      y1: "9",
      y2: "9"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14 22V4a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v18"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14 13h2a2 2 0 0 1 2 2v2a2 2 0 0 0 2 2h0a2 2 0 0 0 2-2V9.83a2 2 0 0 0-.59-1.42L18 5"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "6P_0");
const LuFullscreen = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 7V5a2 2 0 0 1 2-2h2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17 3h2a2 2 0 0 1 2 2v2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 17v2a2 2 0 0 1-2 2h-2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 21H5a2 2 0 0 1-2-2v-2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "8",
      rx: "1",
      width: "10",
      x: "7",
      y: "8"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "3M_0");
const LuFunctionSquare = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "18",
      rx: "2",
      ry: "2",
      width: "18",
      x: "3",
      y: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 17c2 0 2.8-1 2.8-2.8V10c0-2 1-3.3 3.2-3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 11.2h5.7"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "3i_0");
const LuGalleryHorizontalEnd = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 7v10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6 5v14"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "18",
      rx: "2",
      width: "12",
      x: "10",
      y: "3"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "MK_0");
const LuGalleryHorizontal = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 3v18"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "18",
      rx: "2",
      width: "12",
      x: "6",
      y: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M22 3v18"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "NH_0");
const LuGalleryThumbnails = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "14",
      rx: "2",
      width: "18",
      x: "3",
      y: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 21h1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 21h1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14 21h1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M19 21h1"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "1h_0");
const LuGalleryVerticalEnd = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 2h10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M5 6h14"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "12",
      rx: "2",
      width: "18",
      x: "3",
      y: "10"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "D2_0");
const LuGalleryVertical = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 2h18"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "12",
      rx: "2",
      width: "18",
      x: "3",
      y: "6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 22h18"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Bl_0");
const LuGamepad2 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "6",
      x2: "10",
      y1: "11",
      y2: "11"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "8",
      x2: "8",
      y1: "9",
      y2: "13"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "15",
      x2: "15.01",
      y1: "12",
      y2: "12"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "18",
      x2: "18.01",
      y1: "10",
      y2: "10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17.32 5H6.68a4 4 0 0 0-3.978 3.59c-.006.052-.01.101-.017.152C2.604 9.416 2 14.456 2 16a3 3 0 0 0 3 3c1 0 1.5-.5 2-1l1.414-1.414A2 2 0 0 1 9.828 16h4.344a2 2 0 0 1 1.414.586L17 18c.5.5 1 1 2 1a3 3 0 0 0 3-3c0-1.545-.604-6.584-.685-7.258-.007-.05-.011-.1-.017-.151A4 4 0 0 0 17.32 5z"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "1y_0");
const LuGamepad = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "6",
      x2: "10",
      y1: "12",
      y2: "12"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "8",
      x2: "8",
      y1: "10",
      y2: "14"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "15",
      x2: "15.01",
      y1: "13",
      y2: "13"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "18",
      x2: "18.01",
      y1: "11",
      y2: "11"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "12",
      rx: "2",
      width: "20",
      x: "2",
      y: "6"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "ZE_0");
const LuGanttChartSquare = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "18",
      rx: "2",
      width: "18",
      x: "3",
      y: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 8h7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 12h6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M11 16h5"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Nv_0");
const LuGanttChart = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 6h10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6 12h9"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M11 18h7"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "it_0");
const LuGaugeCircle = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M15.6 2.7a10 10 0 1 0 5.7 5.7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M13.4 10.6 19 5"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "pz_0");
const LuGauge = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m12 14 4-4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3.34 19a10 10 0 1 1 17.32 0"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "uu_0");
const LuGavel = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m14 13-7.5 7.5c-.83.83-2.17.83-3 0 0 0 0 0 0 0a2.12 2.12 0 0 1 0-3L11 10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m16 16 6-6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m8 8 6-6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m9 7 8 8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m21 11-8-8"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "l3_0");
const LuGem = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6 3h12l4 6-10 13L2 9Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M11 3 8 9l4 13 4-13-3-6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 9h20"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "4U_0");
const LuGhost = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 10h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M15 10h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 2a8 8 0 0 0-8 8v12l3-3 2.5 2.5L12 19l2.5 2.5L17 19l3 3V10a8 8 0 0 0-8-8z"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "WM_0");
const LuGift = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "4",
      rx: "1",
      width: "18",
      x: "3",
      y: "8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 8v13"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7.5 8a2.5 2.5 0 0 1 0-5A4.8 8 0 0 1 12 8a4.8 8 0 0 1 4.5-5 2.5 2.5 0 0 1 0 5"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "8k_0");
const LuGitBranchPlus = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6 3v12"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18 9a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6 21a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M15 6a9 9 0 0 0-9 9"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18 15v6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 18h-6"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Gc_0");
const LuGitBranch = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "6",
      x2: "6",
      y1: "3",
      y2: "15"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "18",
      cy: "6",
      r: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "6",
      cy: "18",
      r: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18 9a9 9 0 0 1-9 9"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "7N_0");
const LuGitCommit = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "3",
      x2: "9",
      y1: "12",
      y2: "12"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "15",
      x2: "21",
      y1: "12",
      y2: "12"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "PP_0");
const LuGitCompare = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "18",
      cy: "18",
      r: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "6",
      cy: "6",
      r: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M13 6h3a2 2 0 0 1 2 2v7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M11 18H8a2 2 0 0 1-2-2V9"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "5s_0");
const LuGitFork = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "18",
      r: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "6",
      cy: "6",
      r: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "18",
      cy: "6",
      r: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18 9v1a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V9"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 12v3"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "YX_0");
const LuGitMerge = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "18",
      cy: "18",
      r: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "6",
      cy: "6",
      r: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6 21V9a9 9 0 0 0 9 9"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "aS_0");
const LuGitPullRequestClosed = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "18",
      cy: "18",
      r: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "6",
      cy: "6",
      r: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18 11.5V15"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m21 3-6 6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m21 9-6-6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "6",
      x2: "6",
      y1: "9",
      y2: "21"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "wz_0");
const LuGitPullRequestDraft = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "18",
      cy: "18",
      r: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "6",
      cy: "6",
      r: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18 6V5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18 11v-1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "6",
      x2: "6",
      y1: "9",
      y2: "21"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "bf_0");
const LuGitPullRequest = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "18",
      cy: "18",
      r: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "6",
      cy: "6",
      r: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M13 6h3a2 2 0 0 1 2 2v7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "6",
      x2: "6",
      y1: "9",
      y2: "21"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "0o_0");
const LuGithub = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M15 22v-4a4.8 4.8 0 0 0-1-3.5c3 0 6-2 6-5.5.08-1.25-.27-2.48-1-3.5.28-1.15.28-2.35 0-3.5 0 0-1 0-3 1.5-2.64-.5-5.36-.5-8 0C6 2 5 2 5 2c-.3 1.15-.3 2.35 0 3.5A5.403 5.403 0 0 0 4 9c0 3.5 3 5.5 6 5.5-.39.49-.68 1.05-.85 1.65-.17.6-.22 1.23-.15 1.85v4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 18c-4.51 2-5-2-7-2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "aj_0");
const LuGitlab = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: /* @__PURE__ */ _jsxQ("path", null, {
    d: "m22 13.29-3.33-10a.42.42 0 0 0-.14-.18.38.38 0 0 0-.22-.11.39.39 0 0 0-.23.07.42.42 0 0 0-.14.18l-2.26 6.67H8.32L6.1 3.26a.42.42 0 0 0-.1-.18.38.38 0 0 0-.26-.08.39.39 0 0 0-.23.07.42.42 0 0 0-.14.18L2 13.29a.74.74 0 0 0 .27.83L12 21l9.69-6.88a.71.71 0 0 0 .31-.83Z"
  }, null, 3, null)
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Am_0");
const LuGlassWater = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M15.2 22H8.8a2 2 0 0 1-2-1.79L5 3h14l-1.81 17.21A2 2 0 0 1 15.2 22Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6 12a5 5 0 0 1 6 0 5 5 0 0 0 6 0"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "FM_0");
const LuGlasses = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "6",
      cy: "15",
      r: "4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "18",
      cy: "15",
      r: "4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14 15a2 2 0 0 0-2-2 2 2 0 0 0-2 2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2.5 13 5 7c.7-1.3 1.4-2 3-2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21.5 13 19 7c-.7-1.3-1.5-2-3-2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "di_0");
const LuGlobe2 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21.54 15H17a2 2 0 0 0-2 2v4.54"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 3.34V5a3 3 0 0 0 3 3v0a2 2 0 0 1 2 2v0c0 1.1.9 2 2 2v0a2 2 0 0 0 2-2v0c0-1.1.9-2 2-2h3.17"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M11 21.95V18a2 2 0 0 0-2-2v0a2 2 0 0 1-2-2v-1a2 2 0 0 0-2-2H2.05"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "10"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "CT_0");
const LuGlobe = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 12h20"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "7Y_0");
const LuGoal = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 13V2l8 4-8 4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M20.55 10.23A9 9 0 1 1 8 4.94"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 10a5 5 0 1 0 8.9 2.02"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "3a_0");
const LuGrab = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18 11.5V9a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v1.4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14 10V8a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10 9.9V9a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6 14v0a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v0"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18 11v0a2 2 0 1 1 4 0v3a8 8 0 0 1-8 8h-4a8 8 0 0 1-8-8 2 2 0 1 1 4 0"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "dw_0");
const LuGraduationCap = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M22 10v6M2 10l10-5 10 5-10 5z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6 12v5c3 3 9 3 12 0v-5"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Df_0");
const LuGrape = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M22 5V2l-5.89 5.89"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "16.6",
      cy: "15.89",
      r: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "8.11",
      cy: "7.4",
      r: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12.35",
      cy: "11.65",
      r: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "13.91",
      cy: "5.85",
      r: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "18.15",
      cy: "10.09",
      r: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "6.56",
      cy: "13.2",
      r: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "10.8",
      cy: "17.44",
      r: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "5",
      cy: "19",
      r: "3"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "4j_0");
const LuGrid2X2 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "18",
      rx: "2",
      width: "18",
      x: "3",
      y: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 12h18"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 3v18"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "UN_0");
const LuGrid3X3 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "18",
      rx: "2",
      width: "18",
      x: "3",
      y: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 9h18"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 15h18"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 3v18"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M15 3v18"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Ms_0");
const LuGripHorizontal = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "9",
      r: "1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "19",
      cy: "9",
      r: "1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "5",
      cy: "9",
      r: "1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "15",
      r: "1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "19",
      cy: "15",
      r: "1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "5",
      cy: "15",
      r: "1"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Sl_0");
const LuGripVertical = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "9",
      cy: "12",
      r: "1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "9",
      cy: "5",
      r: "1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "9",
      cy: "19",
      r: "1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "15",
      cy: "12",
      r: "1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "15",
      cy: "5",
      r: "1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "15",
      cy: "19",
      r: "1"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "gl_0");
const LuGrip = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "5",
      r: "1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "19",
      cy: "5",
      r: "1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "5",
      cy: "5",
      r: "1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "19",
      cy: "12",
      r: "1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "5",
      cy: "12",
      r: "1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "19",
      r: "1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "19",
      cy: "19",
      r: "1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "5",
      cy: "19",
      r: "1"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "mR_0");
const LuGroup = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 7V5c0-1.1.9-2 2-2h2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17 3h2c1.1 0 2 .9 2 2v2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 17v2c0 1.1-.9 2-2 2h-2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 21H5c-1.1 0-2-.9-2-2v-2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "5",
      rx: "1",
      width: "7",
      x: "7",
      y: "7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "5",
      rx: "1",
      width: "7",
      x: "10",
      y: "12"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "w9_0");
const LuHammer = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m15 12-8.5 8.5c-.83.83-2.17.83-3 0 0 0 0 0 0 0a2.12 2.12 0 0 1 0-3L12 9"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17.64 15 22 10.64"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m20.91 11.7-1.25-1.25c-.6-.6-.93-1.4-.93-2.25v-.86L16.01 4.6a5.56 5.56 0 0 0-3.94-1.64H9l.92.82A6.18 6.18 0 0 1 12 8.4v1.56l2 2h2.47l2.26 1.91"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "rY_0");
const LuHandMetal = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18 12.5V10a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v1.4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14 11V9a2 2 0 1 0-4 0v2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10 10.5V5a2 2 0 1 0-4 0v9"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m7 15-1.76-1.76a2 2 0 0 0-2.83 2.82l3.6 3.6C7.5 21.14 9.2 22 12 22h2a8 8 0 0 0 8-8V7a2 2 0 1 0-4 0v5"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Z4_0");
const LuHand = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18 11V6a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v0"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14 10V4a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10 10.5V6a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18 8a2 2 0 1 1 4 0v6a8 8 0 0 1-8 8h-2c-2.8 0-4.5-.86-5.99-2.34l-3.6-3.6a2 2 0 0 1 2.83-2.82L7 15"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "3n_0");
const LuHardDriveDownload = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 2v8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m16 6-4 4-4-4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "8",
      rx: "2",
      width: "20",
      x: "2",
      y: "14"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6 18h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10 18h.01"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "RN_0");
const LuHardDriveUpload = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m16 6-4-4-4 4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 2v8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "8",
      rx: "2",
      width: "20",
      x: "2",
      y: "14"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6 18h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10 18h.01"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Zv_0");
const LuHardDrive = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "22",
      x2: "2",
      y1: "12",
      y2: "12"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "6",
      x2: "6.01",
      y1: "16",
      y2: "16"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "10",
      x2: "10.01",
      y1: "16",
      y2: "16"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "9z_0");
const LuHardHat = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 18a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v2z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10 10V5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 15v-3a6 6 0 0 1 6-6h0"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14 6h0a6 6 0 0 1 6 6v3"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "98_0");
const LuHash = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "4",
      x2: "20",
      y1: "9",
      y2: "9"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "4",
      x2: "20",
      y1: "15",
      y2: "15"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "10",
      x2: "8",
      y1: "3",
      y2: "21"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "16",
      x2: "14",
      y1: "3",
      y2: "21"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Ur_0");
const LuHaze = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m5.2 6.2 1.4 1.4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 13h2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M20 13h2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m17.4 7.6 1.4-1.4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M22 17H2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M22 21H2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 13a4 4 0 0 0-8 0"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 5V2.5"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Uu_0");
const LuHdmiPort = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M22 9a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h1l2 2h12l2-2h1a1 1 0 0 0 1-1Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7.5 12h9"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "b2_0");
const LuHeading1 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 12h8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 18V6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 18V6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m17 12 3-2v8"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "H0_0");
const LuHeading2 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 12h8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 18V6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 18V6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 18h-4c0-4 4-3 4-6 0-1.5-2-2.5-4-1"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "r4_0");
const LuHeading3 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 12h8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 18V6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 18V6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17.5 10.5c1.7-1 3.5 0 3.5 1.5a2 2 0 0 1-2 2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17 17.5c2 1.5 4 .3 4-1.5a2 2 0 0 0-2-2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Xp_0");
const LuHeading4 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 12h8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 18V6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 18V6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17 10v4h4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 10v8"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "0Z_0");
const LuHeading5 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 12h8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 18V6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 18V6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17 13v-3h4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17 17.7c.4.2.8.3 1.3.3 1.5 0 2.7-1.1 2.7-2.5S19.8 13 18.3 13H17"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "4N_0");
const LuHeading6 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 12h8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 18V6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 18V6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "19",
      cy: "16",
      r: "2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M20 10c-2 2-3 3.5-3 6"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "uK_0");
const LuHeading = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6 12h12"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6 20V4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18 20V4"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "8M_0");
const LuHeadphones = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: /* @__PURE__ */ _jsxQ("path", null, {
    d: "M3 14h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-7a9 9 0 0 1 18 0v7a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3"
  }, null, 3, null)
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "GA_0");
const LuHeartCrack = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m12 13-1-1 2-2-3-3 2-2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "am_0");
const LuHeartHandshake = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 5 9.04 7.96a2.17 2.17 0 0 0 0 3.08v0c.82.82 2.13.85 3 .07l2.07-1.9a2.82 2.82 0 0 1 3.79 0l2.96 2.66"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m18 15-2-2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m15 18-2-2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "0q_0");
const LuHeartOff = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "2",
      x2: "22",
      y1: "2",
      y2: "22"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16.5 16.5 12 21l-7-7c-1.5-1.45-3-3.2-3-5.5a5.5 5.5 0 0 1 2.14-4.35"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8.76 3.1c1.15.22 2.13.78 3.24 1.9 1.5-1.5 2.74-2 4.5-2A5.5 5.5 0 0 1 22 8.5c0 2.12-1.3 3.78-2.67 5.17"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "P4_0");
const LuHeartPulse = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3.22 12H9.5l.5-1 2 4.5 2-7 1.5 3.5h5.27"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "tk_0");
const LuHeart = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: /* @__PURE__ */ _jsxQ("path", null, {
    d: "M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"
  }, null, 3, null)
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "z9_0");
const LuHelpCircle = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 17h.01"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "TH_0");
const LuHelpingHand = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m3 15 5.12-5.12A3 3 0 0 1 10.24 9H13a2 2 0 1 1 0 4h-2.5m4-.68 4.17-4.89a1.88 1.88 0 0 1 2.92 2.36l-4.2 5.94A3 3 0 0 1 14.96 17H9.83a2 2 0 0 0-1.42.59L7 19"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m2 14 6 6"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "52_0");
const LuHexagon = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: /* @__PURE__ */ _jsxQ("path", null, {
    d: "M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"
  }, null, 3, null)
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Iq_0");
const LuHighlighter = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m9 11-6 6v3h9l3-3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m22 12-4.6 4.6a2 2 0 0 1-2.8 0l-5.2-5.2a2 2 0 0 1 0-2.8L14 4"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "O2_0");
const LuHistory = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 3v5h5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 7v5l4 2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "1w_0");
const LuHome = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "9 22 9 12 15 12 15 22"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "pt_0");
const LuHopOff = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17.5 5.5C19 7 20.5 9 21 11c-1.323.265-2.646.39-4.118.226"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M5.5 17.5C7 19 9 20.5 11 21c.5-2.5.5-5-1-8.5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17.5 17.5c-2.5 0-4 0-6-1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M20 11.5c1 1.5 2 3.5 2 4.5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M11.5 20c1.5 1 3.5 2 4.5 2 .5-1.5 0-3-.5-4.5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M22 22c-2 0-3.5-.5-5.5-1.5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4.783 4.782C1.073 8.492 1 14.5 5 18c1-1 2-4.5 1.5-6.5 1.5 1 4 1 5.5.5M8.227 2.57C11.578 1.335 15.453 2.089 18 5c-.88.88-3.7 1.761-5.726 1.618"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "2",
      x2: "22",
      y1: "2",
      y2: "22"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Ye_0");
const LuHop = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17.5 5.5C19 7 20.5 9 21 11c-2.5.5-5 .5-8.5-1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M5.5 17.5C7 19 9 20.5 11 21c.5-2.5.5-5-1-8.5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16.5 11.5c1 2 1 3.5 1 6-2.5 0-4 0-6-1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M20 11.5c1 1.5 2 3.5 2 4.5-1.5.5-3 0-4.5-.5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M11.5 20c1.5 1 3.5 2 4.5 2 .5-1.5 0-3-.5-4.5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M20.5 16.5c1 2 1.5 3.5 1.5 5.5-2 0-3.5-.5-5.5-1.5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4.783 4.782C8.493 1.072 14.5 1 18 5c-1 1-4.5 2-6.5 1.5 1 1.5 1 4 .5 5.5-1.5.5-4 .5-5.5-.5C7 13.5 6 17 5 18c-4-3.5-3.927-9.508-.217-13.218Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4.5 4.5 3 3c-.184-.185-.184-.816 0-1"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "4o_0");
const LuHotel = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m9 16 .348-.24c1.465-1.013 3.84-1.013 5.304 0L15 16"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 7h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 7h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 7h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 11h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 11h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 11h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10 22v-6.5m4 0V22"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Ub_0");
const LuHourglass = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M5 22h14"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M5 2h14"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17 22v-4.172a2 2 0 0 0-.586-1.414L12 12l-4.414 4.414A2 2 0 0 0 7 17.828V22"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 2v4.172a2 2 0 0 0 .586 1.414L12 12l4.414-4.414A2 2 0 0 0 17 6.172V2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "ku_0");
const LuIceCream2 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 17c5 0 8-2.69 8-6H4c0 3.31 3 6 8 6Zm-4 4h8m-4-3v3M5.14 11a3.5 3.5 0 1 1 6.71 0"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12.14 11a3.5 3.5 0 1 1 6.71 0"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M15.5 6.5a3.5 3.5 0 1 0-7 0"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "hW_0");
const LuIceCream = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m7 11 4.08 10.35a1 1 0 0 0 1.84 0L17 11"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17 7A5 5 0 0 0 7 7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17 7a2 2 0 0 1 0 4H7a2 2 0 0 1 0-4"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "LM_0");
const LuImageDown = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "9",
      cy: "9",
      r: "2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10.3 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10.8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m21 15-3.1-3.1a2 2 0 0 0-2.814.014L6 21"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m14 19.5 3 3v-6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m17 22.5 3-3"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "x0_0");
const LuImageMinus = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 9v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "16",
      x2: "22",
      y1: "5",
      y2: "5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "9",
      cy: "9",
      r: "2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "xC_0");
const LuImageOff = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "2",
      x2: "22",
      y1: "2",
      y2: "22"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10.41 10.41a2 2 0 1 1-2.83-2.83"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "13.5",
      x2: "6",
      y1: "13.5",
      y2: "21"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "18",
      x2: "21",
      y1: "12",
      y2: "15"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3.59 3.59A1.99 1.99 0 0 0 3 5v14a2 2 0 0 0 2 2h14c.55 0 1.052-.22 1.41-.59"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 15V5a2 2 0 0 0-2-2H9"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "A1_0");
const LuImagePlus = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "16",
      x2: "22",
      y1: "5",
      y2: "5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "19",
      x2: "19",
      y1: "2",
      y2: "8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "9",
      cy: "9",
      r: "2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Fh_0");
const LuImage = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "18",
      rx: "2",
      ry: "2",
      width: "18",
      x: "3",
      y: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "9",
      cy: "9",
      r: "2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "R4_0");
const LuImport = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 3v12"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m8 11 4 4 4-4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 5H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-4"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "a3_0");
const LuInbox = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "22 12 16 12 14 15 10 15 8 12 2 12"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "6L_0");
const LuIndent = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "3 8 7 12 3 16"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "21",
      x2: "11",
      y1: "12",
      y2: "12"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "21",
      x2: "11",
      y1: "6",
      y2: "6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "21",
      x2: "11",
      y1: "18",
      y2: "18"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "05_0");
const LuIndianRupee = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6 3h12"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6 8h12"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m6 13 8.5 8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6 13h3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 13c6.667 0 6.667-10 0-10"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "mk_0");
const LuInfinity = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: /* @__PURE__ */ _jsxQ("path", null, {
    d: "M12 12c-2-2.67-4-4-6-4a4 4 0 1 0 0 8c2 0 4-1.33 6-4Zm0 0c2 2.67 4 4 6 4a4 4 0 0 0 0-8c-2 0-4 1.33-6 4Z"
  }, null, 3, null)
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "uT_0");
const LuInfo = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 16v-4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 8h.01"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "d1_0");
const LuInstagram = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "20",
      rx: "5",
      ry: "5",
      width: "20",
      x: "2",
      y: "2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "17.5",
      x2: "17.51",
      y1: "6.5",
      y2: "6.5"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "PK_0");
const LuItalic = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "19",
      x2: "10",
      y1: "4",
      y2: "4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "14",
      x2: "5",
      y1: "20",
      y2: "20"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "15",
      x2: "9",
      y1: "4",
      y2: "20"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "ow_0");
const LuIterationCcw = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M20 10c0-4.4-3.6-8-8-8s-8 3.6-8 8 3.6 8 8 8h8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "16 14 20 18 16 22"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "BV_0");
const LuIterationCw = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 10c0-4.4 3.6-8 8-8s8 3.6 8 8-3.6 8-8 8H4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "8 22 4 18 8 14"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "7N_0");
const LuJapaneseYen = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 9.5V21m0-11.5L6 3m6 6.5L18 3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6 15h12"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6 11h12"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "9E_0");
const LuJoystick = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 17a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-2Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6 15v-2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 15V9"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "6",
      r: "3"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "LA_0");
const LuKanbanSquareDashed = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 7v7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 7v4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 7v9"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M5 3a2 2 0 0 0-2 2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 3h1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14 3h1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M19 3a2 2 0 0 1 2 2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 9v1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 14v1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 19a2 2 0 0 1-2 2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14 21h1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 21h1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M5 21a2 2 0 0 1-2-2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 14v1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 9v1"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "FX_0");
const LuKanbanSquare = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "18",
      rx: "2",
      width: "18",
      x: "3",
      y: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 7v7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 7v4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 7v9"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "M0_0");
const LuKanban = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6 5v11"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 5v6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18 5v14"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "vG_0");
const LuKeyRound = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 18v3c0 .6.4 1 1 1h4v-3h3v-3h2l1.4-1.4a6.5 6.5 0 1 0-4-4Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "16.5",
      cy: "7.5",
      r: ".5"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "IQ_0");
const LuKeySquare = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12.4 2.7c.9-.9 2.5-.9 3.4 0l5.5 5.5c.9.9.9 2.5 0 3.4l-3.7 3.7c-.9.9-2.5.9-3.4 0L8.7 9.8c-.9-.9-.9-2.5 0-3.4Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m14 7 3 3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9.4 10.6 2 18v3c0 .6.4 1 1 1h4v-3h3v-3h2l1.4-1.4"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "BD_0");
const LuKey = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "7.5",
      cy: "15.5",
      r: "5.5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m21 2-9.6 9.6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m15.5 7.5 3 3L22 7l-3-3"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Wf_0");
const LuKeyboard = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "16",
      rx: "2",
      ry: "2",
      width: "20",
      x: "2",
      y: "4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6 8h.001"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10 8h.001"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14 8h.001"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18 8h.001"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 12h.001"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 12h.001"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 12h.001"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 16h10"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "47_0");
const LuLampCeiling = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 2v5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6 7h12l4 9H2l4-9Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9.17 16a3 3 0 1 0 5.66 0"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "OA_0");
const LuLampDesk = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m14 5-3 3 2 7 8-8-7-2Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m14 5-3 3-3-3 3-3 3 3Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9.5 6.5 4 12l3 6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 22v-2c0-1.1.9-2 2-2h4a2 2 0 0 1 2 2v2H3Z"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "WB_0");
const LuLampFloor = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 2h6l3 7H6l3-7Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 9v13"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 22h6"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "pt_0");
const LuLampWallDown = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M11 13h6l3 7H8l3-7Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14 13V8a2 2 0 0 0-2-2H8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 9h2a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H4v6Z"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Xt_0");
const LuLampWallUp = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M11 4h6l3 7H8l3-7Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14 11v5a2 2 0 0 1-2 2H8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 15h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H4v-6Z"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "8d_0");
const LuLamp = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 2h8l4 10H4L8 2Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 12v6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 22v-2c0-1.1.9-2 2-2h4a2 2 0 0 1 2 2v2H8Z"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "jK_0");
const LuLandPlot = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m12 8 6-3-6-3v10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m8 11.99-5.5 3.14a1 1 0 0 0 0 1.74l8.5 4.86a2 2 0 0 0 2 0l8.5-4.86a1 1 0 0 0 0-1.74L16 12"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m6.49 12.85 11.02 6.3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17.51 12.85 6.5 19.15"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "0X_0");
const LuLandmark = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "3",
      x2: "21",
      y1: "22",
      y2: "22"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "6",
      x2: "6",
      y1: "18",
      y2: "11"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "10",
      x2: "10",
      y1: "18",
      y2: "11"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "14",
      x2: "14",
      y1: "18",
      y2: "11"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "18",
      x2: "18",
      y1: "18",
      y2: "11"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polygon", null, {
      points: "12 2 20 7 4 7"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "PF_0");
const LuLanguages = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m5 8 6 6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m4 14 6-6 2-3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 5h12"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 2h1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m22 22-5-10-5 10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14 18h6"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "2t_0");
const LuLaptop2 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "12",
      rx: "2",
      ry: "2",
      width: "18",
      x: "3",
      y: "4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "2",
      x2: "22",
      y1: "20",
      y2: "20"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "lD_0");
const LuLaptop = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: /* @__PURE__ */ _jsxQ("path", null, {
    d: "M20 16V7a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v9m16 0H4m16 0 1.28 2.55a1 1 0 0 1-.9 1.45H3.62a1 1 0 0 1-.9-1.45L4 16"
  }, null, 3, null)
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "3P_0");
const LuLassoSelect = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 22a5 5 0 0 1-2-4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 16.93c.96.43 1.96.74 2.99.91"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3.34 14A6.8 6.8 0 0 1 2 10c0-4.42 4.48-8 10-8s10 3.58 10 8a7.19 7.19 0 0 1-.33 2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M5 18a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14.33 22h-.09a.35.35 0 0 1-.24-.32v-10a.34.34 0 0 1 .33-.34c.08 0 .15.03.21.08l7.34 6a.33.33 0 0 1-.21.59h-4.49l-2.57 3.85a.35.35 0 0 1-.28.14v0z"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Zi_0");
const LuLasso = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 22a5 5 0 0 1-2-4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3.3 14A6.8 6.8 0 0 1 2 10c0-4.4 4.5-8 10-8s10 3.6 10 8-4.5 8-10 8a12 12 0 0 1-5-1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M5 18a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "cZ_0");
const LuLaugh = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18 13a6 6 0 0 1-6 5 6 6 0 0 1-6-5h12Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "9",
      x2: "9.01",
      y1: "9",
      y2: "9"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "15",
      x2: "15.01",
      y1: "9",
      y2: "9"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "PY_0");
const LuLayers2 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m16.02 12 5.48 3.13a1 1 0 0 1 0 1.74L13 21.74a2 2 0 0 1-2 0l-8.5-4.87a1 1 0 0 1 0-1.74L7.98 12"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M13 13.74a2 2 0 0 1-2 0L2.5 8.87a1 1 0 0 1 0-1.74L11 2.26a2 2 0 0 1 2 0l8.5 4.87a1 1 0 0 1 0 1.74Z"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "5j_0");
const LuLayers3 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m6.08 9.5-3.5 1.6a1 1 0 0 0 0 1.81l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9a1 1 0 0 0 0-1.83l-3.5-1.59"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m6.08 14.5-3.5 1.6a1 1 0 0 0 0 1.81l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9a1 1 0 0 0 0-1.83l-3.5-1.59"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "00_0");
const LuLayers = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m22 17.65-9.17 4.16a2 2 0 0 1-1.66 0L2 17.65"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m22 12.65-9.17 4.16a2 2 0 0 1-1.66 0L2 12.65"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Qr_0");
const LuLayoutDashboard = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "9",
      rx: "1",
      width: "7",
      x: "3",
      y: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "5",
      rx: "1",
      width: "7",
      x: "14",
      y: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "9",
      rx: "1",
      width: "7",
      x: "14",
      y: "12"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "5",
      rx: "1",
      width: "7",
      x: "3",
      y: "16"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "uX_0");
const LuLayoutGrid = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "7",
      rx: "1",
      width: "7",
      x: "3",
      y: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "7",
      rx: "1",
      width: "7",
      x: "14",
      y: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "7",
      rx: "1",
      width: "7",
      x: "14",
      y: "14"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "7",
      rx: "1",
      width: "7",
      x: "3",
      y: "14"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "0c_0");
const LuLayoutList = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "7",
      rx: "1",
      width: "7",
      x: "3",
      y: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "7",
      rx: "1",
      width: "7",
      x: "3",
      y: "14"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14 4h7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14 9h7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14 15h7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14 20h7"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "XC_0");
const LuLayoutPanelLeft = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "18",
      rx: "1",
      width: "7",
      x: "3",
      y: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "7",
      rx: "1",
      width: "7",
      x: "14",
      y: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "7",
      rx: "1",
      width: "7",
      x: "14",
      y: "14"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "tu_0");
const LuLayoutPanelTop = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "7",
      rx: "1",
      width: "18",
      x: "3",
      y: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "7",
      rx: "1",
      width: "7",
      x: "3",
      y: "14"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "7",
      rx: "1",
      width: "7",
      x: "14",
      y: "14"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Gu_0");
const LuLayoutTemplate = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "7",
      rx: "1",
      width: "18",
      x: "3",
      y: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "7",
      rx: "1",
      width: "9",
      x: "3",
      y: "14"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "7",
      rx: "1",
      width: "5",
      x: "16",
      y: "14"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "0o_0");
const LuLayout = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "18",
      rx: "2",
      ry: "2",
      width: "18",
      x: "3",
      y: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "3",
      x2: "21",
      y1: "9",
      y2: "9"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "9",
      x2: "9",
      y1: "21",
      y2: "9"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "n8_0");
const LuLeaf = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8 0 5.5-4.78 10-10 10Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 21c0-3 1.85-5.36 5.08-6C9.5 14.52 12 13 13 12"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "wS_0");
const LuLeafyGreen = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 22c1.25-.987 2.27-1.975 3.9-2.2a5.56 5.56 0 0 1 3.8 1.5 4 4 0 0 0 6.187-2.353 3.5 3.5 0 0 0 3.69-5.116A3.5 3.5 0 0 0 20.95 8 3.5 3.5 0 1 0 16 3.05a3.5 3.5 0 0 0-5.831 1.373 3.5 3.5 0 0 0-5.116 3.69 4 4 0 0 0-2.348 6.155C3.499 15.42 4.409 16.712 4.2 18.1 3.926 19.743 3.014 20.732 2 22"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 22 17 7"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "HP_0");
const LuLibraryBig = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "18",
      rx: "1",
      width: "8",
      x: "3",
      y: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 3v18"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M20.4 18.9c.2.5-.1 1.1-.6 1.3l-1.9.7c-.5.2-1.1-.1-1.3-.6L11.1 5.1c-.2-.5.1-1.1.6-1.3l1.9-.7c.5-.2 1.1.1 1.3.6Z"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "KE_0");
const LuLibrarySquare = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "18",
      rx: "2",
      width: "18",
      x: "3",
      y: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 7v10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M11 7v10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m15 7 2 10"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "yU_0");
const LuLibrary = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m16 6 4 14"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 6v14"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 8v12"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 4v16"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "pJ_0");
const LuLifeBuoy = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m4.93 4.93 4.24 4.24"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m14.83 9.17 4.24-4.24"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m14.83 14.83 4.24 4.24"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m9.17 14.83-4.24 4.24"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "4"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "gH_0");
const LuLigature = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 20V8c0-2.2 1.8-4 4-4 1.5 0 2.8.8 3.5 2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6 12h4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14 12h2v8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6 20h4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14 20h4"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "1W_0");
const LuLightbulbOff = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16.8 11.2c.8-.9 1.2-2 1.2-3.2a6 6 0 0 0-9.3-5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m2 2 20 20"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6.3 6.3a4.67 4.67 0 0 0 1.2 5.2c.7.7 1.3 1.5 1.5 2.5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 18h6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10 22h4"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "bj_0");
const LuLightbulb = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .2 2.2 1.5 3.5.7.7 1.3 1.5 1.5 2.5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 18h6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10 22h4"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "JJ_0");
const LuLineChart = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 3v18h18"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m19 9-5 5-4-4-3 3"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "it_0");
const LuLink2Off = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 17H7A5 5 0 0 1 7 7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M15 7h2a5 5 0 0 1 4 8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "8",
      x2: "12",
      y1: "12",
      y2: "12"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "2",
      x2: "22",
      y1: "2",
      y2: "22"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "2F_0");
const LuLink2 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 17H7A5 5 0 0 1 7 7h2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M15 7h2a5 5 0 1 1 0 10h-2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "8",
      x2: "16",
      y1: "12",
      y2: "12"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "QO_0");
const LuLink = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "CK_0");
const LuLinkedin = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "12",
      width: "4",
      x: "2",
      y: "9"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "4",
      cy: "4",
      r: "2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "H2_0");
const LuListChecks = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m3 17 2 2 4-4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m3 7 2 2 4-4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M13 6h8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M13 12h8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M13 18h8"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "q2_0");
const LuListEnd = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 12H3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 6H3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10 18H3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 6v10a2 2 0 0 1-2 2h-5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m16 16-2 2 2 2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "cX_0");
const LuListFilter = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 6h18"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 12h10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10 18h4"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "8T_0");
const LuListMinus = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M11 12H3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 6H3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 18H3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 12h-6"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "uF_0");
const LuListMusic = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 15V6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18.5 18a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 12H3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 6H3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 18H3"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "NX_0");
const LuListOrdered = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "10",
      x2: "21",
      y1: "6",
      y2: "6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "10",
      x2: "21",
      y1: "12",
      y2: "12"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "10",
      x2: "21",
      y1: "18",
      y2: "18"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 6h1v4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 10h2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6 18H4c0-1 2-2 2-3s-1-1.5-2-1"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Ur_0");
const LuListPlus = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M11 12H3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 6H3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 18H3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18 9v6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 12h-6"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "K0_0");
const LuListRestart = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 6H3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 12H3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 18H3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 18a5 5 0 0 0 9-3 4.5 4.5 0 0 0-4.5-4.5c-1.33 0-2.54.54-3.41 1.41L11 14"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M11 10v4h4"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "bv_0");
const LuListStart = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 12H3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 18H3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10 6H3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 18V8a2 2 0 0 0-2-2h-5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m16 8-2-2 2-2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "YE_0");
const LuListTodo = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "6",
      rx: "1",
      width: "6",
      x: "3",
      y: "5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m3 17 2 2 4-4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M13 6h8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M13 12h8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M13 18h8"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Rk_0");
const LuListTree = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 12h-8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 6H8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 18h-8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 6v4c0 1.1.9 2 2 2h3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 10v6c0 1.1.9 2 2 2h3"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Rs_0");
const LuListVideo = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 12H3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 6H3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 18H3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m16 12 5 3-5 3v-6Z"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "MB_0");
const LuListX = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M11 12H3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 6H3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 18H3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m19 10-4 4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m15 10 4 4"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "sR_0");
const LuList = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "8",
      x2: "21",
      y1: "6",
      y2: "6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "8",
      x2: "21",
      y1: "12",
      y2: "12"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "8",
      x2: "21",
      y1: "18",
      y2: "18"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "3",
      x2: "3.01",
      y1: "6",
      y2: "6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "3",
      x2: "3.01",
      y1: "12",
      y2: "12"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "3",
      x2: "3.01",
      y1: "18",
      y2: "18"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "l2_0");
const LuLoader2 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: /* @__PURE__ */ _jsxQ("path", null, {
    d: "M21 12a9 9 0 1 1-6.219-8.56"
  }, null, 3, null)
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "nT_0");
const LuLoader = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "12",
      x2: "12",
      y1: "2",
      y2: "6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "12",
      x2: "12",
      y1: "18",
      y2: "22"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "4.93",
      x2: "7.76",
      y1: "4.93",
      y2: "7.76"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "16.24",
      x2: "19.07",
      y1: "16.24",
      y2: "19.07"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "2",
      x2: "6",
      y1: "12",
      y2: "12"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "18",
      x2: "22",
      y1: "12",
      y2: "12"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "4.93",
      x2: "7.76",
      y1: "19.07",
      y2: "16.24"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "16.24",
      x2: "19.07",
      y1: "7.76",
      y2: "4.93"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "kT_0");
const LuLocateFixed = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "2",
      x2: "5",
      y1: "12",
      y2: "12"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "19",
      x2: "22",
      y1: "12",
      y2: "12"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "12",
      x2: "12",
      y1: "2",
      y2: "5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "12",
      x2: "12",
      y1: "19",
      y2: "22"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "3"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "oe_0");
const LuLocateOff = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "2",
      x2: "5",
      y1: "12",
      y2: "12"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "19",
      x2: "22",
      y1: "12",
      y2: "12"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "12",
      x2: "12",
      y1: "2",
      y2: "5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "12",
      x2: "12",
      y1: "19",
      y2: "22"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7.11 7.11C5.83 8.39 5 10.1 5 12c0 3.87 3.13 7 7 7 1.9 0 3.61-.83 4.89-2.11"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18.71 13.96c.19-.63.29-1.29.29-1.96 0-3.87-3.13-7-7-7-.67 0-1.33.1-1.96.29"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "2",
      x2: "22",
      y1: "2",
      y2: "22"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "s9_0");
const LuLocate = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "2",
      x2: "5",
      y1: "12",
      y2: "12"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "19",
      x2: "22",
      y1: "12",
      y2: "12"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "12",
      x2: "12",
      y1: "2",
      y2: "5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "12",
      x2: "12",
      y1: "19",
      y2: "22"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "7"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "a2_0");
const LuLockKeyhole = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "16",
      r: "1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "12",
      rx: "2",
      width: "18",
      x: "3",
      y: "10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 10V7a5 5 0 0 1 10 0v3"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "EW_0");
const LuLock = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "11",
      rx: "2",
      ry: "2",
      width: "18",
      x: "3",
      y: "11"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 11V7a5 5 0 0 1 10 0v4"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "WS_0");
const LuLogIn = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "10 17 15 12 10 7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "15",
      x2: "3",
      y1: "12",
      y2: "12"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "ca_0");
const LuLogOut = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "16 17 21 12 16 7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "21",
      x2: "9",
      y1: "12",
      y2: "12"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "0h_0");
const LuLollipop = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "11",
      cy: "11",
      r: "8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m21 21-4.3-4.3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M11 11a2 2 0 0 0 4 0 4 4 0 0 0-8 0 6 6 0 0 0 12 0"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "IG_0");
const LuLuggage = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6 20h0a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h0"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 18V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v14"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10 20h4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "16",
      cy: "20",
      r: "2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "8",
      cy: "20",
      r: "2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "59_0");
const LuMSquare = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "18",
      rx: "2",
      width: "18",
      x: "3",
      y: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 16V8l4 4 4-4v8"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "29_0");
const LuMagnet = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m6 15-4-4 6.75-6.77a7.79 7.79 0 0 1 11 11L13 22l-4-4 6.39-6.36a2.14 2.14 0 0 0-3-3L6 15"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m5 8 4 4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m12 15 4 4"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "0y_0");
const LuMailCheck = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M22 13V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m16 19 2 2 4-4"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "ek_0");
const LuMailMinus = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M22 15V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 19h6"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "DC_0");
const LuMailOpen = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21.2 8.4c.5.38.8.97.8 1.6v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V10a2 2 0 0 1 .8-1.6l8-6a2 2 0 0 1 2.4 0l8 6Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m22 10-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 10"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "N4_0");
const LuMailPlus = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M22 13V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M19 16v6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 19h6"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "c9_0");
const LuMailQuestion = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M22 10.5V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h12.5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18 15.28c.2-.4.5-.8.9-1a2.1 2.1 0 0 1 2.6.4c.3.4.5.8.5 1.3 0 1.3-2 2-2 2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M20 22v.01"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "eV_0");
const LuMailSearch = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M22 12.5V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h7.5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18 21a3 3 0 1 0 0-6 3 3 0 0 0 0 6v0Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "18",
      cy: "18",
      r: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m22 22-1.5-1.5"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "fQ_0");
const LuMailWarning = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M22 10.5V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h12.5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M20 14v4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M20 22v.01"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "by_0");
const LuMailX = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M22 13V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h9"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m17 17 4 4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m21 17-4 4"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Ps_0");
const LuMail = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "16",
      rx: "2",
      width: "20",
      x: "2",
      y: "4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "n4_0");
const LuMailbox = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M22 17a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9.5C2 7 4 5 6.5 5H18c2.2 0 4 1.8 4 4v8Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "15,9 18,9 18,11"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6.5 5C9 5 11 7 11 9.5V17a2 2 0 0 1-2 2v0"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "6",
      x2: "7",
      y1: "10",
      y2: "10"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "ea_0");
const LuMails = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "13",
      rx: "2",
      width: "16",
      x: "6",
      y: "4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m22 7-7.1 3.78c-.57.3-1.23.3-1.8 0L6 7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 8v11c0 1.1.9 2 2 2h14"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Cl_0");
const LuMapPinOff = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M5.43 5.43A8.06 8.06 0 0 0 4 10c0 6 8 12 8 12a29.94 29.94 0 0 0 5-5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M19.18 13.52A8.66 8.66 0 0 0 20 10a8 8 0 0 0-8-8 7.88 7.88 0 0 0-3.52.82"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9.13 9.13A2.78 2.78 0 0 0 9 10a3 3 0 0 0 3 3 2.78 2.78 0 0 0 .87-.13"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14.9 9.25a3 3 0 0 0-2.15-2.16"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "2",
      x2: "22",
      y1: "2",
      y2: "22"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Au_0");
const LuMapPin = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "10",
      r: "3"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "8M_0");
const LuMapPinned = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18 8c0 4.5-6 9-6 9s-6-4.5-6-9a6 6 0 0 1 12 0"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "8",
      r: "2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8.835 14H5a1 1 0 0 0-.9.7l-2 6c-.1.1-.1.2-.1.3 0 .6.4 1 1 1h18c.6 0 1-.4 1-1 0-.1 0-.2-.1-.3l-2-6a1 1 0 0 0-.9-.7h-3.835"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "HF_0");
const LuMap = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("polygon", null, {
      points: "3 6 9 3 15 6 21 3 21 18 15 21 9 18 3 21"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "9",
      x2: "9",
      y1: "3",
      y2: "18"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "15",
      x2: "15",
      y1: "6",
      y2: "21"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "o9_0");
const LuMartini = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 22h8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 11v11"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m19 3-7 8-7-8Z"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Su_0");
const LuMaximize2 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "15 3 21 3 21 9"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "9 21 3 21 3 15"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "21",
      x2: "14",
      y1: "3",
      y2: "10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "3",
      x2: "10",
      y1: "21",
      y2: "14"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "p9_0");
const LuMaximize = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 3H5a2 2 0 0 0-2 2v3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 8V5a2 2 0 0 0-2-2h-3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 16v3a2 2 0 0 0 2 2h3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 21h3a2 2 0 0 0 2-2v-3"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "V3_0");
const LuMedal = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7.21 15 2.66 7.14a2 2 0 0 1 .13-2.2L4.4 2.8A2 2 0 0 1 6 2h12a2 2 0 0 1 1.6.8l1.6 2.14a2 2 0 0 1 .14 2.2L16.79 15"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M11 12 5.12 2.2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m13 12 5.88-9.8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 7h8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "17",
      r: "5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 18v-2h-.5"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "xX_0");
const LuMegaphoneOff = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9.26 9.26 3 11v3l14.14 3.14"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 15.34V6l-7.31 2.03"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M11.6 16.8a3 3 0 1 1-5.8-1.6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "2",
      x2: "22",
      y1: "2",
      y2: "22"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Lp_0");
const LuMegaphone = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m3 11 18-5v12L3 14v-3z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M11.6 16.8a3 3 0 1 1-5.8-1.6"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "sz_0");
const LuMeh = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "8",
      x2: "16",
      y1: "15",
      y2: "15"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "9",
      x2: "9.01",
      y1: "9",
      y2: "9"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "15",
      x2: "15.01",
      y1: "9",
      y2: "9"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "SO_0");
const LuMemoryStick = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6 19v-3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10 19v-3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14 19v-3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18 19v-3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 11V9"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 11V9"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 11V9"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 15h20"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 7a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v1.1a2 2 0 0 0 0 3.837V17a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-5.1a2 2 0 0 0 0-3.837Z"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "xO_0");
const LuMenuSquare = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "18",
      rx: "2",
      width: "18",
      x: "3",
      y: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 8h10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 12h10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 16h10"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "g5_0");
const LuMenu = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "4",
      x2: "20",
      y1: "12",
      y2: "12"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "4",
      x2: "20",
      y1: "6",
      y2: "6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "4",
      x2: "20",
      y1: "18",
      y2: "18"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "f1_0");
const LuMerge = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m8 6 4-4 4 4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 2v10.3a4 4 0 0 1-1.172 2.872L4 22"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m20 22-5-5"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "v8_0");
const LuMessageCircle = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: /* @__PURE__ */ _jsxQ("path", null, {
    d: "m3 21 1.9-5.7a8.5 8.5 0 1 1 3.8 3.8z"
  }, null, 3, null)
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "F2_0");
const LuMessageSquareDashed = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 6V5c0-1.1.9-2 2-2h2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M11 3h3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18 3h1c1.1 0 2 .9 2 2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 9v2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 15c0 1.1-.9 2-2 2h-1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14 17h-3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m7 17-4 4v-5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 12v-2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "l0_0");
const LuMessageSquarePlus = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "9",
      x2: "15",
      y1: "10",
      y2: "10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "12",
      x2: "12",
      y1: "7",
      y2: "13"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "XK_0");
const LuMessageSquare = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: /* @__PURE__ */ _jsxQ("path", null, {
    d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"
  }, null, 3, null)
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "42_0");
const LuMessagesSquare = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14 9a2 2 0 0 1-2 2H6l-4 4V4c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v5Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18 9h2a2 2 0 0 1 2 2v11l-4-4h-6a2 2 0 0 1-2-2v-1"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "n6_0");
const LuMic2 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m12 8-9.04 9.06a2.82 2.82 0 1 0 3.98 3.98L16 12"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "17",
      cy: "7",
      r: "5"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Xs_0");
const LuMicOff = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "2",
      x2: "22",
      y1: "2",
      y2: "22"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18.89 13.23A7.12 7.12 0 0 0 19 12v-2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M5 10v2a7 7 0 0 0 12 5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M15 9.34V5a3 3 0 0 0-5.68-1.33"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 9v3a3 3 0 0 0 5.12 2.12"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "12",
      x2: "12",
      y1: "19",
      y2: "22"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Vn_0");
const LuMic = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 2a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M19 10v2a7 7 0 0 1-14 0v-2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "12",
      x2: "12",
      y1: "19",
      y2: "22"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "xC_0");
const LuMicroscope = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6 18h8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 22h18"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14 22a7 7 0 1 0 0-14h-1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 14h2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 12a2 2 0 0 1-2-2V6h6v4a2 2 0 0 1-2 2Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 6V3a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v3"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "mZ_0");
const LuMicrowave = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "15",
      rx: "2",
      width: "20",
      x: "2",
      y: "4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "7",
      rx: "1",
      width: "8",
      x: "6",
      y: "8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18 8v7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6 19v2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18 19v2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "cH_0");
const LuMilestone = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18 6H5a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h13l4-3.5L18 6Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 13v8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 3v3"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "5Q_0");
const LuMilkOff = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 2h8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 2v1.343M15 2v2.789a4 4 0 0 0 .672 2.219l.656.984a4 4 0 0 1 .672 2.22v1.131M7.8 7.8l-.128.192A4 4 0 0 0 7 10.212V20a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 15a6.47 6.47 0 0 1 5 0 6.472 6.472 0 0 0 3.435.435"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "2",
      x2: "22",
      y1: "2",
      y2: "22"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "u3_0");
const LuMilk = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 2h8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 2v2.789a4 4 0 0 1-.672 2.219l-.656.984A4 4 0 0 0 7 10.212V20a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-9.789a4 4 0 0 0-.672-2.219l-.656-.984A4 4 0 0 1 15 4.788V2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 15a6.472 6.472 0 0 1 5 0 6.47 6.47 0 0 0 5 0"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "kZ_0");
const LuMinimize2 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "4 14 10 14 10 20"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "20 10 14 10 14 4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "14",
      x2: "21",
      y1: "10",
      y2: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "3",
      x2: "10",
      y1: "21",
      y2: "14"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Ei_0");
const LuMinimize = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 3v3a2 2 0 0 1-2 2H3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 8h-3a2 2 0 0 1-2-2V3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 16h3a2 2 0 0 1 2 2v3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 21v-3a2 2 0 0 1 2-2h3"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "hI_0");
const LuMinusCircle = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 12h8"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Av_0");
const LuMinusSquare = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "18",
      rx: "2",
      width: "18",
      x: "3",
      y: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 12h8"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Fr_0");
const LuMinus = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: /* @__PURE__ */ _jsxQ("path", null, {
    d: "M5 12h14"
  }, null, 3, null)
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "lG_0");
const LuMonitorCheck = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m9 10 2 2 4-4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "14",
      rx: "2",
      width: "20",
      x: "2",
      y: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 17v4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 21h8"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Gm_0");
const LuMonitorDot = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "19",
      cy: "6",
      r: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M22 12v3a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h9"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 17v4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 21h8"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "ih_0");
const LuMonitorDown = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 13V7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m15 10-3 3-3-3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "14",
      rx: "2",
      width: "20",
      x: "2",
      y: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 17v4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 21h8"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "dZ_0");
const LuMonitorOff = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17 17H4a2 2 0 0 1-2-2V5c0-1.5 1-2 1-2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M22 15V5a2 2 0 0 0-2-2H9"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 21h8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 17v4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m2 2 20 20"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "hB_0");
const LuMonitorPause = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10 13V7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14 13V7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "14",
      rx: "2",
      width: "20",
      x: "2",
      y: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 17v4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 21h8"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "98_0");
const LuMonitorPlay = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m10 7 5 3-5 3Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "14",
      rx: "2",
      width: "20",
      x: "2",
      y: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 17v4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 21h8"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "O1_0");
const LuMonitorSmartphone = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18 8V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10 19v-3.96 3.15"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 19h5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "10",
      rx: "2",
      width: "6",
      x: "16",
      y: "12"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Wj_0");
const LuMonitorSpeaker = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M5.5 20H8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17 9h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "16",
      rx: "2",
      width: "10",
      x: "12",
      y: "4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 6H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "17",
      cy: "15",
      r: "1"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "rh_0");
const LuMonitorStop = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "6",
      width: "6",
      x: "9",
      y: "7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "14",
      rx: "2",
      width: "20",
      x: "2",
      y: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 17v4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 21h8"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "dl_0");
const LuMonitorUp = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m9 10 3-3 3 3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 13V7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "14",
      rx: "2",
      width: "20",
      x: "2",
      y: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 17v4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 21h8"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Vl_0");
const LuMonitorX = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m14.5 12.5-5-5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m9.5 12.5 5-5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "14",
      rx: "2",
      width: "20",
      x: "2",
      y: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 17v4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 21h8"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "V5_0");
const LuMonitor = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "14",
      rx: "2",
      width: "20",
      x: "2",
      y: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "8",
      x2: "16",
      y1: "21",
      y2: "21"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "12",
      x2: "12",
      y1: "17",
      y2: "21"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Ra_0");
const LuMoonStar = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M19 3v4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 5h-4"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "wJ_0");
const LuMoon = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: /* @__PURE__ */ _jsxQ("path", null, {
    d: "M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z"
  }, null, 3, null)
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Oe_0");
const LuMoreHorizontal = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "19",
      cy: "12",
      r: "1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "5",
      cy: "12",
      r: "1"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "U0_0");
const LuMoreVertical = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "5",
      r: "1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "19",
      r: "1"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Gy_0");
const LuMountainSnow = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m8 3 4 8 5-5 5 15H2L8 3z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4.14 15.08c2.62-1.57 5.24-1.43 7.86.42 2.74 1.94 5.49 2 8.23.19"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "zw_0");
const LuMountain = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: /* @__PURE__ */ _jsxQ("path", null, {
    d: "m8 3 4 8 5-5 5 15H2L8 3z"
  }, null, 3, null)
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "OV_0");
const LuMousePointer2 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: /* @__PURE__ */ _jsxQ("path", null, {
    d: "m4 4 7.07 17 2.51-7.39L21 11.07z"
  }, null, 3, null)
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "FJ_0");
const LuMousePointerClick = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m9 9 5 12 1.8-5.2L21 14Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7.2 2.2 8 5.1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m5.1 8-2.9-.8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14 4.1 12 6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m6 12-1.9 2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "O0_0");
const LuMousePointerSquareDashed = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M5 3a2 2 0 0 0-2 2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M19 3a2 2 0 0 1 2 2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m12 12 4 10 1.7-4.3L22 16Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M5 21a2 2 0 0 1-2-2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 3h1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 21h2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14 3h1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 9v1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 9v2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 14v1"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Gb_0");
const LuMousePointerSquare = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 11V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m12 12 4 10 1.7-4.3L22 16Z"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "hq_0");
const LuMousePointer = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m3 3 7.07 16.97 2.51-7.39 7.39-2.51L3 3z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m13 13 6 6"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "uR_0");
const LuMouse = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "20",
      rx: "7",
      width: "14",
      x: "5",
      y: "2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 6v4"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "81_0");
const LuMove3D = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M5 3v16h16"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m5 19 6-6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m2 6 3-3 3 3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m18 16 3 3-3 3"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "qU_0");
const LuMoveDiagonal2 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "5 11 5 5 11 5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "19 13 19 19 13 19"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "5",
      x2: "19",
      y1: "5",
      y2: "19"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Wi_0");
const LuMoveDiagonal = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "13 5 19 5 19 11"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "11 19 5 19 5 13"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "19",
      x2: "5",
      y1: "5",
      y2: "19"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "v0_0");
const LuMoveDownLeft = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M11 19H5V13"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M19 5L5 19"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "yU_0");
const LuMoveDownRight = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M19 13V19H13"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M5 5L19 19"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "sU_0");
const LuMoveDown = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 18L12 22L16 18"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 2V22"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "x0_0");
const LuMoveHorizontal = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "18 8 22 12 18 16"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "6 8 2 12 6 16"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "2",
      x2: "22",
      y1: "12",
      y2: "12"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "a9_0");
const LuMoveLeft = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6 8L2 12L6 16"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 12H22"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "mN_0");
const LuMoveRight = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18 8L22 12L18 16"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 12H22"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "uS_0");
const LuMoveUpLeft = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M5 11V5H11"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M5 5L19 19"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "jy_0");
const LuMoveUpRight = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M13 5H19V11"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M19 5L5 19"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Ek_0");
const LuMoveUp = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 6L12 2L16 6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 2V22"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "iv_0");
const LuMoveVertical = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "8 18 12 22 16 18"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "8 6 12 2 16 6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "12",
      x2: "12",
      y1: "2",
      y2: "22"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "WI_0");
const LuMove = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "5 9 2 12 5 15"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "9 5 12 2 15 5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "15 19 12 22 9 19"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "19 9 22 12 19 15"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "2",
      x2: "22",
      y1: "12",
      y2: "12"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "12",
      x2: "12",
      y1: "2",
      y2: "22"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "9j_0");
const LuMusic2 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "8",
      cy: "18",
      r: "4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 18V2l7 4"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "AY_0");
const LuMusic3 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "18",
      r: "4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 18V2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "D2_0");
const LuMusic4 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 18V5l12-2v13"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m9 9 12-2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "6",
      cy: "18",
      r: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "18",
      cy: "16",
      r: "3"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "c6_0");
const LuMusic = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 18V5l12-2v13"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "6",
      cy: "18",
      r: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "18",
      cy: "16",
      r: "3"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "gR_0");
const LuNavigation2Off = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9.31 9.31 5 21l7-4 7 4-1.17-3.17"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14.53 8.88 12 2l-1.17 3.17"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "2",
      x2: "22",
      y1: "2",
      y2: "22"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "j4_0");
const LuNavigation2 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: /* @__PURE__ */ _jsxQ("polygon", null, {
    points: "12 2 19 21 12 17 5 21 12 2"
  }, null, 3, null)
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "06_0");
const LuNavigationOff = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8.43 8.43 3 11l8 2 2 8 2.57-5.43"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17.39 11.73 22 2l-9.73 4.61"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "2",
      x2: "22",
      y1: "2",
      y2: "22"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "fC_0");
const LuNavigation = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: /* @__PURE__ */ _jsxQ("polygon", null, {
    points: "3 11 22 2 13 21 11 13 3 11"
  }, null, 3, null)
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "3C_0");
const LuNetwork = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "6",
      rx: "1",
      width: "6",
      x: "16",
      y: "16"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "6",
      rx: "1",
      width: "6",
      x: "2",
      y: "16"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "6",
      rx: "1",
      width: "6",
      x: "9",
      y: "2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M5 16v-3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 12V8"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "z1_0");
const LuNewspaper = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 22h16a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v16a2 2 0 0 1-2 2Zm0 0a2 2 0 0 1-2-2v-9c0-1.1.9-2 2-2h2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18 14h-8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M15 18h-5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10 6h8v4h-8V6Z"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "zu_0");
const LuNfc = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6 8.32a7.43 7.43 0 0 1 0 7.36"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9.46 6.21a11.76 11.76 0 0 1 0 11.58"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12.91 4.1a15.91 15.91 0 0 1 .01 15.8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16.37 2a20.16 20.16 0 0 1 0 20"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "zt_0");
const LuNutOff = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 4V2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M5 10v4a7.004 7.004 0 0 0 5.277 6.787c.412.104.802.292 1.102.592L12 22l.621-.621c.3-.3.69-.488 1.102-.592a7.01 7.01 0 0 0 4.125-2.939"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M19 10v3.343"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 12c-1.349-.573-1.905-1.005-2.5-2-.546.902-1.048 1.353-2.5 2-1.018-.644-1.46-1.08-2-2-1.028.71-1.69.918-3 1 1.081-1.048 1.757-2.03 2-3 .194-.776.84-1.551 1.79-2.21m11.654 5.997c.887-.457 1.28-.891 1.556-1.787 1.032.916 1.683 1.157 3 1-1.297-1.036-1.758-2.03-2-3-.5-2-4-4-8-4-.74 0-1.461.068-2.15.192"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "2",
      x2: "22",
      y1: "2",
      y2: "22"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "L0_0");
const LuNut = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 4V2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M5 10v4a7.004 7.004 0 0 0 5.277 6.787c.412.104.802.292 1.102.592L12 22l.621-.621c.3-.3.69-.488 1.102-.592A7.003 7.003 0 0 0 19 14v-4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 4C8 4 4.5 6 4 8c-.243.97-.919 1.952-2 3 1.31-.082 1.972-.29 3-1 .54.92.982 1.356 2 2 1.452-.647 1.954-1.098 2.5-2 .595.995 1.151 1.427 2.5 2 1.31-.621 1.862-1.058 2.5-2 .629.977 1.162 1.423 2.5 2 1.209-.548 1.68-.967 2-2 1.032.916 1.683 1.157 3 1-1.297-1.036-1.758-2.03-2-3-.5-2-4-4-8-4Z"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "J8_0");
const LuOctagon = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: /* @__PURE__ */ _jsxQ("polygon", null, {
    points: "7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"
  }, null, 3, null)
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "yO_0");
const LuOption = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 3h6l6 18h6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14 3h7"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "gs_0");
const LuOrbit = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "19",
      cy: "5",
      r: "2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "5",
      cy: "19",
      r: "2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10.4 21.9a10 10 0 0 0 9.941-15.416"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M13.5 2.1a10 10 0 0 0-9.841 15.416"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "1s_0");
const LuOutdent = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "7 8 3 12 7 16"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "21",
      x2: "11",
      y1: "12",
      y2: "12"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "21",
      x2: "11",
      y1: "6",
      y2: "6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "21",
      x2: "11",
      y1: "18",
      y2: "18"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "9i_0");
const LuPackage2 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 9h18v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V9Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m3 9 2.45-4.9A2 2 0 0 1 7.24 3h9.52a2 2 0 0 1 1.8 1.1L21 9"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 3v6"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "C0_0");
const LuPackageCheck = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m16 16 2 2 4-4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 10V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l2-1.14"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m7.5 4.27 9 5.15"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "3.29 7 12 12 20.71 7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "12",
      x2: "12",
      y1: "22",
      y2: "12"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "cO_0");
const LuPackageMinus = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 16h6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 10V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l2-1.14"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m7.5 4.27 9 5.15"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "3.29 7 12 12 20.71 7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "12",
      x2: "12",
      y1: "22",
      y2: "12"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "aF_0");
const LuPackageOpen = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M20.91 8.84 8.56 2.23a1.93 1.93 0 0 0-1.81 0L3.1 4.13a2.12 2.12 0 0 0-.05 3.69l12.22 6.93a2 2 0 0 0 1.94 0L21 12.51a2.12 2.12 0 0 0-.09-3.67Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m3.09 8.84 12.35-6.61a1.93 1.93 0 0 1 1.81 0l3.65 1.9a2.12 2.12 0 0 1 .1 3.69L8.73 14.75a2 2 0 0 1-1.94 0L3 12.51a2.12 2.12 0 0 1 .09-3.67Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "12",
      x2: "12",
      y1: "22",
      y2: "13"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M20 13.5v3.37a2.06 2.06 0 0 1-1.11 1.83l-6 3.08a1.93 1.93 0 0 1-1.78 0l-6-3.08A2.06 2.06 0 0 1 4 16.87V13.5"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "fg_0");
const LuPackagePlus = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 16h6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M19 13v6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 10V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l2-1.14"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m7.5 4.27 9 5.15"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "3.29 7 12 12 20.71 7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "12",
      x2: "12",
      y1: "22",
      y2: "12"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Md_0");
const LuPackageSearch = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 10V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l2-1.14"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m7.5 4.27 9 5.15"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "3.29 7 12 12 20.71 7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "12",
      x2: "12",
      y1: "22",
      y2: "12"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "18.5",
      cy: "15.5",
      r: "2.5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M20.27 17.27 22 19"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "8E_0");
const LuPackageX = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 10V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l2-1.14"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m7.5 4.27 9 5.15"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "3.29 7 12 12 20.71 7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "12",
      x2: "12",
      y1: "22",
      y2: "12"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m17 13 5 5m-5 0 5-5"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "v3_0");
const LuPackage = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m7.5 4.27 9 5.15"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m3.3 7 8.7 5 8.7-5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 22V12"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "ve_0");
const LuPaintBucket = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m19 11-8-8-8.6 8.6a2 2 0 0 0 0 2.8l5.2 5.2c.8.8 2 .8 2.8 0L19 11Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m5 2 5 5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 13h15"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M22 20a2 2 0 1 1-4 0c0-1.6 1.7-2.4 2-4 .3 1.6 2 2.4 2 4Z"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Fz_0");
const LuPaintbrush2 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14 19.9V16h3a2 2 0 0 0 2-2v-2H5v2c0 1.1.9 2 2 2h3v3.9a2 2 0 1 0 4 0Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6 12V2h12v10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14 2v4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10 2v2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "56_0");
const LuPaintbrush = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18.37 2.63 14 7l-1.59-1.59a2 2 0 0 0-2.82 0L8 7l9 9 1.59-1.59a2 2 0 0 0 0-2.82L17 10l4.37-4.37a2.12 2.12 0 1 0-3-3Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 8c-2 3-4 3.5-7 4l8 10c2-1 6-5 6-7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14.5 17.5 4.5 15"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "yv_0");
const LuPalette = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "13.5",
      cy: "6.5",
      r: ".5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "17.5",
      cy: "10.5",
      r: ".5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "8.5",
      cy: "7.5",
      r: ".5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "6.5",
      cy: "12.5",
      r: ".5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10c.926 0 1.648-.746 1.648-1.688 0-.437-.18-.835-.437-1.125-.29-.289-.438-.652-.438-1.125a1.64 1.64 0 0 1 1.668-1.668h1.996c3.051 0 5.555-2.503 5.555-5.554C21.965 6.012 17.461 2 12 2z"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "60_0");
const LuPalmtree = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M13 8c0-2.76-2.46-5-5.5-5S2 5.24 2 8h2l1-1 1 1h4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M13 7.14A5.82 5.82 0 0 1 16.5 6c3.04 0 5.5 2.24 5.5 5h-3l-1-1-1 1h-3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M5.89 9.71c-2.15 2.15-2.3 5.47-.35 7.43l4.24-4.25.7-.7.71-.71 2.12-2.12c-1.95-1.96-5.27-1.8-7.42.35z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M11 15.5c.5 2.5-.17 4.5-1 6.5h4c2-5.5-.5-12-1-14"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "ln_0");
const LuPanelBottomClose = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "18",
      rx: "2",
      ry: "2",
      width: "18",
      x: "3",
      y: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "3",
      x2: "21",
      y1: "15",
      y2: "15"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m15 8-3 3-3-3"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "0g_0");
const LuPanelBottomInactive = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "18",
      rx: "2",
      width: "18",
      x: "3",
      y: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14 15h1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M19 15h2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 15h2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 15h1"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Fy_0");
const LuPanelBottomOpen = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "18",
      rx: "2",
      ry: "2",
      width: "18",
      x: "3",
      y: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "3",
      x2: "21",
      y1: "15",
      y2: "15"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m9 10 3-3 3 3"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "0m_0");
const LuPanelBottom = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "18",
      rx: "2",
      ry: "2",
      width: "18",
      x: "3",
      y: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "3",
      x2: "21",
      y1: "15",
      y2: "15"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "15_0");
const LuPanelLeftClose = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "18",
      rx: "2",
      ry: "2",
      width: "18",
      x: "3",
      y: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 3v18"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m16 15-3-3 3-3"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "ZN_0");
const LuPanelLeftInactive = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "18",
      rx: "2",
      width: "18",
      x: "3",
      y: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 14v1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 19v2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 3v2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 9v1"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "EX_0");
const LuPanelLeftOpen = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "18",
      rx: "2",
      ry: "2",
      width: "18",
      x: "3",
      y: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 3v18"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m14 9 3 3-3 3"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "CF_0");
const LuPanelLeft = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "18",
      rx: "2",
      ry: "2",
      width: "18",
      x: "3",
      y: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "9",
      x2: "9",
      y1: "3",
      y2: "21"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "1o_0");
const LuPanelRightClose = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "18",
      rx: "2",
      ry: "2",
      width: "18",
      x: "3",
      y: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "15",
      x2: "15",
      y1: "3",
      y2: "21"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m8 9 3 3-3 3"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "CJ_0");
const LuPanelRightInactive = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "18",
      rx: "2",
      width: "18",
      x: "3",
      y: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M15 14v1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M15 19v2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M15 3v2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M15 9v1"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "eL_0");
const LuPanelRightOpen = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "18",
      rx: "2",
      ry: "2",
      width: "18",
      x: "3",
      y: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "15",
      x2: "15",
      y1: "3",
      y2: "21"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m10 15-3-3 3-3"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "A9_0");
const LuPanelRight = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "18",
      rx: "2",
      ry: "2",
      width: "18",
      x: "3",
      y: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "15",
      x2: "15",
      y1: "3",
      y2: "21"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "6b_0");
const LuPanelTopClose = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "18",
      rx: "2",
      ry: "2",
      width: "18",
      x: "3",
      y: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "3",
      x2: "21",
      y1: "9",
      y2: "9"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m9 16 3-3 3 3"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "zn_0");
const LuPanelTopInactive = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "18",
      rx: "2",
      width: "18",
      x: "3",
      y: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14 9h1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M19 9h2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 9h2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 9h1"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "rG_0");
const LuPanelTopOpen = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "18",
      rx: "2",
      ry: "2",
      width: "18",
      x: "3",
      y: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "3",
      x2: "21",
      y1: "9",
      y2: "9"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m15 14-3 3-3-3"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "vU_0");
const LuPanelTop = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "18",
      rx: "2",
      ry: "2",
      width: "18",
      x: "3",
      y: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "3",
      x2: "21",
      y1: "9",
      y2: "9"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "aL_0");
const LuPaperclip = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: /* @__PURE__ */ _jsxQ("path", null, {
    d: "m21.44 11.05-9.19 9.19a6 6 0 0 1-8.49-8.49l8.57-8.57A4 4 0 1 1 18 8.84l-8.59 8.57a2 2 0 0 1-2.83-2.83l8.49-8.48"
  }, null, 3, null)
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "qG_0");
const LuParentheses = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 21s-4-3-4-9 4-9 4-9"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 3s4 3 4 9-4 9-4 9"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "LN_0");
const LuParkingCircleOff = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m5 5 14 14"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M13 13a3 3 0 1 0 0-6H9v2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 17v-2.34"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "If_0");
const LuParkingCircle = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 17V7h4a3 3 0 0 1 0 6H9"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "ze_0");
const LuParkingMeter = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 9a3 3 0 1 1 6 0"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 12v3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M11 15h2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M19 9a7 7 0 1 0-13.6 2.3C6.4 14.4 8 19 8 19h8s1.6-4.6 2.6-7.7c.3-.8.4-1.5.4-2.3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 19v3"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "qC_0");
const LuParkingSquareOff = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3.6 3.6A2 2 0 0 1 5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-.59 1.41"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 8.7V19a2 2 0 0 0 2 2h10.3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m2 2 20 20"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M13 13a3 3 0 1 0 0-6H9v2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 17v-2.3"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "70_0");
const LuParkingSquare = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "18",
      rx: "2",
      width: "18",
      x: "3",
      y: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 17V7h4a3 3 0 0 1 0 6H9"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "UL_0");
const LuPartyPopper = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M5.8 11.3 2 22l10.7-3.79"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 3h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M22 8h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M15 2h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M22 20h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m22 2-2.24.75a2.9 2.9 0 0 0-1.96 3.12v0c.1.86-.57 1.63-1.45 1.63h-.38c-.86 0-1.6.6-1.76 1.44L14 10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m22 13-.82-.33c-.86-.34-1.82.2-1.98 1.11v0c-.11.7-.72 1.22-1.43 1.22H17"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m11 2 .33.82c.34.86-.2 1.82-1.11 1.98v0C9.52 4.9 9 5.52 9 6.23V7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M11 13c1.93 1.93 2.83 4.17 2 5-.83.83-3.07-.07-5-2-1.93-1.93-2.83-4.17-2-5 .83-.83 3.07.07 5 2Z"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "SC_0");
const LuPauseCircle = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "10",
      x2: "10",
      y1: "15",
      y2: "9"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "14",
      x2: "14",
      y1: "15",
      y2: "9"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "2g_0");
const LuPauseOctagon = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10 15V9"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14 15V9"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7.714 2h8.572L22 7.714v8.572L16.286 22H7.714L2 16.286V7.714L7.714 2z"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "uv_0");
const LuPause = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "16",
      width: "4",
      x: "6",
      y: "4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "16",
      width: "4",
      x: "14",
      y: "4"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "2t_0");
const LuPawPrint = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "11",
      cy: "4",
      r: "2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "18",
      cy: "8",
      r: "2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "20",
      cy: "16",
      r: "2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 10a5 5 0 0 1 5 5v3.5a3.5 3.5 0 0 1-6.84 1.045Q6.52 17.48 4.46 16.84A3.5 3.5 0 0 1 5.5 10Z"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "9G_0");
const LuPcCase = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "20",
      rx: "2",
      width: "14",
      x: "5",
      y: "2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M15 14h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 6h6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 10h6"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "PC_0");
const LuPenLine = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 20h9"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4Z"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "bd_0");
const LuPenSquare = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18.5 2.5a2.12 2.12 0 0 1 3 3L12 15l-4 1 1-4Z"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "yZ_0");
const LuPenTool = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m12 19 7-7 3 3-7 7-3-3z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m18 13-1.5-7.5L2 2l3.5 14.5L13 18l5-5z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m2 2 7.586 7.586"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "11",
      cy: "11",
      r: "2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "ex_0");
const LuPen = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: /* @__PURE__ */ _jsxQ("path", null, {
    d: "M17 3a2.85 2.83 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5Z"
  }, null, 3, null)
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "GN_0");
const LuPencilLine = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 20h9"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m15 5 3 3"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "XM_0");
const LuPencilRuler = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m15 5 4 4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M13 7 8.7 2.7a2.41 2.41 0 0 0-3.4 0L2.7 5.3a2.41 2.41 0 0 0 0 3.4L7 13"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m8 6 2-2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m2 22 5.5-1.5L21.17 6.83a2.82 2.82 0 0 0-4-4L3.5 16.5Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m18 16 2-2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m17 11 4.3 4.3c.94.94.94 2.46 0 3.4l-2.6 2.6c-.94.94-2.46.94-3.4 0L11 17"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "tF_0");
const LuPencil = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17 3a2.85 2.83 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m15 5 4 4"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "eG_0");
const LuPentagon = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: /* @__PURE__ */ _jsxQ("path", null, {
    d: "M3.5 8.7c-.7.5-1 1.4-.7 2.2l2.8 8.7c.3.8 1 1.4 1.9 1.4h9.1c.9 0 1.6-.6 1.9-1.4l2.8-8.7c.3-.8 0-1.7-.7-2.2l-7.4-5.3a2.1 2.1 0 0 0-2.4 0Z"
  }, null, 3, null)
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "IP_0");
const LuPercentCircle = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m15 9-6 6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 9h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M15 15h.01"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "cf_0");
const LuPercentDiamond = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2.7 10.3a2.41 2.41 0 0 0 0 3.41l7.59 7.59a2.41 2.41 0 0 0 3.41 0l7.59-7.59a2.41 2.41 0 0 0 0-3.41L13.7 2.71a2.41 2.41 0 0 0-3.41 0Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9.2 9.2h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m14.5 9.5-5 5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14.7 14.8h.01"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "i0_0");
const LuPercentSquare = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "18",
      rx: "2",
      width: "18",
      x: "3",
      y: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m15 9-6 6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 9h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M15 15h.01"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "eN_0");
const LuPercent = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "19",
      x2: "5",
      y1: "5",
      y2: "19"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "6.5",
      cy: "6.5",
      r: "2.5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "17.5",
      cy: "17.5",
      r: "2.5"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "o0_0");
const LuPersonStanding = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "5",
      r: "1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m9 20 3-6 3 6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m6 8 6 2 6-2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 10v4"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "NE_0");
const LuPhoneCall = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14.05 2a9 9 0 0 1 8 7.94"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14.05 6A5 5 0 0 1 18 10"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "jL_0");
const LuPhoneForwarded = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "18 2 22 6 18 10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "14",
      x2: "22",
      y1: "6",
      y2: "6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "O8_0");
const LuPhoneIncoming = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "16 2 16 8 22 8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "22",
      x2: "16",
      y1: "2",
      y2: "8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "tD_0");
const LuPhoneMissed = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "22",
      x2: "16",
      y1: "2",
      y2: "8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "16",
      x2: "22",
      y1: "2",
      y2: "8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "22_0");
const LuPhoneOff = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10.68 13.31a16 16 0 0 0 3.41 2.6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7 2 2 0 0 1 1.72 2v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.42 19.42 0 0 1-3.33-2.67m-2.67-3.34a19.79 19.79 0 0 1-3.07-8.63A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "22",
      x2: "2",
      y1: "2",
      y2: "22"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Ex_0");
const LuPhoneOutgoing = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "22 8 22 2 16 2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "16",
      x2: "22",
      y1: "8",
      y2: "2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "FJ_0");
const LuPhone = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: /* @__PURE__ */ _jsxQ("path", null, {
    d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
  }, null, 3, null)
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Hq_0");
const LuPiSquare = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "18",
      rx: "2",
      width: "18",
      x: "3",
      y: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 7h10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10 7v10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 17a2 2 0 0 1-2-2V7"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "l6_0");
const LuPi = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "9",
      x2: "9",
      y1: "4",
      y2: "20"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 7c0-1.7 1.3-3 3-3h13"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18 20c-1.7 0-3-1.3-3-3V4"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Rl_0");
const LuPictureInPicture2 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 9V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v10c0 1.1.9 2 2 2h4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "7",
      rx: "2",
      width: "10",
      x: "12",
      y: "13"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "mS_0");
const LuPictureInPicture = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 4.5v5H3m-1-6 6 6m13 0v-3c0-1.16-.84-2-2-2h-7m-9 9v2c0 1.05.95 2 2 2h3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "7",
      ry: "2",
      width: "10",
      x: "12",
      y: "13.5"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "rb_0");
const LuPieChart = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21.21 15.89A10 10 0 1 1 8 2.83"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M22 12A10 10 0 0 0 12 2v10z"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "HH_0");
const LuPiggyBank = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M19 5c-1.5 0-2.8 1.4-3 2-3.5-1.5-11-.3-11 5 0 1.8 0 3 2 4.5V20h4v-2h3v2h4v-4c1-.5 1.7-1 2-2h2v-4h-2c0-1-.5-1.5-1-2h0V5z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 9v1c0 1.1.9 2 2 2h1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 11h0"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "qN_0");
const LuPilcrowSquare = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "18",
      rx: "2",
      width: "18",
      x: "3",
      y: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 12H9.5a2.5 2.5 0 0 1 0-5H17"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 7v10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 7v10"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Fk_0");
const LuPilcrow = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M13 4v16"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17 4v16"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M19 4H9.5a4.5 4.5 0 0 0 0 9H13"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "3Y_0");
const LuPill = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m10.5 20.5 10-10a4.95 4.95 0 1 0-7-7l-10 10a4.95 4.95 0 1 0 7 7Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m8.5 8.5 7 7"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "b5_0");
const LuPinOff = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "2",
      x2: "22",
      y1: "2",
      y2: "22"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "12",
      x2: "12",
      y1: "17",
      y2: "22"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 9v1.76a2 2 0 0 1-1.11 1.79l-1.78.9A2 2 0 0 0 5 15.24V17h12"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M15 9.34V6h1a2 2 0 0 0 0-4H7.89"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "C8_0");
const LuPin = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "12",
      x2: "12",
      y1: "17",
      y2: "22"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M5 17h14v-1.76a2 2 0 0 0-1.11-1.79l-1.78-.9A2 2 0 0 1 15 10.76V6h1a2 2 0 0 0 0-4H8a2 2 0 0 0 0 4h1v4.76a2 2 0 0 1-1.11 1.79l-1.78.9A2 2 0 0 0 5 15.24Z"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Kq_0");
const LuPipette = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m2 22 1-1h3l9-9"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 21v-3l9-9"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m15 6 3.4-3.4a2.1 2.1 0 1 1 3 3L18 9l.4.4a2.1 2.1 0 1 1-3 3l-3.8-3.8a2.1 2.1 0 1 1 3-3l.4.4Z"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Ri_0");
const LuPizza = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M15 11h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M11 15h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 16h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m2 16 20 6-6-20A20 20 0 0 0 2 16"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M5.71 17.11a17.04 17.04 0 0 1 11.4-11.4"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "RQ_0");
const LuPlaneLanding = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 22h20"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3.77 10.77 2 9l2-4.5 1.1.55c.55.28.9.84.9 1.45s.35 1.17.9 1.45L8 8.5l3-6 1.05.53a2 2 0 0 1 1.09 1.52l.72 5.4a2 2 0 0 0 1.09 1.52l4.4 2.2c.42.22.78.55 1.01.96l.6 1.03c.49.88-.06 1.98-1.06 2.1l-1.18.15c-.47.06-.95-.02-1.37-.24L4.29 11.15a2 2 0 0 1-.52-.38Z"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "ss_0");
const LuPlaneTakeoff = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 22h20"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6.36 17.4 4 17l-2-4 1.1-.55a2 2 0 0 1 1.8 0l.17.1a2 2 0 0 0 1.8 0L8 12 5 6l.9-.45a2 2 0 0 1 2.09.2l4.02 3a2 2 0 0 0 2.1.2l4.19-2.06a2.41 2.41 0 0 1 1.73-.17L21 7a1.4 1.4 0 0 1 .87 1.99l-.38.76c-.23.46-.6.84-1.07 1.08L7.58 17.2a2 2 0 0 1-1.22.18Z"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "4M_0");
const LuPlane = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: /* @__PURE__ */ _jsxQ("path", null, {
    d: "M17.8 19.2 16 11l3.5-3.5C21 6 21.5 4 21 3c-1-.5-3 0-4.5 1.5L13 8 4.8 6.2c-.5-.1-.9.1-1.1.5l-.3.5c-.2.5-.1 1 .3 1.3L9 12l-2 3H4l-1 1 3 2 2 3 1-1v-3l3-2 3.5 5.3c.3.4.8.5 1.3.3l.5-.2c.4-.3.6-.7.5-1.2z"
  }, null, 3, null)
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "ut_0");
const LuPlayCircle = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polygon", null, {
      points: "10 8 16 12 10 16 10 8"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Ks_0");
const LuPlaySquare = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "18",
      rx: "2",
      width: "18",
      x: "3",
      y: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m9 8 6 4-6 4Z"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "f0_0");
const LuPlay = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: /* @__PURE__ */ _jsxQ("polygon", null, {
    points: "5 3 19 12 5 21 5 3"
  }, null, 3, null)
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Ic_0");
const LuPlug2 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 2v6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M15 2v6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 17v5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M5 8h14"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6 11V8h12v3a6 6 0 1 1-12 0v0Z"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Cr_0");
const LuPlugZap2 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m13 2-2 2.5h3L12 7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10 14v-3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14 14v-3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M11 19c-1.7 0-3-1.3-3-3v-2h8v2c0 1.7-1.3 3-3 3Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 22v-3"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Sq_0");
const LuPlugZap = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6.3 20.3a2.4 2.4 0 0 0 3.4 0L12 18l-6-6-2.3 2.3a2.4 2.4 0 0 0 0 3.4Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m2 22 3-3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7.5 13.5 10 11"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10.5 16.5 13 14"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m18 3-4 4h6l-4 4"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "MB_0");
const LuPlug = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 22v-5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 8V2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M15 8V2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18 8v5a4 4 0 0 1-4 4h-4a4 4 0 0 1-4-4V8Z"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "pX_0");
const LuPlusCircle = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 12h8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 8v8"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "wr_0");
const LuPlusSquare = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "18",
      rx: "2",
      width: "18",
      x: "3",
      y: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 12h8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 8v8"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "PM_0");
const LuPlus = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M5 12h14"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 5v14"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Z7_0");
const LuPocketKnife = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 2v1c0 1 2 1 2 2S3 6 3 7s2 1 2 2-2 1-2 2 2 1 2 2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18 6h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6 18h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M20.83 8.83a4 4 0 0 0-5.66-5.66l-12 12a4 4 0 1 0 5.66 5.66Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18 11.66V22a4 4 0 0 0 4-4V6"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Ax_0");
const LuPocket = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 3h16a2 2 0 0 1 2 2v6a10 10 0 0 1-10 10A10 10 0 0 1 2 11V5a2 2 0 0 1 2-2z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "8 10 12 14 16 10"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "2H_0");
const LuPodcast = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "11",
      r: "1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M11 17a1 1 0 0 1 2 0c0 .5-.34 3-.5 4.5a.5.5 0 0 1-1 0c-.16-1.5-.5-4-.5-4.5Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 14a5 5 0 1 1 8 0"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17 18.5a9 9 0 1 0-10 0"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "d7_0");
const LuPointer = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M22 14a8 8 0 0 1-8 8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18 11v-1a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v0"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14 10V9a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10 9.5V4a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18 11a2 2 0 1 1 4 0v3a8 8 0 0 1-8 8h-2c-2.8 0-4.5-.86-5.99-2.34l-3.6-3.6a2 2 0 0 1 2.83-2.82L7 15"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "p8_0");
const LuPopcorn = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18 8a2 2 0 0 0 0-4 2 2 0 0 0-4 0 2 2 0 0 0-4 0 2 2 0 0 0-4 0 2 2 0 0 0 0 4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10 22 9 8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m14 22 1-14"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M20 8c.5 0 .9.4.8 1l-2.6 12c-.1.5-.7 1-1.2 1H7c-.6 0-1.1-.4-1.2-1L3.2 9c-.1-.6.3-1 .8-1Z"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "RL_0");
const LuPopsicle = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18.6 14.4c.8-.8.8-2 0-2.8l-8.1-8.1a4.95 4.95 0 1 0-7.1 7.1l8.1 8.1c.9.7 2.1.7 2.9-.1Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m22 22-5.5-5.5"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "mt_0");
const LuPoundSterling = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18 7c0-5.333-8-5.333-8 0"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10 7v14"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6 21h12"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6 13h10"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "t1_0");
const LuPowerOff = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18.36 6.64A9 9 0 0 1 20.77 15"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6.16 6.16a9 9 0 1 0 12.68 12.68"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 2v4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m2 2 20 20"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "2w_0");
const LuPower = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18.36 6.64a9 9 0 1 1-12.73 0"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "12",
      x2: "12",
      y1: "2",
      y2: "12"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "rG_0");
const LuPresentation = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 3h20"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 3v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m7 21 5-5 5 5"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Ws_0");
const LuPrinter = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "6 9 6 2 18 2 18 9"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "8",
      width: "12",
      x: "6",
      y: "14"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Ad_0");
const LuProjector = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M5 7 3 5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 6V3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m13 7 2-2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "9",
      cy: "13",
      r: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M11.83 12H20a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h2.17"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 16h2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Ow_0");
const LuPuzzle = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: /* @__PURE__ */ _jsxQ("path", null, {
    d: "M19.439 7.85c-.049.322.059.648.289.878l1.568 1.568c.47.47.706 1.087.706 1.704s-.235 1.233-.706 1.704l-1.611 1.611a.98.98 0 0 1-.837.276c-.47-.07-.802-.48-.968-.925a2.501 2.501 0 1 0-3.214 3.214c.446.166.855.497.925.968a.979.979 0 0 1-.276.837l-1.61 1.61a2.404 2.404 0 0 1-1.705.707 2.402 2.402 0 0 1-1.704-.706l-1.568-1.568a1.026 1.026 0 0 0-.877-.29c-.493.074-.84.504-1.02.968a2.5 2.5 0 1 1-3.237-3.237c.464-.18.894-.527.967-1.02a1.026 1.026 0 0 0-.289-.877l-1.568-1.568A2.402 2.402 0 0 1 1.998 12c0-.617.236-1.234.706-1.704L4.23 8.77c.24-.24.581-.353.917-.303.515.077.877.528 1.073 1.01a2.5 2.5 0 1 0 3.259-3.259c-.482-.196-.933-.558-1.01-1.073-.05-.336.062-.676.303-.917l1.525-1.525A2.402 2.402 0 0 1 12 1.998c.617 0 1.234.236 1.704.706l1.568 1.568c.23.23.556.338.877.29.493-.074.84-.504 1.02-.968a2.5 2.5 0 1 1 3.237 3.237c-.464.18-.894.527-.967 1.02Z"
  }, null, 3, null)
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "X7_0");
const LuPyramid = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2.5 16.88a1 1 0 0 1-.32-1.43l9-13.02a1 1 0 0 1 1.64 0l9 13.01a1 1 0 0 1-.32 1.44l-8.51 4.86a2 2 0 0 1-1.98 0Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 2v20"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "By_0");
const LuQrCode = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "5",
      rx: "1",
      width: "5",
      x: "3",
      y: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "5",
      rx: "1",
      width: "5",
      x: "16",
      y: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "5",
      rx: "1",
      width: "5",
      x: "3",
      y: "16"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 16h-3a2 2 0 0 0-2 2v3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 21v.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 7v3a2 2 0 0 1-2 2H7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 12h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 3h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 16v.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 12h1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 12v.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 21v-1"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "q6_0");
const LuQuote = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 21c3 0 7-1 7-8V5c0-1.25-.756-2.017-2-2H4c-1.25 0-2 .75-2 1.972V11c0 1.25.75 2 2 2 1 0 1 0 1 1v1c0 1-1 2-2 2s-1 .008-1 1.031V20c0 1 0 1 1 1z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M15 21c3 0 7-1 7-8V5c0-1.25-.757-2.017-2-2h-4c-1.25 0-2 .75-2 1.972V11c0 1.25.75 2 2 2h.75c0 2.25.25 4-2.75 4v3c0 1 0 1 1 1z"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "SW_0");
const LuRabbit = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M20 8.54V4a2 2 0 1 0-4 0v3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18 21h-8a4 4 0 0 1-4-4 7 7 0 0 1 7-7h.2L9.6 6.4a1.93 1.93 0 1 1 2.8-2.8L15.8 7h.2c3.3 0 6 2.7 6 6v1a2 2 0 0 1-2 2h-1c-1.7 0-3 1.3-3 3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7.61 12.53a3 3 0 1 0-1.6 4.3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M13 16a3 3 0 0 1 2.24 5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18 12h.01"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "lj_0");
const LuRadar = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M19.07 4.93A10 10 0 0 0 6.99 3.34"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 6h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2.29 9.62A10 10 0 1 0 21.31 8.35"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16.24 7.76A6 6 0 1 0 8.23 16.67"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 18h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17.99 11.66A6 6 0 0 1 15.77 16.67"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m13.41 10.59 5.66-5.66"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Gb_0");
const LuRadiation = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 12h0"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7.5 4.2c-.3-.5-.9-.7-1.3-.4C3.9 5.5 2.3 8.1 2 11c-.1.5.4 1 1 1h5c0-1.5.8-2.8 2-3.4-1.1-1.9-2-3.5-2.5-4.4z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 12c.6 0 1-.4 1-1-.3-2.9-1.8-5.5-4.1-7.1-.4-.3-1.1-.2-1.3.3-.6.9-1.5 2.5-2.6 4.3 1.2.7 2 2 2 3.5h5z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7.5 19.8c-.3.5-.1 1.1.4 1.3 2.6 1.2 5.6 1.2 8.2 0 .5-.2.7-.8.4-1.3-.5-.9-1.4-2.5-2.5-4.3-1.2.7-2.8.7-4 0-1.1 1.8-2 3.4-2.5 4.3z"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "vH_0");
const LuRadioReceiver = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M5 16v2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M19 16v2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "8",
      rx: "2",
      width: "20",
      x: "2",
      y: "8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18 12h0"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "3Y_0");
const LuRadioTower = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4.9 16.1C1 12.2 1 5.8 4.9 1.9"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7.8 4.7a6.14 6.14 0 0 0-.8 7.5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "9",
      r: "2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16.2 4.8c2 2 2.26 5.11.8 7.47"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M19.1 1.9a9.96 9.96 0 0 1 0 14.1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9.5 18h5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m8 22 4-11 4 11"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "ty_0");
const LuRadio = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4.9 19.1C1 15.2 1 8.8 4.9 4.9"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7.8 16.2c-2.3-2.3-2.3-6.1 0-8.5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16.2 7.8c2.3 2.3 2.3 6.1 0 8.5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M19.1 4.9C23 8.8 23 15.1 19.1 19"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "XQ_0");
const LuRadius = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M20.34 17.52a10 10 0 1 0-2.82 2.82"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "19",
      cy: "19",
      r: "2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m13.41 13.41 4.18 4.18"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "kR_0");
const LuRailSymbol = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M5 15h14"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M5 9h14"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m14 20-5-5 6-6-5-5"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "u6_0");
const LuRainbow = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M22 17a10 10 0 0 0-20 0"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6 17a6 6 0 0 1 12 0"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10 17a2 2 0 0 1 4 0"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Ks_0");
const LuRat = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17 5c0-1.7-1.3-3-3-3s-3 1.3-3 3c0 .8.3 1.5.8 2H11c-3.9 0-7 3.1-7 7v0c0 2.2 1.8 4 4 4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16.8 3.9c.3-.3.6-.5 1-.7 1.5-.6 3.3.1 3.9 1.6.6 1.5-.1 3.3-1.6 3.9l1.6 2.8c.2.3.2.7.2 1-.2.8-.9 1.2-1.7 1.1 0 0-1.6-.3-2.7-.6H17c-1.7 0-3 1.3-3 3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M13.2 18a3 3 0 0 0-2.2-5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M13 22H4a2 2 0 0 1 0-4h12"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 9h.01"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Dy_0");
const LuRatio = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "20",
      rx: "2",
      width: "12",
      x: "6",
      y: "2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "12",
      rx: "2",
      width: "20",
      x: "2",
      y: "6"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Qb_0");
const LuReceipt = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1-2-1Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 17V7"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Wv_0");
const LuRectangleHorizontal = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: /* @__PURE__ */ _jsxQ("rect", null, {
    height: "12",
    rx: "2",
    width: "20",
    x: "2",
    y: "6"
  }, null, 3, null)
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Zt_0");
const LuRectangleVertical = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: /* @__PURE__ */ _jsxQ("rect", null, {
    height: "20",
    rx: "2",
    width: "12",
    x: "6",
    y: "2"
  }, null, 3, null)
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "yv_0");
const LuRecycle = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 19H4.815a1.83 1.83 0 0 1-1.57-.881 1.785 1.785 0 0 1-.004-1.784L7.196 9.5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M11 19h8.203a1.83 1.83 0 0 0 1.556-.89 1.784 1.784 0 0 0 0-1.775l-1.226-2.12"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m14 16-3 3 3 3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8.293 13.596 7.196 9.5 3.1 10.598"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m9.344 5.811 1.093-1.892A1.83 1.83 0 0 1 11.985 3a1.784 1.784 0 0 1 1.546.888l3.943 6.843"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m13.378 9.633 4.096 1.098 1.097-4.096"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "mJ_0");
const LuRedo2 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m15 14 5-5-5-5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M20 9H9.5A5.5 5.5 0 0 0 4 14.5v0A5.5 5.5 0 0 0 9.5 20H13"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "0K_0");
const LuRedoDot = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "17",
      r: "1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 7v6h-6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 17a9 9 0 0 1 9-9 9 9 0 0 1 6 2.3l3 2.7"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "8P_0");
const LuRedo = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 7v6h-6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 17a9 9 0 0 1 9-9 9 9 0 0 1 6 2.3l3 2.7"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "PP_0");
const LuRefreshCcwDot = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 2v6h6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 12A9 9 0 0 0 6 5.3L3 8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 22v-6h-6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 12a9 9 0 0 0 15 6.7l3-2.7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "1"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "d3_0");
const LuRefreshCcw = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 12a9 9 0 0 0-9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 3v5h5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 12a9 9 0 0 0 9 9 9.75 9.75 0 0 0 6.74-2.74L21 16"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 16h5v5"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "CE_0");
const LuRefreshCwOff = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 8L18.74 5.74A9.75 9.75 0 0 0 12 3C11 3 10.03 3.16 9.13 3.47"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 16H3v5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 12C3 9.51 4 7.26 5.64 5.64"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m3 16 2.26 2.26A9.75 9.75 0 0 0 12 21c2.49 0 4.74-1 6.36-2.64"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 12c0 1-.16 1.97-.47 2.87"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 3v5h-5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M22 22 2 2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Ge_0");
const LuRefreshCw = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 3v5h-5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 16H3v5"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "qP_0");
const LuRefrigerator = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M5 6a4 4 0 0 1 4-4h6a4 4 0 0 1 4 4v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M5 10h14"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M15 7v6"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "8u_0");
const LuRegex = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17 3v10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m12.67 5.5 8.66 5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m12.67 10.5 8.66-5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 17a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-2z"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Fn_0");
const LuRemoveFormatting = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 7V4h16v3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M5 20h6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M13 4 8 20"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m15 15 5 5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m20 15-5 5"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "pC_0");
const LuRepeat1 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m17 2 4 4-4 4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 11v-1a4 4 0 0 1 4-4h14"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m7 22-4-4 4-4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 13v1a4 4 0 0 1-4 4H3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M11 10h1v4"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "VA_0");
const LuRepeat2 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m2 9 3-3 3 3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M13 18H7a2 2 0 0 1-2-2V6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m22 15-3 3-3-3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M11 6h6a2 2 0 0 1 2 2v10"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "f0_0");
const LuRepeat = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m17 2 4 4-4 4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 11v-1a4 4 0 0 1 4-4h14"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m7 22-4-4 4-4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 13v1a4 4 0 0 1-4 4H3"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "hL_0");
const LuReplaceAll = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14 4c0-1.1.9-2 2-2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M20 2c1.1 0 2 .9 2 2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M22 8c0 1.1-.9 2-2 2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 10c-1.1 0-2-.9-2-2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m3 7 3 3 3-3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6 10V5c0-1.7 1.3-3 3-3h1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "8",
      rx: "2",
      width: "8",
      x: "2",
      y: "14"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14 14c1.1 0 2 .9 2 2v4c0 1.1-.9 2-2 2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M20 14c1.1 0 2 .9 2 2v4c0 1.1-.9 2-2 2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "9M_0");
const LuReplace = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14 4c0-1.1.9-2 2-2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M20 2c1.1 0 2 .9 2 2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M22 8c0 1.1-.9 2-2 2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 10c-1.1 0-2-.9-2-2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m3 7 3 3 3-3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6 10V5c0-1.7 1.3-3 3-3h1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "8",
      rx: "2",
      width: "8",
      x: "2",
      y: "14"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Sl_0");
const LuReplyAll = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "7 17 2 12 7 7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "12 17 7 12 12 7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M22 18v-2a4 4 0 0 0-4-4H7"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Nr_0");
const LuReply = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "9 17 4 12 9 7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M20 18v-2a4 4 0 0 0-4-4H4"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "F4_0");
const LuRewind = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("polygon", null, {
      points: "11 19 2 12 11 5 11 19"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polygon", null, {
      points: "22 19 13 12 22 5 22 19"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Yx_0");
const LuRocket = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "J0_0");
const LuRockingChair = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "3.5 2 6.5 12.5 18 12.5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "9.5",
      x2: "5.5",
      y1: "12.5",
      y2: "20"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "15",
      x2: "18.5",
      y1: "12.5",
      y2: "20"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2.75 18a13 13 0 0 0 18.5 0"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Vr_0");
const LuRollerCoaster = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6 19V5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10 19V6.8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14 19v-7.8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18 5v4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18 19v-6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M22 19V9"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 19V9a4 4 0 0 1 4-4c2 0 4 1.33 6 4s4 4 6 4a4 4 0 1 0-3-6.65"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "xG_0");
const LuRotate3D = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16.466 7.5C15.643 4.237 13.952 2 12 2 9.239 2 7 6.477 7 12s2.239 10 5 10c.342 0 .677-.069 1-.2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m15.194 13.707 3.814 1.86-1.86 3.814"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M19 15.57c-1.804.885-4.274 1.43-7 1.43-5.523 0-10-2.239-10-5s4.477-5 10-5c4.838 0 8.873 1.718 9.8 4"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "mf_0");
const LuRotateCcw = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 3v5h5"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "5F_0");
const LuRotateCw = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 12a9 9 0 1 1-9-9c2.52 0 4.93 1 6.74 2.74L21 8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 3v5h-5"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "hB_0");
const LuRouteOff = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "6",
      cy: "19",
      r: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 19h8.5c.4 0 .9-.1 1.3-.2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M5.2 5.2A3.5 3.53 0 0 0 6.5 12H12"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m2 2 20 20"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 15.3a3.5 3.5 0 0 0-3.3-3.3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M15 5h-4.3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "18",
      cy: "5",
      r: "3"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "0O_0");
const LuRoute = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "6",
      cy: "19",
      r: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 19h8.5a3.5 3.5 0 0 0 0-7h-11a3.5 3.5 0 0 1 0-7H15"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "18",
      cy: "5",
      r: "3"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "c0_0");
const LuRouter = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "8",
      rx: "2",
      width: "20",
      x: "2",
      y: "14"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6.01 18H6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10.01 18H10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M15 10v4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17.84 7.17a4 4 0 0 0-5.66 0"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M20.66 4.34a8 8 0 0 0-11.31 0"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Ed_0");
const LuRows = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "18",
      rx: "2",
      ry: "2",
      width: "18",
      x: "3",
      y: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "3",
      x2: "21",
      y1: "12",
      y2: "12"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "y8_0");
const LuRss = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 11a9 9 0 0 1 9 9"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 4a16 16 0 0 1 16 16"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "5",
      cy: "19",
      r: "1"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "qf_0");
const LuRuler = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21.3 15.3a2.4 2.4 0 0 1 0 3.4l-2.6 2.6a2.4 2.4 0 0 1-3.4 0L2.7 8.7a2.41 2.41 0 0 1 0-3.4l2.6-2.6a2.41 2.41 0 0 1 3.4 0Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m14.5 12.5 2-2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m11.5 9.5 2-2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m8.5 6.5 2-2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m17.5 15.5 2-2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Tk_0");
const LuRussianRuble = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6 11h8a4 4 0 0 0 0-8H9v18"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6 15h8"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "0h_0");
const LuSailboat = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M22 18H2a4 4 0 0 0 4 4h12a4 4 0 0 0 4-4Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 14 10 2 3 14h18Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10 2v16"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Gk_0");
const LuSalad = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 21h10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 21a9 9 0 0 0 9-9H3a9 9 0 0 0 9 9Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M11.38 12a2.4 2.4 0 0 1-.4-4.77 2.4 2.4 0 0 1 3.2-2.77 2.4 2.4 0 0 1 3.47-.63 2.4 2.4 0 0 1 3.37 3.37 2.4 2.4 0 0 1-1.1 3.7 2.51 2.51 0 0 1 .03 1.1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m13 12 4-4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10.9 7.25A3.99 3.99 0 0 0 4 10c0 .73.2 1.41.54 2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Nr_0");
const LuSandwich = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 11v3a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 19H4a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-3.83"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m3 11 7.77-6.04a2 2 0 0 1 2.46 0L21 11H3Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12.97 19.77 7 15h12.5l-3.75 4.5a2 2 0 0 1-2.78.27Z"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Xn_0");
const LuSatelliteDish = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 10a7.31 7.31 0 0 0 10 10Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m9 15 3-3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17 13a6 6 0 0 0-6-6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 13A10 10 0 0 0 11 3"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Ub_0");
const LuSatellite = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M13 7 9 3 5 7l4 4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m17 11 4 4-4 4-4-4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m8 12 4 4 6-6-4-4Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m16 8 3-3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 21a6 6 0 0 0-6-6"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "0b_0");
const LuSaveAll = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6 4a2 2 0 0 1 2-2h10l4 4v10.2a2 2 0 0 1-2 1.8H8a2 2 0 0 1-2-2Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10 2v4h6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18 18v-7h-8v7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18 22H4a2 2 0 0 1-2-2V6"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "KR_0");
const LuSave = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "17 21 17 13 7 13 7 21"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "7 3 7 8 15 8"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Jw_0");
const LuScale3D = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "19",
      cy: "19",
      r: "2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "5",
      cy: "5",
      r: "2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M5 7v12h12"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m5 19 6-6"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Wj_0");
const LuScale = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m16 16 3-8 3 8c-.87.65-1.92 1-3 1s-2.13-.35-3-1Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m2 16 3-8 3 8c-.87.65-1.92 1-3 1s-2.13-.35-3-1Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 21h10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 3v18"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 7h2c2 0 5-1 7-2 2 1 5 2 7 2h2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "GK_0");
const LuScaling = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 3 9 15"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 3H3v18h18v-9"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 3h5v5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14 15H9v-5"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "nW_0");
const LuScanBarcode = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 7V5a2 2 0 0 1 2-2h2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17 3h2a2 2 0 0 1 2 2v2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 17v2a2 2 0 0 1-2 2h-2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 21H5a2 2 0 0 1-2-2v-2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 7v10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 7v10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17 7v10"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "At_0");
const LuScanEye = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 7V5a2 2 0 0 1 2-2h2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17 3h2a2 2 0 0 1 2 2v2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 17v2a2 2 0 0 1-2 2h-2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 21H5a2 2 0 0 1-2-2v-2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M5 12s2.5-5 7-5 7 5 7 5-2.5 5-7 5-7-5-7-5"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "pC_0");
const LuScanFace = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 7V5a2 2 0 0 1 2-2h2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17 3h2a2 2 0 0 1 2 2v2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 17v2a2 2 0 0 1-2 2h-2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 21H5a2 2 0 0 1-2-2v-2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 14s1.5 2 4 2 4-2 4-2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 9h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M15 9h.01"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "YJ_0");
const LuScanLine = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 7V5a2 2 0 0 1 2-2h2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17 3h2a2 2 0 0 1 2 2v2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 17v2a2 2 0 0 1-2 2h-2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 21H5a2 2 0 0 1-2-2v-2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 12h10"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "fN_0");
const LuScanSearch = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 7V5a2 2 0 0 1 2-2h2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17 3h2a2 2 0 0 1 2 2v2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 17v2a2 2 0 0 1-2 2h-2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 21H5a2 2 0 0 1-2-2v-2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m16 16-1.9-1.9"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "0k_0");
const LuScanText = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 7V5a2 2 0 0 1 2-2h2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17 3h2a2 2 0 0 1 2 2v2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 17v2a2 2 0 0 1-2 2h-2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 21H5a2 2 0 0 1-2-2v-2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 8h8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 12h10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 16h6"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "L3_0");
const LuScan = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 7V5a2 2 0 0 1 2-2h2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17 3h2a2 2 0 0 1 2 2v2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 17v2a2 2 0 0 1-2 2h-2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 21H5a2 2 0 0 1-2-2v-2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "60_0");
const LuScatterChart = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "7.5",
      cy: "7.5",
      r: ".5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "18.5",
      cy: "5.5",
      r: ".5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "11.5",
      cy: "11.5",
      r: ".5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "7.5",
      cy: "16.5",
      r: ".5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "17.5",
      cy: "14.5",
      r: ".5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 3v18h18"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "nQ_0");
const LuSchool2 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "10",
      r: "1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M22 20V8h-4l-6-4-6 4H2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6 17v.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6 13v.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18 17v.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18 13v.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14 22v-5a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v5"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "uL_0");
const LuSchool = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m4 6 8-4 8 4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m18 10 4 2v8a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-8l4-2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14 22v-4a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18 5v17"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6 5v17"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "9",
      r: "2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "yC_0");
const LuScissorsLineDashed = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M5.42 9.42 8 12"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "4",
      cy: "8",
      r: "2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m14 6-8.58 8.58"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "4",
      cy: "16",
      r: "2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10.8 14.8 14 18"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 12h-2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M22 12h-2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "qm_0");
const LuScissorsSquareDashedBottom = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10 22H8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 22h-2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "8",
      cy: "8",
      r: "2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9.414 9.414 12 12"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14.8 14.8 18 18"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "8",
      cy: "16",
      r: "2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m18 6-8.586 8.586"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "4b_0");
const LuScissorsSquare = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "20",
      rx: "2",
      width: "20",
      x: "2",
      y: "2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "8",
      cy: "8",
      r: "2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9.414 9.414 12 12"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14.8 14.8 18 18"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "8",
      cy: "16",
      r: "2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m18 6-8.586 8.586"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "qB_0");
const LuScissors = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "6",
      cy: "6",
      r: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8.12 8.12 12 12"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M20 4 8.12 15.88"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "6",
      cy: "18",
      r: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14.8 14.8 20 20"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "k8_0");
const LuScreenShareOff = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M13 3H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 21h8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 17v4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m22 3-5 5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m17 3 5 5"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "CR_0");
const LuScreenShare = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M13 3H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 21h8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 17v4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m17 8 5-5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17 3h5v5"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "U7_0");
const LuScrollText = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 21h12a2 2 0 0 0 2-2v-2H10v2a2 2 0 1 1-4 0V5a2 2 0 1 0-4 0v3h4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M19 17V5a2 2 0 0 0-2-2H4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M15 8h-5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M15 12h-5"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "0s_0");
const LuScroll = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 21h12a2 2 0 0 0 2-2v-2H10v2a2 2 0 1 1-4 0V5a2 2 0 1 0-4 0v3h4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M19 17V5a2 2 0 0 0-2-2H4"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "yp_0");
const LuSearchCheck = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m8 11 2 2 4-4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "11",
      cy: "11",
      r: "8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m21 21-4.3-4.3"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Ep_0");
const LuSearchCode = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m9 9-2 2 2 2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m13 13 2-2-2-2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "11",
      cy: "11",
      r: "8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m21 21-4.3-4.3"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "wX_0");
const LuSearchSlash = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m13.5 8.5-5 5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "11",
      cy: "11",
      r: "8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m21 21-4.3-4.3"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "gt_0");
const LuSearchX = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m13.5 8.5-5 5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m8.5 8.5 5 5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "11",
      cy: "11",
      r: "8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m21 21-4.3-4.3"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "FK_0");
const LuSearch = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "11",
      cy: "11",
      r: "8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m21 21-4.3-4.3"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "OE_0");
const LuSendHorizontal = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m3 3 3 9-3 9 19-9Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6 12h16"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "DB_0");
const LuSendToBack = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "8",
      rx: "2",
      width: "8",
      x: "14",
      y: "14"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "8",
      rx: "2",
      width: "8",
      x: "2",
      y: "2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 14v1a2 2 0 0 0 2 2h1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14 7h1a2 2 0 0 1 2 2v1"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "6k_0");
const LuSend = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m22 2-7 20-4-9-9-4Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M22 2 11 13"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Ll_0");
const LuSeparatorHorizontal = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "3",
      x2: "21",
      y1: "12",
      y2: "12"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "8 8 12 4 16 8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "16 16 12 20 8 16"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "of_0");
const LuSeparatorVertical = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "12",
      x2: "12",
      y1: "3",
      y2: "21"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "8 8 4 12 8 16"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "16 16 20 12 16 8"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "0D_0");
const LuServerCog = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4.5 10H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-.5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4.5 14H4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2h-.5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6 6h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6 18h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m15.7 13.4-.9-.3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m9.2 10.9-.9-.3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m10.6 15.7.3-.9"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m13.6 15.7-.4-1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m10.8 9.3-.4-1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m8.3 13.6 1-.4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m14.7 10.8 1-.4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m13.4 8.3-.3.9"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Wq_0");
const LuServerCrash = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6 10H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6 14H4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2h-2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6 6h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6 18h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m13 6-4 6h6l-4 6"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "g6_0");
const LuServerOff = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 2h13a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10 10 2.5 2.5C2 2 2 2.5 2 5v3a2 2 0 0 0 2 2h6z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M22 17v-1a2 2 0 0 0-2-2h-1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 14a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h16.5l1-.5.5.5-8-8H4z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6 18h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m2 2 20 20"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Fj_0");
const LuServer = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "8",
      rx: "2",
      ry: "2",
      width: "20",
      x: "2",
      y: "2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "8",
      rx: "2",
      ry: "2",
      width: "20",
      x: "2",
      y: "14"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "6",
      x2: "6.01",
      y1: "6",
      y2: "6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "6",
      x2: "6.01",
      y1: "18",
      y2: "18"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "To_0");
const LuSettings2 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M20 7h-9"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14 17H5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "17",
      cy: "17",
      r: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "7",
      cy: "7",
      r: "3"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "DA_0");
const LuSettings = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "3"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "xG_0");
const LuShapes = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8.3 10a.7.7 0 0 1-.626-1.079L11.4 3a.7.7 0 0 1 1.198-.043L16.3 8.9a.7.7 0 0 1-.572 1.1Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "7",
      rx: "1",
      width: "7",
      x: "3",
      y: "14"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "17.5",
      cy: "17.5",
      r: "3.5"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "3D_0");
const LuShare2 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "18",
      cy: "5",
      r: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "6",
      cy: "12",
      r: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "18",
      cy: "19",
      r: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "8.59",
      x2: "15.42",
      y1: "13.51",
      y2: "17.49"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "15.41",
      x2: "8.59",
      y1: "6.51",
      y2: "10.49"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "e5_0");
const LuShare = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "16 6 12 2 8 6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "12",
      x2: "12",
      y1: "2",
      y2: "15"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "OY_0");
const LuSheet = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "18",
      rx: "2",
      ry: "2",
      width: "18",
      x: "3",
      y: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "3",
      x2: "21",
      y1: "9",
      y2: "9"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "3",
      x2: "21",
      y1: "15",
      y2: "15"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "9",
      x2: "9",
      y1: "9",
      y2: "21"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "15",
      x2: "15",
      y1: "9",
      y2: "21"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "UN_0");
const LuShell = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: /* @__PURE__ */ _jsxQ("path", null, {
    d: "M14 11a2 2 0 1 1-4 0 4 4 0 0 1 8 0 6 6 0 0 1-12 0 8 8 0 0 1 16 0 10 10 0 1 1-20 0 11.93 11.93 0 0 1 2.42-7.22 2 2 0 1 1 3.16 2.44"
  }, null, 3, null)
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "MS_0");
const LuShieldAlert = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 8v4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 16h.01"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "CV_0");
const LuShieldBan = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m4 5 14 12"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "WD_0");
const LuShieldCheck = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m9 12 2 2 4-4"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "oN_0");
const LuShieldEllipsis = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 11h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 11h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 11h.01"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "P5_0");
const LuShieldHalf = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 22V2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "WD_0");
const LuShieldMinus = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 11h8"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "k2_0");
const LuShieldOff = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M19.7 14a6.9 6.9 0 0 0 .3-2V5l-8-3-3.2 1.2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m2 2 20 20"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4.7 4.7 4 5v7c0 6 8 10 8 10a20.3 20.3 0 0 0 5.62-4.38"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Ij_0");
const LuShieldPlus = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 11h8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 15V7"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "hv_0");
const LuShieldQuestion = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9.1 9a3 3 0 0 1 5.82 1c0 2-3 3-3 3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 17h.01"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "lv_0");
const LuShieldX = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m14.5 9-5 5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m9.5 9 5 5"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "cV_0");
const LuShield = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: /* @__PURE__ */ _jsxQ("path", null, {
    d: "M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10"
  }, null, 3, null)
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "nm_0");
const LuShipWheel = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 2v7.5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m19 5-5.23 5.23"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M22 12h-7.5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m19 19-5.23-5.23"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 14.5V22"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10.23 13.77 5 19"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9.5 12H2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10.23 10.23 5 5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "2.5"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Yi_0");
const LuShip = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 21c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1 .6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M19.38 20A11.6 11.6 0 0 0 21 14l-9-4-9 4c0 2.9.94 5.34 2.81 7.76"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M19 13V7a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 10v4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 2v3"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "zA_0");
const LuShirt = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: /* @__PURE__ */ _jsxQ("path", null, {
    d: "M20.38 3.46 16 2a4 4 0 0 1-8 0L3.62 3.46a2 2 0 0 0-1.34 2.23l.58 3.47a1 1 0 0 0 .99.84H6v10c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V10h2.15a1 1 0 0 0 .99-.84l.58-3.47a2 2 0 0 0-1.34-2.23z"
  }, null, 3, null)
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "p6_0");
const LuShoppingBag = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 6h18"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 10a4 4 0 0 1-8 0"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "vi_0");
const LuShoppingBasket = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m5 11 4-7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m19 11-4-7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 11h20"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m3.5 11 1.6 7.4a2 2 0 0 0 2 1.6h9.8c.9 0 1.8-.7 2-1.6l1.7-7.4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m9 11 1 9"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4.5 15.5h15"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m15 11-1 9"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "ns_0");
const LuShoppingCart = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "8",
      cy: "21",
      r: "1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "19",
      cy: "21",
      r: "1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "B4_0");
const LuShovel = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 22v-5l5-5 5 5-5 5z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9.5 14.5 16 8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m17 2 5 5-.5.5a3.53 3.53 0 0 1-5 0s0 0 0 0a3.53 3.53 0 0 1 0-5L17 2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "iD_0");
const LuShowerHead = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m4 4 2.5 2.5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M13.5 6.5a4.95 4.95 0 0 0-7 7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M15 5 5 15"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14 17v.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10 16v.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M13 13v.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 10v.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M11 20v.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17 14v.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M20 11v.01"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "1P_0");
const LuShrink = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m15 15 6 6m-6-6v4.8m0-4.8h4.8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 19.8V15m0 0H4.2M9 15l-6 6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M15 4.2V9m0 0h4.8M15 9l6-6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 4.2V9m0 0H4.2M9 9 3 3"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Wg_0");
const LuShrub = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 22v-7l-2-2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17 8v.8A6 6 0 0 1 13.8 20v0H10v0A6.5 6.5 0 0 1 7 8h0a5 5 0 0 1 10 0Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m14 14-2 2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "uu_0");
const LuShuffle = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 18h1.4c1.3 0 2.5-.6 3.3-1.7l6.1-8.6c.7-1.1 2-1.7 3.3-1.7H22"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m18 2 4 4-4 4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 6h1.9c1.5 0 2.9.9 3.6 2.2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M22 18h-5.9c-1.3 0-2.6-.7-3.3-1.8l-.5-.8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m18 14 4 4-4 4"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "lI_0");
const LuSigmaSquare = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "18",
      rx: "2",
      width: "18",
      x: "3",
      y: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 8.9V7H8l4 5-4 5h8v-1.9"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "ml_0");
const LuSigma = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: /* @__PURE__ */ _jsxQ("path", null, {
    d: "M18 7V4H6l6 8-6 8h12v-3"
  }, null, 3, null)
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "FL_0");
const LuSignalHigh = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 20h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 20v-4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 20v-8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17 20V8"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Cx_0");
const LuSignalLow = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 20h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 20v-4"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "cF_0");
const LuSignalMedium = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 20h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 20v-4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 20v-8"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "xv_0");
const LuSignalZero = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: /* @__PURE__ */ _jsxQ("path", null, {
    d: "M2 20h.01"
  }, null, 3, null)
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "3i_0");
const LuSignal = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 20h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 20v-4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 20v-8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17 20V8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M22 4v16"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "xA_0");
const LuSignpostBig = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10 9H4L2 7l2-2h6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14 5h6l2 2-2 2h-6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10 22V4a2 2 0 1 1 4 0v18"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 22h8"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "wy_0");
const LuSignpost = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 3v3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18.5 13h-13L2 9.5 5.5 6h13L22 9.5Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 13v8"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Hf_0");
const LuSiren = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 12a5 5 0 0 1 5-5v0a5 5 0 0 1 5 5v6H7v-6Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M5 20a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v2H5v-2Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 12h1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18.5 4.5 18 5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 12h1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 2v1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m4.929 4.929.707.707"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 12v6"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "k7_0");
const LuSkipBack = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("polygon", null, {
      points: "19 20 9 12 19 4 19 20"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "5",
      x2: "5",
      y1: "19",
      y2: "5"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "c3_0");
const LuSkipForward = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("polygon", null, {
      points: "5 4 15 12 5 20 5 4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "19",
      x2: "19",
      y1: "5",
      y2: "19"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "B0_0");
const LuSkull = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "9",
      cy: "12",
      r: "1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "15",
      cy: "12",
      r: "1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 20v2h8v-2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m12.5 17-.5-1-.5 1h1z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 20a2 2 0 0 0 1.56-3.25 8 8 0 1 0-11.12 0A2 2 0 0 0 8 20"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "nt_0");
const LuSlack = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "8",
      rx: "1.5",
      width: "3",
      x: "13",
      y: "2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M19 8.5V10h1.5A1.5 1.5 0 1 0 19 8.5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "8",
      rx: "1.5",
      width: "3",
      x: "8",
      y: "14"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M5 15.5V14H3.5A1.5 1.5 0 1 0 5 15.5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "3",
      rx: "1.5",
      width: "8",
      x: "14",
      y: "13"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M15.5 19H14v1.5a1.5 1.5 0 1 0 1.5-1.5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "3",
      rx: "1.5",
      width: "8",
      x: "2",
      y: "8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8.5 5H10V3.5A1.5 1.5 0 1 0 8.5 5"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "yK_0");
const LuSlash = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: /* @__PURE__ */ _jsxQ("path", null, {
    d: "M22 2 2 22"
  }, null, 3, null)
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "oI_0");
const LuSlice = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m8 14-6 6h9v-3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18.37 3.63 8 14l3 3L21.37 6.63a2.12 2.12 0 1 0-3-3Z"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "F2_0");
const LuSlidersHorizontal = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "21",
      x2: "14",
      y1: "4",
      y2: "4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "10",
      x2: "3",
      y1: "4",
      y2: "4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "21",
      x2: "12",
      y1: "12",
      y2: "12"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "8",
      x2: "3",
      y1: "12",
      y2: "12"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "21",
      x2: "16",
      y1: "20",
      y2: "20"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "12",
      x2: "3",
      y1: "20",
      y2: "20"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "14",
      x2: "14",
      y1: "2",
      y2: "6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "8",
      x2: "8",
      y1: "10",
      y2: "14"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "16",
      x2: "16",
      y1: "18",
      y2: "22"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "TO_0");
const LuSliders = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "4",
      x2: "4",
      y1: "21",
      y2: "14"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "4",
      x2: "4",
      y1: "10",
      y2: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "12",
      x2: "12",
      y1: "21",
      y2: "12"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "12",
      x2: "12",
      y1: "8",
      y2: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "20",
      x2: "20",
      y1: "21",
      y2: "16"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "20",
      x2: "20",
      y1: "12",
      y2: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "2",
      x2: "6",
      y1: "14",
      y2: "14"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "10",
      x2: "14",
      y1: "8",
      y2: "8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "18",
      x2: "22",
      y1: "16",
      y2: "16"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Sr_0");
const LuSmartphoneCharging = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "20",
      rx: "2",
      ry: "2",
      width: "14",
      x: "5",
      y: "2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12.667 8 10 12h4l-2.667 4"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "zC_0");
const LuSmartphoneNfc = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "12",
      rx: "1",
      width: "7",
      x: "2",
      y: "6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M13 8.32a7.43 7.43 0 0 1 0 7.36"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16.46 6.21a11.76 11.76 0 0 1 0 11.58"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M19.91 4.1a15.91 15.91 0 0 1 .01 15.8"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "6P_0");
const LuSmartphone = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "20",
      rx: "2",
      ry: "2",
      width: "14",
      x: "5",
      y: "2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 18h.01"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "3n_0");
const LuSmilePlus = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M22 11v1a10 10 0 1 1-9-10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 14s1.5 2 4 2 4-2 4-2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "9",
      x2: "9.01",
      y1: "9",
      y2: "9"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "15",
      x2: "15.01",
      y1: "9",
      y2: "9"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 5h6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M19 2v6"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Ge_0");
const LuSmile = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 14s1.5 2 4 2 4-2 4-2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "9",
      x2: "9.01",
      y1: "9",
      y2: "9"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "15",
      x2: "15.01",
      y1: "9",
      y2: "9"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "jr_0");
const LuSnail = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 13a6 6 0 1 0 12 0 4 4 0 1 0-8 0 2 2 0 0 0 4 0"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "10",
      cy: "13",
      r: "8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 21h12c4.4 0 8-3.6 8-8V7a2 2 0 1 0-4 0v6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18 3 19.1 5.2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M22 3 20.9 5.2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "RS_0");
const LuSnowflake = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "2",
      x2: "22",
      y1: "12",
      y2: "12"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "12",
      x2: "12",
      y1: "2",
      y2: "22"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m20 16-4-4 4-4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m4 8 4 4-4 4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m16 4-4 4-4-4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m8 20 4-4 4 4"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "W2_0");
const LuSofa = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M20 9V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 11v5a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-5a2 2 0 0 0-4 0v2H6v-2a2 2 0 0 0-4 0Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 18v2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M20 18v2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 4v9"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "ki_0");
const LuSoup = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 21a9 9 0 0 0 9-9H3a9 9 0 0 0 9 9Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 21h10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M19.5 12 22 6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16.25 3c.27.1.8.53.75 1.36-.06.83-.93 1.2-1 2.02-.05.78.34 1.24.73 1.62"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M11.25 3c.27.1.8.53.74 1.36-.05.83-.93 1.2-.98 2.02-.06.78.33 1.24.72 1.62"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6.25 3c.27.1.8.53.75 1.36-.06.83-.93 1.2-1 2.02-.05.78.34 1.24.74 1.62"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Ha_0");
const LuSpace = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: /* @__PURE__ */ _jsxQ("path", null, {
    d: "M22 17v1c0 .5-.5 1-1 1H3c-.5 0-1-.5-1-1v-1"
  }, null, 3, null)
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "wd_0");
const LuSpade = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M5 9c-1.5 1.5-3 3.2-3 5.5A5.5 5.5 0 0 0 7.5 20c1.8 0 3-.5 4.5-2 1.5 1.5 2.7 2 4.5 2a5.5 5.5 0 0 0 5.5-5.5c0-2.3-1.5-4-3-5.5l-7-7-7 7Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 18v4"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "EV_0");
const LuSparkle = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: /* @__PURE__ */ _jsxQ("path", null, {
    d: "m12 3-1.9 5.8a2 2 0 0 1-1.287 1.288L3 12l5.8 1.9a2 2 0 0 1 1.288 1.287L12 21l1.9-5.8a2 2 0 0 1 1.287-1.288L21 12l-5.8-1.9a2 2 0 0 1-1.288-1.287Z"
  }, null, 3, null)
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "WC_0");
const LuSparkles = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m12 3-1.912 5.813a2 2 0 0 1-1.275 1.275L3 12l5.813 1.912a2 2 0 0 1 1.275 1.275L12 21l1.912-5.813a2 2 0 0 1 1.275-1.275L21 12l-5.813-1.912a2 2 0 0 1-1.275-1.275L12 3Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M5 3v4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M19 17v4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 5h4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17 19h4"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "61_0");
const LuSpeaker = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "20",
      rx: "2",
      ry: "2",
      width: "16",
      x: "4",
      y: "2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "14",
      r: "4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "12",
      x2: "12.01",
      y1: "6",
      y2: "6"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "qg_0");
const LuSpeech = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8.8 20v-4.1l1.9.2a2.3 2.3 0 0 0 2.164-2.1V8.3A5.37 5.37 0 0 0 2 8.25c0 2.8.656 3.054 1 4.55a5.77 5.77 0 0 1 .029 2.758L2 20"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M19.8 17.8a7.5 7.5 0 0 0 .003-10.603"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17 15a3.5 3.5 0 0 0-.025-4.975"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Y3_0");
const LuSpellCheck2 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m6 16 6-12 6 12"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 12h8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 21c1.1 0 1.1-1 2.3-1s1.1 1 2.3 1c1.1 0 1.1-1 2.3-1 1.1 0 1.1 1 2.3 1 1.1 0 1.1-1 2.3-1 1.1 0 1.1 1 2.3 1 1.1 0 1.1-1 2.3-1"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "4v_0");
const LuSpellCheck = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m6 16 6-12 6 12"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 12h8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m16 20 2 2 4-4"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "hM_0");
const LuSpline = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "19",
      cy: "5",
      r: "2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "5",
      cy: "19",
      r: "2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M5 17A12 12 0 0 1 17 5"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "cr_0");
const LuSplitSquareHorizontal = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 19H5c-1 0-2-1-2-2V7c0-1 1-2 2-2h3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 5h3c1 0 2 1 2 2v10c0 1-1 2-2 2h-3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "12",
      x2: "12",
      y1: "4",
      y2: "20"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "qj_0");
const LuSplitSquareVertical = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M5 8V5c0-1 1-2 2-2h10c1 0 2 1 2 2v3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M19 16v3c0 1-1 2-2 2H7c-1 0-2-1-2-2v-3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "4",
      x2: "20",
      y1: "12",
      y2: "12"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "a4_0");
const LuSplit = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 3h5v5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 3H3v5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 22v-8.3a4 4 0 0 0-1.172-2.872L3 3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m15 9 6-6"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "0j_0");
const LuSprayCan = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 3h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 5h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M11 7h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 7h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 9h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 11h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "4",
      width: "4",
      x: "15",
      y: "5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m19 9 2 2v10c0 .6-.4 1-1 1h-6c-.6 0-1-.4-1-1V11l2-2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m13 14 8-2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m13 19 8-2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Nc_0");
const LuSprout = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 20h10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10 20c5.5-2.5.8-6.4 3-10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9.5 9.4c1.1.8 1.8 2.2 2.3 3.7-2 .4-3.5.4-4.8-.3-1.2-.6-2.3-1.9-3-4.2 2.8-.5 4.4 0 5.5.8z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14.1 6a7 7 0 0 0-1.1 4c1.9-.1 3.3-.6 4.3-1.4 1-1 1.6-2.3 1.7-4.6-2.7.1-4 1-4.9 2z"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "M7_0");
const LuSquareAsterisk = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "18",
      rx: "2",
      width: "18",
      x: "3",
      y: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 8v8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m8.5 14 7-4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m8.5 10 7 4"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "8x_0");
const LuSquareCode = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "18",
      rx: "2",
      width: "18",
      x: "3",
      y: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m10 10-2 2 2 2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m14 14 2-2-2-2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "0Y_0");
const LuSquareDashedBottomCode = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m10 10-2 2 2 2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m14 14 2-2-2-2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M5 21a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 21h1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14 21h1"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "So_0");
const LuSquareDashedBottom = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M5 21a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 21h1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14 21h1"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Li_0");
const LuSquareDot = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "18",
      rx: "2",
      width: "18",
      x: "3",
      y: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "1"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "qW_0");
const LuSquareEqual = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "18",
      rx: "2",
      width: "18",
      x: "3",
      y: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 10h10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 14h10"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "js_0");
const LuSquareSlash = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "18",
      rx: "2",
      width: "18",
      x: "3",
      y: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "9",
      x2: "15",
      y1: "15",
      y2: "9"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Rg_0");
const LuSquareStack = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 10c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h4c1.1 0 2 .9 2 2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10 16c-1.1 0-2-.9-2-2v-4c0-1.1.9-2 2-2h4c1.1 0 2 .9 2 2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "8",
      rx: "2",
      width: "8",
      x: "14",
      y: "14"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "gh_0");
const LuSquare = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: /* @__PURE__ */ _jsxQ("rect", null, {
    height: "18",
    rx: "2",
    width: "18",
    x: "3",
    y: "3"
  }, null, 3, null)
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Sb_0");
const LuSquirrel = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18 6a4 4 0 0 0-4 4 7 7 0 0 0-7 7c0-5 4-5 4-10.5a4.5 4.5 0 1 0-9 0 2.5 2.5 0 0 0 5 0C7 10 3 11 3 17c0 2.8 2.2 5 5 5h10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 20c0-1.7 1.3-3 3-3h1a2 2 0 0 0 2-2v-2a4 4 0 0 0-4-4V4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M15.2 22a3 3 0 0 0-2.2-5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18 13h.01"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "DB_0");
const LuStamp = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M5 22h14"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M19.27 13.73A2.5 2.5 0 0 0 17.5 13h-11A2.5 2.5 0 0 0 4 15.5V17a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-1.5c0-.66-.26-1.3-.73-1.77Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14 13V8.5C14 7 15 7 15 5a3 3 0 0 0-3-3c-1.66 0-3 1-3 3s1 2 1 3.5V13"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "D6_0");
const LuStarHalf = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: /* @__PURE__ */ _jsxQ("path", null, {
    d: "M12 17.8 5.8 21 7 14.1 2 9.3l7-1L12 2"
  }, null, 3, null)
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Ke_0");
const LuStarOff = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8.34 8.34 2 9.27l5 4.87L5.82 21 12 17.77 18.18 21l-.59-3.43"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18.42 12.76 22 9.27l-6.91-1L12 2l-1.44 2.91"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "2",
      x2: "22",
      y1: "2",
      y2: "22"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "jk_0");
const LuStar = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: /* @__PURE__ */ _jsxQ("polygon", null, {
    points: "12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"
  }, null, 3, null)
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "SV_0");
const LuStepBack = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "18",
      x2: "18",
      y1: "20",
      y2: "4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polygon", null, {
      points: "14,20 4,12 14,4"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "g2_0");
const LuStepForward = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "6",
      x2: "6",
      y1: "4",
      y2: "20"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polygon", null, {
      points: "10,4 20,12 10,20"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "JO_0");
const LuStethoscope = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4.8 2.3A.3.3 0 1 0 5 2H4a2 2 0 0 0-2 2v5a6 6 0 0 0 6 6v0a6 6 0 0 0 6-6V4a2 2 0 0 0-2-2h-1a.2.2 0 1 0 .3.3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 15v1a6 6 0 0 0 6 6v0a6 6 0 0 0 6-6v-4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "20",
      cy: "10",
      r: "2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "7J_0");
const LuSticker = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M15.5 3H5a2 2 0 0 0-2 2v14c0 1.1.9 2 2 2h14a2 2 0 0 0 2-2V8.5L15.5 3Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M15 3v6h6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10 16s.8 1 2 1c1.3 0 2-1 2-1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 13h0"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 13h0"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "dg_0");
const LuStickyNote = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M15.5 3H5a2 2 0 0 0-2 2v14c0 1.1.9 2 2 2h14a2 2 0 0 0 2-2V8.5L15.5 3Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M15 3v6h6"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "vn_0");
const LuStopCircle = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "6",
      width: "6",
      x: "9",
      y: "9"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "bW_0");
const LuStore = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m2 7 4.41-4.41A2 2 0 0 1 7.83 2h8.34a2 2 0 0 1 1.42.59L22 7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M15 22v-4a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 7h20"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M22 7v3a2 2 0 0 1-2 2v0a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 16 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 12 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 8 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 4 12v0a2 2 0 0 1-2-2V7"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "9X_0");
const LuStretchHorizontal = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "6",
      rx: "2",
      width: "20",
      x: "2",
      y: "4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "6",
      rx: "2",
      width: "20",
      x: "2",
      y: "14"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "7G_0");
const LuStretchVertical = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "20",
      rx: "2",
      width: "6",
      x: "4",
      y: "2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "20",
      rx: "2",
      width: "6",
      x: "14",
      y: "2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "vJ_0");
const LuStrikethrough = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 4H9a3 3 0 0 0-2.83 4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14 12a4 4 0 0 1 0 8H6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "4",
      x2: "20",
      y1: "12",
      y2: "12"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Ji_0");
const LuSubscript = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m4 5 8 8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m12 5-8 8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M20 19h-4c0-1.5.44-2 1.5-2.5S20 15.33 20 14c0-.47-.17-.93-.48-1.29a2.11 2.11 0 0 0-2.62-.44c-.42.24-.74.62-.9 1.07"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "yf_0");
const LuSubtitles = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 13h4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M15 13h2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 9h2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M13 9h4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2Z"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "4Y_0");
const LuSunDim = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 4h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M20 12h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 20h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 12h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17.657 6.343h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17.657 17.657h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6.343 17.657h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6.343 6.343h.01"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "4O_0");
const LuSunMedium = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 3v1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 20v1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 12h1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M20 12h1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m18.364 5.636-.707.707"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m6.343 17.657-.707.707"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m5.636 5.636.707.707"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m17.657 17.657.707.707"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "xA_0");
const LuSunMoon = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 8a2.83 2.83 0 0 0 4 4 4 4 0 1 1-4-4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 2v2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 20v2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m4.9 4.9 1.4 1.4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m17.7 17.7 1.4 1.4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 12h2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M20 12h2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m6.3 17.7-1.4 1.4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m19.1 4.9-1.4 1.4"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "hu_0");
const LuSunSnow = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10 9a3 3 0 1 0 0 6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 12h1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14 21V3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10 4V3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10 21v-1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m3.64 18.36.7-.7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m4.34 6.34-.7-.7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14 12h8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m17 4-3 3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m14 17 3 3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m21 15-3-3 3-3"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "HT_0");
const LuSun = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 2v2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 20v2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m4.93 4.93 1.41 1.41"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m17.66 17.66 1.41 1.41"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 12h2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M20 12h2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m6.34 17.66-1.41 1.41"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m19.07 4.93-1.41 1.41"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Qm_0");
const LuSunrise = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 2v8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m4.93 10.93 1.41 1.41"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 18h2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M20 18h2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m19.07 10.93-1.41 1.41"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M22 22H2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m8 6 4-4 4 4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 18a4 4 0 0 0-8 0"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "7g_0");
const LuSunset = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 10V2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m4.93 10.93 1.41 1.41"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 18h2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M20 18h2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m19.07 10.93-1.41 1.41"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M22 22H2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m16 6-4 4-4-4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 18a4 4 0 0 0-8 0"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "9S_0");
const LuSuperscript = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m4 19 8-8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m12 19-8-8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M20 12h-4c0-1.5.442-2 1.5-2.5S20 8.334 20 7.002c0-.472-.17-.93-.484-1.29a2.105 2.105 0 0 0-2.617-.436c-.42.239-.738.614-.899 1.06"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Bc_0");
const LuSwissFranc = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10 21V3h8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6 16h9"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10 9.5h7"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "We_0");
const LuSwitchCamera = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M11 19H4a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M13 5h7a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m18 22-3-3 3-3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m6 2 3 3-3 3"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "03_0");
const LuSword = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "14.5 17.5 3 6 3 3 6 3 17.5 14.5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "13",
      x2: "19",
      y1: "19",
      y2: "13"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "16",
      x2: "20",
      y1: "16",
      y2: "20"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "19",
      x2: "21",
      y1: "21",
      y2: "19"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "9j_0");
const LuSwords = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "14.5 17.5 3 6 3 3 6 3 17.5 14.5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "13",
      x2: "19",
      y1: "19",
      y2: "13"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "16",
      x2: "20",
      y1: "16",
      y2: "20"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "19",
      x2: "21",
      y1: "21",
      y2: "19"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "14.5 6.5 18 3 21 3 21 6 17.5 9.5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "5",
      x2: "9",
      y1: "14",
      y2: "18"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "7",
      x2: "4",
      y1: "17",
      y2: "20"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "3",
      x2: "5",
      y1: "19",
      y2: "21"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "IE_0");
const LuSyringe = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m18 2 4 4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m17 7 3-3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M19 9 8.7 19.3c-1 1-2.5 1-3.4 0l-.6-.6c-1-1-1-2.5 0-3.4L15 5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m9 11 4 4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m5 19-3 3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m14 4 6 6"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Wt_0");
const LuTable2 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: /* @__PURE__ */ _jsxQ("path", null, {
    d: "M9 3H5a2 2 0 0 0-2 2v4m6-6h10a2 2 0 0 1 2 2v4M9 3v18m0 0h10a2 2 0 0 0 2-2V9M9 21H5a2 2 0 0 1-2-2V9m0 0h18"
  }, null, 3, null)
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "og_0");
const LuTableProperties = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M15 3v18"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "18",
      rx: "2",
      width: "18",
      x: "3",
      y: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 9H3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 15H3"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "5I_0");
const LuTable = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 3v18"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "18",
      rx: "2",
      width: "18",
      x: "3",
      y: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 9h18"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 15h18"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "nY_0");
const LuTabletSmartphone = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "14",
      rx: "2",
      width: "10",
      x: "3",
      y: "8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M5 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2h-2.4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 18h.01"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "8y_0");
const LuTablet = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "20",
      rx: "2",
      ry: "2",
      width: "16",
      x: "4",
      y: "2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "12",
      x2: "12.01",
      y1: "18",
      y2: "18"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "TV_0");
const LuTablets = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "7",
      cy: "7",
      r: "5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "17",
      cy: "17",
      r: "5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 17h10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m3.46 10.54 7.08-7.08"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "ZH_0");
const LuTag = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 2H2v10l9.29 9.29c.94.94 2.48.94 3.42 0l6.58-6.58c.94-.94.94-2.48 0-3.42L12 2Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 7h.01"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "N3_0");
const LuTags = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 5H2v7l6.29 6.29c.94.94 2.48.94 3.42 0l3.58-3.58c.94-.94.94-2.48 0-3.42L9 5Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6 9.01V9"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m15 5 6.3 6.3a2.4 2.4 0 0 1 0 3.4L17 19"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "mu_0");
const LuTally1 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: /* @__PURE__ */ _jsxQ("path", null, {
    d: "M4 4v16"
  }, null, 3, null)
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "0F_0");
const LuTally2 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 4v16"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 4v16"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "V0_0");
const LuTally3 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 4v16"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 4v16"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14 4v16"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Au_0");
const LuTally4 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 4v16"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 4v16"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14 4v16"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M19 4v16"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "uJ_0");
const LuTally5 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 4v16"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 4v16"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14 4v16"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M19 4v16"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M22 6 2 18"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "tD_0");
const LuTangent = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "17",
      cy: "4",
      r: "2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M15.59 5.41 5.41 15.59"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "4",
      cy: "17",
      r: "2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 22s-4-9-1.5-11.5S22 12 22 12"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "iE_0");
const LuTarget = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "t5_0");
const LuTentTree = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "4",
      cy: "4",
      r: "2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m14 5 3-3 3 3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m14 10 3-3 3 3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17 14V2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17 14H7l-5 8h20Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 14v8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m9 14 5 8"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "8M_0");
const LuTent = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3.5 21 14 3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M20.5 21 10 3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M15.5 21 12 15l-3.5 6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 21h20"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "WA_0");
const LuTerminalSquare = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m7 11 2-2-2-2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M11 13h4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "18",
      rx: "2",
      ry: "2",
      width: "18",
      x: "3",
      y: "3"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "v5_0");
const LuTerminal = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "4 17 10 11 4 5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "12",
      x2: "20",
      y1: "19",
      y2: "19"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Qu_0");
const LuTestTube2 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 7 6.82 21.18a2.83 2.83 0 0 1-3.99-.01v0a2.83 2.83 0 0 1 0-4L17 3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m16 2 6 6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 16H4"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "2C_0");
const LuTestTube = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14.5 2v17.5c0 1.4-1.1 2.5-2.5 2.5h0c-1.4 0-2.5-1.1-2.5-2.5V2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8.5 2h7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14.5 16h-5"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "ya_0");
const LuTestTubes = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 2v17.5A2.5 2.5 0 0 1 6.5 22v0A2.5 2.5 0 0 1 4 19.5V2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M20 2v17.5a2.5 2.5 0 0 1-2.5 2.5v0a2.5 2.5 0 0 1-2.5-2.5V2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 2h7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14 2h7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 16H4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M20 16h-5"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Jk_0");
const LuTextCursorInput = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M5 4h1a3 3 0 0 1 3 3 3 3 0 0 1 3-3h1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M13 20h-1a3 3 0 0 1-3-3 3 3 0 0 1-3 3H5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M5 16H4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M13 8h7a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 7v10"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "z8_0");
const LuTextCursor = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17 22h-1a4 4 0 0 1-4-4V6a4 4 0 0 1 4-4h1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 22h1a4 4 0 0 0 4-4v-1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 2h1a4 4 0 0 1 4 4v1"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Yc_0");
const LuTextQuote = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17 6H3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 12H8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 18H8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 12v6"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "xr_0");
const LuTextSelect = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M5 3a2 2 0 0 0-2 2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M19 3a2 2 0 0 1 2 2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 19a2 2 0 0 1-2 2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M5 21a2 2 0 0 1-2-2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 3h1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 21h1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14 3h1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14 21h1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 9v1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 9v1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 14v1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 14v1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "7",
      x2: "15",
      y1: "8",
      y2: "8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "7",
      x2: "17",
      y1: "12",
      y2: "12"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "7",
      x2: "13",
      y1: "16",
      y2: "16"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Ww_0");
const LuText = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17 6.1H3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 12.1H3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M15.1 18H3"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "LY_0");
const LuTheater = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 10s3-3 3-8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M22 10s-3-3-3-8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10 2c0 4.4-3.6 8-8 8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14 2c0 4.4 3.6 8 8 8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 10s2 2 2 5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M22 10s-2 2-2 5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 15h8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 22v-1a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14 22v-1a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v1"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Br_0");
const LuThermometerSnowflake = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 12h10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 4v16"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m3 9 3 3-3 3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 6 9 9 6 6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m6 18 3-3 1.5 1.5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M20 4v10.54a4 4 0 1 1-4 0V4a2 2 0 0 1 4 0Z"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "qk_0");
const LuThermometerSun = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 9a4 4 0 0 0-2 7.5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 3v2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m6.6 18.4-1.4 1.4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M20 4v10.54a4 4 0 1 1-4 0V4a2 2 0 0 1 4 0Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 13H2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6.34 7.34 4.93 5.93"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "VV_0");
const LuThermometer = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: /* @__PURE__ */ _jsxQ("path", null, {
    d: "M14 4v10.54a4 4 0 1 1-4 0V4a2 2 0 0 1 4 0Z"
  }, null, 3, null)
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Ot_0");
const LuThumbsDown = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17 14V2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 18.12 10 14H4.17a2 2 0 0 1-1.92-2.56l2.33-8A2 2 0 0 1 6.5 2H20a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2.76a2 2 0 0 0-1.79 1.11L12 22h0a3.13 3.13 0 0 1-3-3.88Z"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "dm_0");
const LuThumbsUp = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 10v12"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2h0a3.13 3.13 0 0 1 3 3.88Z"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Sn_0");
const LuTicket = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M13 5v2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M13 17v2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M13 11v2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "x0_0");
const LuTimerOff = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10 2h4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4.6 11a8 8 0 0 0 1.7 8.7 8 8 0 0 0 8.7 1.7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7.4 7.4a8 8 0 0 1 10.3 1 8 8 0 0 1 .9 10.2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m2 2 20 20"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 12v-2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "aD_0");
const LuTimerReset = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10 2h4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 14v-4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 13a8 8 0 0 1 8-7 8 8 0 1 1-5.3 14L4 17.6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 17H4v5"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "vN_0");
const LuTimer = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "10",
      x2: "14",
      y1: "2",
      y2: "2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "12",
      x2: "15",
      y1: "14",
      y2: "11"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "14",
      r: "8"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "06_0");
const LuToggleLeft = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "12",
      rx: "6",
      ry: "6",
      width: "20",
      x: "2",
      y: "6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "8",
      cy: "12",
      r: "2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "fY_0");
const LuToggleRight = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "12",
      rx: "6",
      ry: "6",
      width: "20",
      x: "2",
      y: "6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "16",
      cy: "12",
      r: "2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "rA_0");
const LuTornado = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 4H3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18 8H6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M19 12H9"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 16h-6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M11 20H9"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "pb_0");
const LuTorus = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("ellipse", null, {
      cx: "12",
      cy: "11",
      rx: "3",
      ry: "2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("ellipse", null, {
      cx: "12",
      cy: "12.5",
      rx: "10",
      ry: "8.5"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Vv_0");
const LuTouchpadOff = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 14h12"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M22 14h-2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 20v-6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m2 2 20 20"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M22 16V6a2 2 0 0 0-2-2H10"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "iL_0");
const LuTouchpad = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "16",
      rx: "2",
      width: "20",
      x: "2",
      y: "4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 14h20"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 20v-6"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "I0_0");
const LuTowerControl = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18.2 12.27 20 6H4l1.8 6.27a1 1 0 0 0 .95.73h10.5a1 1 0 0 0 .96-.73Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 13v9"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 22v-9"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m9 6 1 7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m15 6-1 7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 6V2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M13 2h-2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "ZZ_0");
const LuToyBrick = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "12",
      rx: "1",
      width: "18",
      x: "3",
      y: "8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10 8V5c0-.6-.4-1-1-1H6a1 1 0 0 0-1 1v3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M19 8V5c0-.6-.4-1-1-1h-3a1 1 0 0 0-1 1v3"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "ym_0");
const LuTractor = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 4h9l1 7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 11V4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 10V4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18 5c-.6 0-1 .4-1 1v5.6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m10 11 11 .9c.6 0 .9.5.8 1.1l-.8 5h-1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "7",
      cy: "15",
      r: ".5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "7",
      cy: "15",
      r: "5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 18h-5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "18",
      cy: "18",
      r: "2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Zg_0");
const LuTrafficCone = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9.3 6.2a4.55 4.55 0 0 0 5.4 0"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7.9 10.7c.9.8 2.4 1.3 4.1 1.3s3.2-.5 4.1-1.3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M13.9 3.5a1.93 1.93 0 0 0-3.8-.1l-3 10c-.1.2-.1.4-.1.6 0 1.7 2.2 3 5 3s5-1.3 5-3c0-.2 0-.4-.1-.5Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m7.5 12.2-4.7 2.7c-.5.3-.8.7-.8 1.1s.3.8.8 1.1l7.6 4.5c.9.5 2.1.5 3 0l7.6-4.5c.7-.3 1-.7 1-1.1s-.3-.8-.8-1.1l-4.7-2.8"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Oh_0");
const LuTrainFrontTunnel = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 22V12a10 10 0 1 1 20 0v10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M15 6.8v1.4a3 2.8 0 1 1-6 0V6.8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10 15h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14 15h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10 19a4 4 0 0 1-4-4v-3a6 6 0 1 1 12 0v3a4 4 0 0 1-4 4Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m9 19-2 3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m15 19 2 3"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "QB_0");
const LuTrainFront = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 3.1V7a4 4 0 0 0 8 0V3.1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m9 15-1-1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m15 15 1-1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 19c-2.8 0-5-2.2-5-5v-4a8 8 0 0 1 16 0v4c0 2.8-2.2 5-5 5Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m8 19-2 3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m16 19 2 3"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "GY_0");
const LuTrainTrack = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 17 17 2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m2 14 8 8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m5 11 8 8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m8 8 8 8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m11 5 8 8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m14 2 8 8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 22 22 7"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "k8_0");
const LuTramFront = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "16",
      rx: "2",
      width: "16",
      x: "4",
      y: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 11h16"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 3v8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m8 19-2 3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m18 22-2-3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 15h0"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 15h0"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "88_0");
const LuTrash2 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 6h18"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "10",
      x2: "10",
      y1: "11",
      y2: "17"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "14",
      x2: "14",
      y1: "11",
      y2: "17"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Eb_0");
const LuTrash = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 6h18"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "St_0");
const LuTreeDeciduous = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 19h8a4 4 0 0 0 3.8-2.8 4 4 0 0 0-1.6-4.5c1-1.1 1-2.7.4-4-.7-1.2-2.2-2-3.6-1.7a3 3 0 0 0-3-3 3 3 0 0 0-3 3c-1.4-.2-2.9.5-3.6 1.7-.7 1.3-.5 2.9.4 4a4 4 0 0 0-1.6 4.5A4 4 0 0 0 8 19Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 19v3"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "DI_0");
const LuTreePine = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m17 14 3 3.3a1 1 0 0 1-.7 1.7H4.7a1 1 0 0 1-.7-1.7L7 14h-.3a1 1 0 0 1-.7-1.7L9 9h-.2A1 1 0 0 1 8 7.3L12 3l4 4.3a1 1 0 0 1-.8 1.7H15l3 3.3a1 1 0 0 1-.7 1.7H17Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 22v-3"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "pL_0");
const LuTrees = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10 10v.2A3 3 0 0 1 8.9 16v0H5v0h0a3 3 0 0 1-1-5.8V10a3 3 0 0 1 6 0Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 16v6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M13 19v3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 19h8.3a1 1 0 0 0 .7-1.7L18 14h.3a1 1 0 0 0 .7-1.7L16 9h.2a1 1 0 0 0 .8-1.7L13 3l-1.4 1.5"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "C0_0");
const LuTrello = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "18",
      rx: "2",
      ry: "2",
      width: "18",
      x: "3",
      y: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "9",
      width: "3",
      x: "7",
      y: "7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "5",
      width: "3",
      x: "14",
      y: "7"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "io_0");
const LuTrendingDown = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "22 17 13.5 8.5 8.5 13.5 2 7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "16 17 22 17 22 11"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "ug_0");
const LuTrendingUp = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "22 7 13.5 15.5 8.5 10.5 2 17"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "16 7 22 7 22 13"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "rm_0");
const LuTriangleRight = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: /* @__PURE__ */ _jsxQ("path", null, {
    d: "M22 18a2 2 0 0 1-2 2H3c-1.1 0-1.3-.6-.4-1.3L20.4 4.3c.9-.7 1.6-.4 1.6.7Z"
  }, null, 3, null)
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "A3_0");
const LuTriangle = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: /* @__PURE__ */ _jsxQ("path", null, {
    d: "M13.73 4a2 2 0 0 0-3.46 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z"
  }, null, 3, null)
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "wr_0");
const LuTrophy = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6 9H4.5a2.5 2.5 0 0 1 0-5H6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18 9h1.5a2.5 2.5 0 0 0 0-5H18"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 22h16"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18 2H6v7a6 6 0 0 0 12 0V2Z"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "lM_0");
const LuTruck = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M5 18H3c-.6 0-1-.4-1-1V7c0-.6.4-1 1-1h10c.6 0 1 .4 1 1v11"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14 9h4l4 4v4c0 .6-.4 1-1 1h-2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "7",
      cy: "18",
      r: "2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M15 18H9"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "17",
      cy: "18",
      r: "2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "ib_0");
const LuTurtle = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m12 10 2 4v3a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-3a8 8 0 1 0-16 0v3a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-3l2-4h4Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4.82 7.9 8 10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M15.18 7.9 12 10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16.93 10H20a2 2 0 0 1 0 4H2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Ku_0");
const LuTv2 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 21h10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "14",
      rx: "2",
      width: "20",
      x: "2",
      y: "3"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Ni_0");
const LuTv = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "15",
      rx: "2",
      ry: "2",
      width: "20",
      x: "2",
      y: "7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "17 2 12 7 7 2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "uG_0");
const LuTwitch = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: /* @__PURE__ */ _jsxQ("path", null, {
    d: "M21 2H3v16h5v4l4-4h5l4-4V2zm-10 9V7m5 4V7"
  }, null, 3, null)
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "9H_0");
const LuTwitter = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: /* @__PURE__ */ _jsxQ("path", null, {
    d: "M22 4s-.7 2.1-2 3.4c1.6 10-9.4 17.3-18 11.6 2.2.1 4.4-.6 6-2C3 15.5.5 9.6 3 5c2.2 2.6 5.6 4.1 9 4-.9-4.2 4-6.6 7-3.8 1.1 0 3-1.2 3-1.2z"
  }, null, 3, null)
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "0a_0");
const LuType = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "4 7 4 4 20 4 20 7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "9",
      x2: "15",
      y1: "20",
      y2: "20"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "12",
      x2: "12",
      y1: "4",
      y2: "20"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Mg_0");
const LuUmbrellaOff = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 2v1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M15.5 21a1.85 1.85 0 0 1-3.5-1v-8H2a10 10 0 0 1 3.428-6.575"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17.5 12H22A10 10 0 0 0 9.004 3.455"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m2 2 20 20"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "RB_0");
const LuUmbrella = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M22 12a10.06 10.06 1 0 0-20 0Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 12v8a2 2 0 0 0 4 0"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 2v1"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "nP_0");
const LuUnderline = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6 4v6a6 6 0 0 0 12 0V4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "4",
      x2: "20",
      y1: "20",
      y2: "20"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "LD_0");
const LuUndo2 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9 14 4 9l5-5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 9h10.5a5.5 5.5 0 0 1 5.5 5.5v0a5.5 5.5 0 0 1-5.5 5.5H11"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "qh_0");
const LuUndoDot = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "17",
      r: "1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 7v6h6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 17a9 9 0 0 0-9-9 9 9 0 0 0-6 2.3L3 13"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "XD_0");
const LuUndo = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 7v6h6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 17a9 9 0 0 0-9-9 9 9 0 0 0-6 2.3L3 13"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "zs_0");
const LuUnfoldHorizontal = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 12h6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 12H2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 2v2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 8v2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 14v2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 20v2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m19 15 3-3-3-3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m5 9-3 3 3 3"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "J5_0");
const LuUnfoldVertical = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 22v-6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 8V2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 12H2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10 12H8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 12h-2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M22 12h-2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m15 19-3 3-3-3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m15 5-3-3-3 3"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "vf_0");
const LuUngroup = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "6",
      rx: "1",
      width: "8",
      x: "5",
      y: "4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "6",
      rx: "1",
      width: "8",
      x: "11",
      y: "14"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "DO_0");
const LuUnlink2 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: /* @__PURE__ */ _jsxQ("path", null, {
    d: "M15 7h2a5 5 0 0 1 0 10h-2m-6 0H7A5 5 0 0 1 7 7h2"
  }, null, 3, null)
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "wO_0");
const LuUnlink = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m18.84 12.25 1.72-1.71h-.02a5.004 5.004 0 0 0-.12-7.07 5.006 5.006 0 0 0-6.95 0l-1.72 1.71"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m5.17 11.75-1.71 1.71a5.004 5.004 0 0 0 .12 7.07 5.006 5.006 0 0 0 6.95 0l1.71-1.71"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "8",
      x2: "8",
      y1: "2",
      y2: "5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "2",
      x2: "5",
      y1: "8",
      y2: "8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "16",
      x2: "16",
      y1: "19",
      y2: "22"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "19",
      x2: "22",
      y1: "16",
      y2: "16"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Ho_0");
const LuUnlockKeyhole = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "16",
      r: "1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "12",
      rx: "2",
      width: "18",
      x: "3",
      y: "10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 10V7a5 5 0 0 1 9.33-2.5"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "QI_0");
const LuUnlock = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "11",
      rx: "2",
      ry: "2",
      width: "18",
      x: "3",
      y: "11"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 11V7a5 5 0 0 1 9.9-1"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "UN_0");
const LuUnplug = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m19 5 3-3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m2 22 3-3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6.3 20.3a2.4 2.4 0 0 0 3.4 0L12 18l-6-6-2.3 2.3a2.4 2.4 0 0 0 0 3.4Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7.5 13.5 10 11"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10.5 16.5 13 14"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m12 6 6 6 2.3-2.3a2.4 2.4 0 0 0 0-3.4l-2.6-2.6a2.4 2.4 0 0 0-3.4 0Z"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "r9_0");
const LuUploadCloud = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 12v9"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m16 16-4-4-4 4"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Cw_0");
const LuUpload = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "17 8 12 3 7 8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "12",
      x2: "12",
      y1: "3",
      y2: "15"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Ow_0");
const LuUsb = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "10",
      cy: "7",
      r: "1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "4",
      cy: "20",
      r: "1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M4.7 19.3 19 5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m21 3-3 1 2 2Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9.26 7.68 5 12l2 5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m10 14 5 2 3.5-3.5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m18 12 1-1 1 1-1 1Z"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "dY_0");
const LuUser2 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "8",
      r: "5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M20 21a8 8 0 1 0-16 0"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "7g_0");
const LuUserCheck2 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14 19a6 6 0 0 0-12 0"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "8",
      cy: "9",
      r: "4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "16 11 18 13 22 9"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "s0_0");
const LuUserCheck = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "9",
      cy: "7",
      r: "4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "16 11 18 13 22 9"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "wP_0");
const LuUserCircle2 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18 20a6 6 0 0 0-12 0"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "10",
      r: "4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "10"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "C4_0");
const LuUserCircle = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "10",
      r: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 20.662V19a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v1.662"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "lU_0");
const LuUserCog2 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "18",
      cy: "15",
      r: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "8",
      cy: "9",
      r: "4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10.5 13.5A6 6 0 0 0 2 19"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m21.7 16.4-.9-.3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m15.2 13.9-.9-.3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m16.6 18.7.3-.9"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m19.1 12.2.3-.9"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m19.6 18.7-.4-1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m16.8 12.3-.4-1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m14.3 16.6 1-.4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m20.7 13.8 1-.4"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "sM_0");
const LuUserCog = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "18",
      cy: "15",
      r: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "9",
      cy: "7",
      r: "4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10 15H6a4 4 0 0 0-4 4v2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m21.7 16.4-.9-.3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m15.2 13.9-.9-.3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m16.6 18.7.3-.9"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m19.1 12.2.3-.9"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m19.6 18.7-.4-1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m16.8 12.3-.4-1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m14.3 16.6 1-.4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m20.7 13.8 1-.4"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Qc_0");
const LuUserMinus2 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14 19a6 6 0 0 0-12 0"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "8",
      cy: "9",
      r: "4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "22",
      x2: "16",
      y1: "11",
      y2: "11"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Td_0");
const LuUserMinus = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "9",
      cy: "7",
      r: "4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "22",
      x2: "16",
      y1: "11",
      y2: "11"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "QB_0");
const LuUserPlus2 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14 19a6 6 0 0 0-12 0"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "8",
      cy: "9",
      r: "4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "19",
      x2: "19",
      y1: "8",
      y2: "14"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "22",
      x2: "16",
      y1: "11",
      y2: "11"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "cb_0");
const LuUserPlus = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "9",
      cy: "7",
      r: "4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "19",
      x2: "19",
      y1: "8",
      y2: "14"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "22",
      x2: "16",
      y1: "11",
      y2: "11"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "18_0");
const LuUserSquare2 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18 21a6 6 0 0 0-12 0"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "11",
      r: "4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "18",
      rx: "2",
      width: "18",
      x: "3",
      y: "3"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "I9_0");
const LuUserSquare = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "18",
      rx: "2",
      width: "18",
      x: "3",
      y: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "10",
      r: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 21v-2a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "g8_0");
const LuUserX2 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14 19a6 6 0 0 0-12 0"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "8",
      cy: "9",
      r: "4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "17",
      x2: "22",
      y1: "8",
      y2: "13"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "22",
      x2: "17",
      y1: "8",
      y2: "13"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Tj_0");
const LuUserX = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "9",
      cy: "7",
      r: "4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "17",
      x2: "22",
      y1: "8",
      y2: "13"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "22",
      x2: "17",
      y1: "8",
      y2: "13"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "pu_0");
const LuUser = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "7",
      r: "4"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "sX_0");
const LuUsers2 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14 19a6 6 0 0 0-12 0"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "8",
      cy: "9",
      r: "4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M22 19a6 6 0 0 0-6-6 4 4 0 1 0 0-8"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "57_0");
const LuUsers = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "9",
      cy: "7",
      r: "4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M22 21v-2a4 4 0 0 0-3-3.87"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 3.13a4 4 0 0 1 0 7.75"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "pI_0");
const LuUtensilsCrossed = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m16 2-2.3 2.3a3 3 0 0 0 0 4.2l1.8 1.8a3 3 0 0 0 4.2 0L22 8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M15 15 3.3 3.3a4.2 4.2 0 0 0 0 6l7.3 7.3c.7.7 2 .7 2.8 0L15 15Zm0 0 7 7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m2.1 21.8 6.4-6.3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m19 5-7 7"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "or_0");
const LuUtensils = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 2v7c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2V2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 2v20"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 15V2v0a5 5 0 0 0-5 5v6c0 1.1.9 2 2 2h3Zm0 0v7"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Md_0");
const LuUtilityPole = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 2v20"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 5h20"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 3v2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 3v2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17 3v2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 3v2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m19 5-7 7-7-7"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Jk_0");
const LuVariable = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 21s-4-3-4-9 4-9 4-9"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 3s4 3 4 9-4 9-4 9"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "15",
      x2: "9",
      y1: "9",
      y2: "15"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "9",
      x2: "15",
      y1: "9",
      y2: "15"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "CM_0");
const LuVegan = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 2a26.6 26.6 0 0 1 10 20c.9-6.82 1.5-9.5 4-14"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 8c4 0 6-2 6-6-4 0-6 2-6 6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17.41 3.6a10 10 0 1 0 3 3"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "mS_0");
const LuVenetianMask = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 12a5 5 0 0 0 5 5 8 8 0 0 1 5 2 8 8 0 0 1 5-2 5 5 0 0 0 5-5V7h-5a8 8 0 0 0-5 2 8 8 0 0 0-5-2H2Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6 11c1.5 0 3 .5 3 2-2 0-3 0-3-2Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18 11c-1.5 0-3 .5-3 2 2 0 3 0 3-2Z"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "WF_0");
const LuVibrateOff = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m2 8 2 2-2 2 2 2-2 2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m22 8-2 2 2 2-2 2 2 2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 8v10c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 10.34V6c0-.55-.45-1-1-1h-4.34"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "2",
      x2: "22",
      y1: "2",
      y2: "22"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "UP_0");
const LuVibrate = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m2 8 2 2-2 2 2 2-2 2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m22 8-2 2 2 2-2 2 2 2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "14",
      rx: "1",
      width: "8",
      x: "8",
      y: "5"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "qp_0");
const LuVideoOff = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10.66 6H14a2 2 0 0 1 2 2v2.34l1 1L22 8v8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16 16a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h2l10 10Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "2",
      x2: "22",
      y1: "2",
      y2: "22"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "mv_0");
const LuVideo = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m22 8-6 4 6 4V8Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "12",
      rx: "2",
      ry: "2",
      width: "14",
      x: "2",
      y: "6"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "2v_0");
const LuVideotape = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "16",
      rx: "2",
      width: "20",
      x: "2",
      y: "4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 8h20"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "8",
      cy: "14",
      r: "2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 12h8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "16",
      cy: "14",
      r: "2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "I9_0");
const LuView = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M5 12s2.545-5 7-5c4.454 0 7 5 7 5s-2.546 5-7 5c-4.455 0-7-5-7-5z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 17v2a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 7V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "8s_0");
const LuVoicemail = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "6",
      cy: "12",
      r: "4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "18",
      cy: "12",
      r: "4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "6",
      x2: "18",
      y1: "16",
      y2: "16"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Ez_0");
const LuVolume1 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("polygon", null, {
      points: "11 5 6 9 2 9 2 15 6 15 11 19 11 5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M15.54 8.46a5 5 0 0 1 0 7.07"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "yY_0");
const LuVolume2 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("polygon", null, {
      points: "11 5 6 9 2 9 2 15 6 15 11 19 11 5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M15.54 8.46a5 5 0 0 1 0 7.07"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M19.07 4.93a10 10 0 0 1 0 14.14"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "0H_0");
const LuVolumeX = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("polygon", null, {
      points: "11 5 6 9 2 9 2 15 6 15 11 19 11 5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "22",
      x2: "16",
      y1: "9",
      y2: "15"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "16",
      x2: "22",
      y1: "9",
      y2: "15"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "gs_0");
const LuVolume = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: /* @__PURE__ */ _jsxQ("polygon", null, {
    points: "11 5 6 9 2 9 2 15 6 15 11 19 11 5"
  }, null, 3, null)
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "04_0");
const LuVote = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m9 12 2 2 4-4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M5 7c0-1.1.9-2 2-2h10a2 2 0 0 1 2 2v12H5V7Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M22 19H2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "CG_0");
const LuWallet2 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17 14h.01"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 7h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "4L_0");
const LuWalletCards = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "18",
      rx: "2",
      width: "18",
      x: "3",
      y: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 9a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 11h3c.8 0 1.6.3 2.1.9l1.1.9c1.6 1.6 4.1 1.6 5.7 0l1.1-.9c.5-.5 1.3-.9 2.1-.9H21"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "ra_0");
const LuWallet = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 12V7H5a2 2 0 0 1 0-4h14v4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 5v14a2 2 0 0 0 2 2h16v-5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18 12a2 2 0 0 0 0 4h4v-4Z"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "lt_0");
const LuWallpaper = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "8",
      cy: "9",
      r: "2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m9 17 6.1-6.1a2 2 0 0 1 2.81.01L22 15V5a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 21h8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 17v4"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "0w_0");
const LuWand2 = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m21.64 3.64-1.28-1.28a1.21 1.21 0 0 0-1.72 0L2.36 18.64a1.21 1.21 0 0 0 0 1.72l1.28 1.28a1.2 1.2 0 0 0 1.72 0L21.64 5.36a1.2 1.2 0 0 0 0-1.72Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m14 7 3 3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M5 6v4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M19 14v4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10 2v2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 8H3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M21 16h-4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M11 3H9"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "ai_0");
const LuWand = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M15 4V2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M15 16v-2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 9h2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M20 9h2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17.8 11.8 19 13"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M15 9h0"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17.8 6.2 19 5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m3 21 9-9"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12.2 6.2 11 5"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "uk_0");
const LuWarehouse = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M22 8.35V20a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8.35A2 2 0 0 1 3.26 6.5l8-3.2a2 2 0 0 1 1.48 0l8 3.2A2 2 0 0 1 22 8.35Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6 18h12"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6 14h12"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "12",
      width: "12",
      x: "6",
      y: "10"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "kq_0");
const LuWatch = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "12 10 12 12 13 13"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m16.13 7.66-.81-4.05a2 2 0 0 0-2-1.61h-2.68a2 2 0 0 0-2 1.61l-.78 4.05"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m7.88 16.36.8 4a2 2 0 0 0 2 1.61h2.72a2 2 0 0 0 2-1.61l.81-4.05"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "2d_0");
const LuWaves = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 6c.6.5 1.2 1 2.5 1C7 7 7 5 9.5 5c2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 12c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 18c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "u6_0");
const LuWaypoints = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "4.5",
      r: "2.5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m10.2 6.3-3.9 3.9"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "4.5",
      cy: "12",
      r: "2.5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 12h10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "19.5",
      cy: "12",
      r: "2.5"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m13.8 17.7 3.9-3.9"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "19.5",
      r: "2.5"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "17_0");
const LuWebcam = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "10",
      r: "8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "10",
      r: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 22h10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 22v-4"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Rc_0");
const LuWebhook = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18 16.98h-5.99c-1.1 0-1.95.94-2.48 1.9A4 4 0 0 1 2 17c.01-.7.2-1.4.57-2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m6 17 3.13-5.78c.53-.97.1-2.18-.5-3.1a4 4 0 1 1 6.89-4.06"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m12 6 3.13 5.73C15.66 12.7 16.9 13 18 13a4 4 0 0 1 0 8"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "sZ_0");
const LuWeight = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "5",
      r: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M6.5 8a2 2 0 0 0-1.905 1.46L2.1 18.5A2 2 0 0 0 4 21h16a2 2 0 0 0 1.925-2.54L19.4 9.5A2 2 0 0 0 17.48 8Z"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "m9_0");
const LuWheatOff = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m2 22 10-10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m16 8-1.17 1.17"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3.47 12.53 5 11l1.53 1.53a3.5 3.5 0 0 1 0 4.94L5 19l-1.53-1.53a3.5 3.5 0 0 1 0-4.94Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m8 8-.53.53a3.5 3.5 0 0 0 0 4.94L9 15l1.53-1.53c.55-.55.88-1.25.98-1.97"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10.91 5.26c.15-.26.34-.51.56-.73L13 3l1.53 1.53a3.5 3.5 0 0 1 .28 4.62"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M20 2h2v2a4 4 0 0 1-4 4h-2V6a4 4 0 0 1 4-4Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M11.47 17.47 13 19l-1.53 1.53a3.5 3.5 0 0 1-4.94 0L5 19l1.53-1.53a3.5 3.5 0 0 1 4.94 0Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m16 16-.53.53a3.5 3.5 0 0 1-4.94 0L9 15l1.53-1.53a3.49 3.49 0 0 1 1.97-.98"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18.74 13.09c.26-.15.51-.34.73-.56L21 11l-1.53-1.53a3.5 3.5 0 0 0-4.62-.28"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "2",
      x2: "22",
      y1: "2",
      y2: "22"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Bm_0");
const LuWheat = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 22 16 8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3.47 12.53 5 11l1.53 1.53a3.5 3.5 0 0 1 0 4.94L5 19l-1.53-1.53a3.5 3.5 0 0 1 0-4.94Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7.47 8.53 9 7l1.53 1.53a3.5 3.5 0 0 1 0 4.94L9 15l-1.53-1.53a3.5 3.5 0 0 1 0-4.94Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M11.47 4.53 13 3l1.53 1.53a3.5 3.5 0 0 1 0 4.94L13 11l-1.53-1.53a3.5 3.5 0 0 1 0-4.94Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M20 2h2v2a4 4 0 0 1-4 4h-2V6a4 4 0 0 1 4-4Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M11.47 17.47 13 19l-1.53 1.53a3.5 3.5 0 0 1-4.94 0L5 19l1.53-1.53a3.5 3.5 0 0 1 4.94 0Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M15.47 13.47 17 15l-1.53 1.53a3.5 3.5 0 0 1-4.94 0L9 15l1.53-1.53a3.5 3.5 0 0 1 4.94 0Z"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M19.47 9.47 21 11l-1.53 1.53a3.5 3.5 0 0 1-4.94 0L13 11l1.53-1.53a3.5 3.5 0 0 1 4.94 0Z"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "H0_0");
const LuWholeWord = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "7",
      cy: "12",
      r: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10 9v6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "17",
      cy: "12",
      r: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M14 7v8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M22 17v1c0 .5-.5 1-1 1H3c-.5 0-1-.5-1-1v-1"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "U6_0");
const LuWifiOff = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "2",
      x2: "22",
      y1: "2",
      y2: "22"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8.5 16.5a5 5 0 0 1 7 0"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 8.82a15 15 0 0 1 4.17-2.65"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M10.66 5c4.01-.36 8.14.9 11.34 3.76"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M16.85 11.25a10 10 0 0 1 2.22 1.68"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M5 13a10 10 0 0 1 5.24-2.76"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "12",
      x2: "12.01",
      y1: "20",
      y2: "20"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "KV_0");
const LuWifi = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M5 13a10 10 0 0 1 14 0"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8.5 16.5a5 5 0 0 1 7 0"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2 8.82a15 15 0 0 1 20 0"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "12",
      x2: "12.01",
      y1: "20",
      y2: "20"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "8v_0");
const LuWind = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M17.7 7.7a2.5 2.5 0 1 1 1.8 4.3H2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M9.6 4.6A2 2 0 1 1 11 8H2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12.6 19.4A2 2 0 1 0 14 16H2"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "wO_0");
const LuWineOff = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 22h8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 10h3m7 0h-1.343"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 15v7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7.307 7.307A12.33 12.33 0 0 0 7 10a5 5 0 0 0 7.391 4.391M8.638 2.981C8.75 2.668 8.872 2.34 9 2h6c1.5 4 2 6 2 8 0 .407-.05.809-.145 1.198"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "2",
      x2: "22",
      y1: "2",
      y2: "22"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "WP_0");
const LuWine = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M8 22h8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 10h10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 15v7"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M12 15a5 5 0 0 0 5-5c0-2-.5-4-2-8H9c-1.5 4-2 6-2 8a5 5 0 0 0 5 5Z"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "jX_0");
const LuWorkflow = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "8",
      rx: "2",
      width: "8",
      x: "3",
      y: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M7 11v4a2 2 0 0 0 2 2h4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "8",
      rx: "2",
      width: "8",
      x: "13",
      y: "13"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "dl_0");
const LuWrapText = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "3",
      x2: "21",
      y1: "6",
      y2: "6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M3 12h15a3 3 0 1 1 0 6h-4"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "16 16 14 18 16 20"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "3",
      x2: "10",
      y1: "18",
      y2: "18"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "0K_0");
const LuWrench = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: /* @__PURE__ */ _jsxQ("path", null, {
    d: "M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"
  }, null, 3, null)
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "GG_0");
const LuXCircle = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "12",
      cy: "12",
      r: "10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m15 9-6 6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m9 9 6 6"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "B3_0");
const LuXOctagon = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("polygon", null, {
      points: "7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m15 9-6 6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m9 9 6 6"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "bd_0");
const LuXSquare = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("rect", null, {
      height: "18",
      rx: "2",
      ry: "2",
      width: "18",
      x: "3",
      y: "3"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m15 9-6 6"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m9 9 6 6"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "wo_0");
const LuX = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M18 6 6 18"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m6 6 12 12"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "CN_0");
const LuYoutube = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "M2.5 17a24.12 24.12 0 0 1 0-10 2 2 0 0 1 1.4-1.4 49.56 49.56 0 0 1 16.2 0A2 2 0 0 1 21.5 7a24.12 24.12 0 0 1 0 10 2 2 0 0 1-1.4 1.4 49.55 49.55 0 0 1-16.2 0A2 2 0 0 1 2.5 17"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("path", null, {
      d: "m10 15 5-3-5-3z"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "36_0");
const LuZapOff = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "12.41 6.75 13 2 10.57 4.92"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "18.57 12.91 21 10 15.66 10"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("polyline", null, {
      points: "8 8 3 14 12 14 11 22 16 16"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "2",
      x2: "22",
      y1: "2",
      y2: "22"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "Ot_0");
const LuZap = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: /* @__PURE__ */ _jsxQ("polygon", null, {
    points: "13 2 3 14 12 14 11 22 21 10 12 10 13 2"
  }, null, 3, null)
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "d0_0");
const LuZoomIn = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "11",
      cy: "11",
      r: "8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "21",
      x2: "16.65",
      y1: "21",
      y2: "16.65"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "11",
      x2: "11",
      y1: "8",
      y2: "14"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "8",
      x2: "14",
      y1: "11",
      y2: "11"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "6s_0");
const LuZoomOut = (props) => /* @__PURE__ */ _jsxS("svg", {
  ...props,
  children: [
    /* @__PURE__ */ _jsxQ("circle", null, {
      cx: "11",
      cy: "11",
      r: "8"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "21",
      x2: "16.65",
      y1: "21",
      y2: "16.65"
    }, null, 3, null),
    /* @__PURE__ */ _jsxQ("line", null, {
      x1: "8",
      x2: "14",
      y1: "11",
      y2: "11"
    }, null, 3, null)
  ]
}, {
  "data-qwikest-icon": true,
  fill: "none",
  height: "1em",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, 0, "1W_0");
export {
  LuAccessibility,
  LuActivity,
  LuActivitySquare,
  LuAirVent,
  LuAirplay,
  LuAlarmCheck,
  LuAlarmClock,
  LuAlarmClockOff,
  LuAlarmMinus,
  LuAlarmPlus,
  LuAlbum,
  LuAlertCircle,
  LuAlertOctagon,
  LuAlertTriangle,
  LuAlignCenter,
  LuAlignCenterHorizontal,
  LuAlignCenterVertical,
  LuAlignEndHorizontal,
  LuAlignEndVertical,
  LuAlignHorizontalDistributeCenter,
  LuAlignHorizontalDistributeEnd,
  LuAlignHorizontalDistributeStart,
  LuAlignHorizontalJustifyCenter,
  LuAlignHorizontalJustifyEnd,
  LuAlignHorizontalJustifyStart,
  LuAlignHorizontalSpaceAround,
  LuAlignHorizontalSpaceBetween,
  LuAlignJustify,
  LuAlignLeft,
  LuAlignRight,
  LuAlignStartHorizontal,
  LuAlignStartVertical,
  LuAlignVerticalDistributeCenter,
  LuAlignVerticalDistributeEnd,
  LuAlignVerticalDistributeStart,
  LuAlignVerticalJustifyCenter,
  LuAlignVerticalJustifyEnd,
  LuAlignVerticalJustifyStart,
  LuAlignVerticalSpaceAround,
  LuAlignVerticalSpaceBetween,
  LuAmpersand,
  LuAmpersands,
  LuAnchor,
  LuAngry,
  LuAnnoyed,
  LuAntenna,
  LuAperture,
  LuAppWindow,
  LuApple,
  LuArchive,
  LuArchiveRestore,
  LuArchiveX,
  LuAreaChart,
  LuArmchair,
  LuArrowBigDown,
  LuArrowBigDownDash,
  LuArrowBigLeft,
  LuArrowBigLeftDash,
  LuArrowBigRight,
  LuArrowBigRightDash,
  LuArrowBigUp,
  LuArrowBigUpDash,
  LuArrowDown,
  LuArrowDown01,
  LuArrowDown10,
  LuArrowDownAZ,
  LuArrowDownCircle,
  LuArrowDownFromLine,
  LuArrowDownLeft,
  LuArrowDownLeftFromCircle,
  LuArrowDownLeftSquare,
  LuArrowDownNarrowWide,
  LuArrowDownRight,
  LuArrowDownRightFromCircle,
  LuArrowDownRightSquare,
  LuArrowDownSquare,
  LuArrowDownToDot,
  LuArrowDownToLine,
  LuArrowDownUp,
  LuArrowDownWideNarrow,
  LuArrowDownZA,
  LuArrowLeft,
  LuArrowLeftCircle,
  LuArrowLeftFromLine,
  LuArrowLeftRight,
  LuArrowLeftSquare,
  LuArrowLeftToLine,
  LuArrowRight,
  LuArrowRightCircle,
  LuArrowRightFromLine,
  LuArrowRightLeft,
  LuArrowRightSquare,
  LuArrowRightToLine,
  LuArrowUp,
  LuArrowUp01,
  LuArrowUp10,
  LuArrowUpAZ,
  LuArrowUpCircle,
  LuArrowUpDown,
  LuArrowUpFromDot,
  LuArrowUpFromLine,
  LuArrowUpLeft,
  LuArrowUpLeftFromCircle,
  LuArrowUpLeftSquare,
  LuArrowUpNarrowWide,
  LuArrowUpRight,
  LuArrowUpRightFromCircle,
  LuArrowUpRightSquare,
  LuArrowUpSquare,
  LuArrowUpToLine,
  LuArrowUpWideNarrow,
  LuArrowUpZA,
  LuArrowsUpFromLine,
  LuAsterisk,
  LuAtSign,
  LuAtom,
  LuAward,
  LuAxe,
  LuAxis3D,
  LuBaby,
  LuBackpack,
  LuBadge,
  LuBadgeAlert,
  LuBadgeCent,
  LuBadgeCheck,
  LuBadgeDollarSign,
  LuBadgeEuro,
  LuBadgeHelp,
  LuBadgeIndianRupee,
  LuBadgeInfo,
  LuBadgeJapaneseYen,
  LuBadgeMinus,
  LuBadgePercent,
  LuBadgePlus,
  LuBadgePoundSterling,
  LuBadgeRussianRuble,
  LuBadgeSwissFranc,
  LuBadgeX,
  LuBaggageClaim,
  LuBan,
  LuBanana,
  LuBanknote,
  LuBarChart,
  LuBarChart2,
  LuBarChart3,
  LuBarChart4,
  LuBarChartBig,
  LuBarChartHorizontal,
  LuBarChartHorizontalBig,
  LuBarcode,
  LuBaseline,
  LuBath,
  LuBattery,
  LuBatteryCharging,
  LuBatteryFull,
  LuBatteryLow,
  LuBatteryMedium,
  LuBatteryWarning,
  LuBeaker,
  LuBean,
  LuBeanOff,
  LuBed,
  LuBedDouble,
  LuBedSingle,
  LuBeef,
  LuBeer,
  LuBell,
  LuBellDot,
  LuBellMinus,
  LuBellOff,
  LuBellPlus,
  LuBellRing,
  LuBike,
  LuBinary,
  LuBiohazard,
  LuBird,
  LuBitcoin,
  LuBlinds,
  LuBlocks,
  LuBluetooth,
  LuBluetoothConnected,
  LuBluetoothOff,
  LuBluetoothSearching,
  LuBold,
  LuBomb,
  LuBone,
  LuBook,
  LuBookA,
  LuBookAudio,
  LuBookCheck,
  LuBookCopy,
  LuBookDashed,
  LuBookDown,
  LuBookHeadphones,
  LuBookHeart,
  LuBookImage,
  LuBookKey,
  LuBookLock,
  LuBookMarked,
  LuBookMinus,
  LuBookOpen,
  LuBookOpenCheck,
  LuBookOpenText,
  LuBookPlus,
  LuBookText,
  LuBookType,
  LuBookUp,
  LuBookUp2,
  LuBookUser,
  LuBookX,
  LuBookmark,
  LuBookmarkCheck,
  LuBookmarkMinus,
  LuBookmarkPlus,
  LuBookmarkX,
  LuBoomBox,
  LuBot,
  LuBox,
  LuBoxSelect,
  LuBoxes,
  LuBraces,
  LuBrackets,
  LuBrain,
  LuBrainCircuit,
  LuBrainCog,
  LuBriefcase,
  LuBringToFront,
  LuBrush,
  LuBug,
  LuBugOff,
  LuBugPlay,
  LuBuilding,
  LuBuilding2,
  LuBus,
  LuBusFront,
  LuCable,
  LuCableCar,
  LuCake,
  LuCakeSlice,
  LuCalculator,
  LuCalendar,
  LuCalendarCheck,
  LuCalendarCheck2,
  LuCalendarClock,
  LuCalendarDays,
  LuCalendarHeart,
  LuCalendarMinus,
  LuCalendarOff,
  LuCalendarPlus,
  LuCalendarRange,
  LuCalendarSearch,
  LuCalendarX,
  LuCalendarX2,
  LuCamera,
  LuCameraOff,
  LuCandlestickChart,
  LuCandy,
  LuCandyCane,
  LuCandyOff,
  LuCar,
  LuCarFront,
  LuCarTaxiFront,
  LuCaravan,
  LuCarrot,
  LuCaseLower,
  LuCaseSensitive,
  LuCaseUpper,
  LuCassetteTape,
  LuCast,
  LuCastle,
  LuCat,
  LuCheck,
  LuCheckCheck,
  LuCheckCircle,
  LuCheckCircle2,
  LuCheckSquare,
  LuChefHat,
  LuCherry,
  LuChevronDown,
  LuChevronDownCircle,
  LuChevronDownSquare,
  LuChevronFirst,
  LuChevronLast,
  LuChevronLeft,
  LuChevronLeftCircle,
  LuChevronLeftSquare,
  LuChevronRight,
  LuChevronRightCircle,
  LuChevronRightSquare,
  LuChevronUp,
  LuChevronUpCircle,
  LuChevronUpSquare,
  LuChevronsDown,
  LuChevronsDownUp,
  LuChevronsLeft,
  LuChevronsLeftRight,
  LuChevronsRight,
  LuChevronsRightLeft,
  LuChevronsUp,
  LuChevronsUpDown,
  LuChrome,
  LuChurch,
  LuCigarette,
  LuCigaretteOff,
  LuCircle,
  LuCircleDashed,
  LuCircleDollarSign,
  LuCircleDot,
  LuCircleDotDashed,
  LuCircleEllipsis,
  LuCircleEqual,
  LuCircleOff,
  LuCircleSlash,
  LuCircleSlash2,
  LuCircuitBoard,
  LuCitrus,
  LuClapperboard,
  LuClipboard,
  LuClipboardCheck,
  LuClipboardCopy,
  LuClipboardEdit,
  LuClipboardList,
  LuClipboardPaste,
  LuClipboardSignature,
  LuClipboardType,
  LuClipboardX,
  LuClock,
  LuClock1,
  LuClock10,
  LuClock11,
  LuClock12,
  LuClock2,
  LuClock3,
  LuClock4,
  LuClock5,
  LuClock6,
  LuClock7,
  LuClock8,
  LuClock9,
  LuCloud,
  LuCloudCog,
  LuCloudDrizzle,
  LuCloudFog,
  LuCloudHail,
  LuCloudLightning,
  LuCloudMoon,
  LuCloudMoonRain,
  LuCloudOff,
  LuCloudRain,
  LuCloudRainWind,
  LuCloudSnow,
  LuCloudSun,
  LuCloudSunRain,
  LuCloudy,
  LuClover,
  LuClub,
  LuCode,
  LuCode2,
  LuCodepen,
  LuCodesandbox,
  LuCoffee,
  LuCog,
  LuCoins,
  LuColumns,
  LuCombine,
  LuCommand,
  LuCompass,
  LuComponent,
  LuComputer,
  LuConciergeBell,
  LuCone,
  LuConstruction,
  LuContact,
  LuContact2,
  LuContainer,
  LuContrast,
  LuCookie,
  LuCopy,
  LuCopyCheck,
  LuCopyMinus,
  LuCopyPlus,
  LuCopySlash,
  LuCopyX,
  LuCopyleft,
  LuCopyright,
  LuCornerDownLeft,
  LuCornerDownRight,
  LuCornerLeftDown,
  LuCornerLeftUp,
  LuCornerRightDown,
  LuCornerRightUp,
  LuCornerUpLeft,
  LuCornerUpRight,
  LuCpu,
  LuCreativeCommons,
  LuCreditCard,
  LuCroissant,
  LuCrop,
  LuCross,
  LuCrosshair,
  LuCrown,
  LuCuboid,
  LuCupSoda,
  LuCurrency,
  LuCylinder,
  LuDatabase,
  LuDatabaseBackup,
  LuDatabaseZap,
  LuDelete,
  LuDessert,
  LuDiameter,
  LuDiamond,
  LuDice1,
  LuDice2,
  LuDice3,
  LuDice4,
  LuDice5,
  LuDice6,
  LuDices,
  LuDiff,
  LuDisc,
  LuDisc2,
  LuDisc3,
  LuDivide,
  LuDivideCircle,
  LuDivideSquare,
  LuDna,
  LuDnaOff,
  LuDog,
  LuDollarSign,
  LuDonut,
  LuDoorClosed,
  LuDoorOpen,
  LuDot,
  LuDownload,
  LuDownloadCloud,
  LuDraftingCompass,
  LuDrama,
  LuDribbble,
  LuDroplet,
  LuDroplets,
  LuDrumstick,
  LuDumbbell,
  LuEar,
  LuEarOff,
  LuEgg,
  LuEggFried,
  LuEggOff,
  LuEqual,
  LuEqualNot,
  LuEraser,
  LuEuro,
  LuExpand,
  LuExternalLink,
  LuEye,
  LuEyeOff,
  LuFacebook,
  LuFactory,
  LuFan,
  LuFastForward,
  LuFeather,
  LuFerrisWheel,
  LuFigma,
  LuFile,
  LuFileArchive,
  LuFileAudio,
  LuFileAudio2,
  LuFileAxis3D,
  LuFileBadge,
  LuFileBadge2,
  LuFileBarChart,
  LuFileBarChart2,
  LuFileBox,
  LuFileCheck,
  LuFileCheck2,
  LuFileClock,
  LuFileCode,
  LuFileCode2,
  LuFileCog,
  LuFileDiff,
  LuFileDigit,
  LuFileDown,
  LuFileEdit,
  LuFileHeart,
  LuFileImage,
  LuFileInput,
  LuFileJson,
  LuFileJson2,
  LuFileKey,
  LuFileKey2,
  LuFileLineChart,
  LuFileLock,
  LuFileLock2,
  LuFileMinus,
  LuFileMinus2,
  LuFileOutput,
  LuFilePieChart,
  LuFilePlus,
  LuFilePlus2,
  LuFileQuestion,
  LuFileScan,
  LuFileSearch,
  LuFileSearch2,
  LuFileSignature,
  LuFileSpreadsheet,
  LuFileStack,
  LuFileSymlink,
  LuFileTerminal,
  LuFileText,
  LuFileType,
  LuFileType2,
  LuFileUp,
  LuFileVideo,
  LuFileVideo2,
  LuFileVolume,
  LuFileVolume2,
  LuFileWarning,
  LuFileX,
  LuFileX2,
  LuFiles,
  LuFilm,
  LuFilter,
  LuFilterX,
  LuFingerprint,
  LuFish,
  LuFishOff,
  LuFishSymbol,
  LuFlag,
  LuFlagOff,
  LuFlagTriangleLeft,
  LuFlagTriangleRight,
  LuFlame,
  LuFlameKindling,
  LuFlashlight,
  LuFlashlightOff,
  LuFlaskConical,
  LuFlaskConicalOff,
  LuFlaskRound,
  LuFlipHorizontal,
  LuFlipHorizontal2,
  LuFlipVertical,
  LuFlipVertical2,
  LuFlower,
  LuFlower2,
  LuFocus,
  LuFoldHorizontal,
  LuFoldVertical,
  LuFolder,
  LuFolderArchive,
  LuFolderCheck,
  LuFolderClock,
  LuFolderClosed,
  LuFolderCog,
  LuFolderDot,
  LuFolderDown,
  LuFolderEdit,
  LuFolderGit,
  LuFolderGit2,
  LuFolderHeart,
  LuFolderInput,
  LuFolderKanban,
  LuFolderKey,
  LuFolderLock,
  LuFolderMinus,
  LuFolderOpen,
  LuFolderOpenDot,
  LuFolderOutput,
  LuFolderPlus,
  LuFolderRoot,
  LuFolderSearch,
  LuFolderSearch2,
  LuFolderSymlink,
  LuFolderSync,
  LuFolderTree,
  LuFolderUp,
  LuFolderX,
  LuFolders,
  LuFootprints,
  LuForklift,
  LuFormInput,
  LuForward,
  LuFrame,
  LuFramer,
  LuFrown,
  LuFuel,
  LuFullscreen,
  LuFunctionSquare,
  LuGalleryHorizontal,
  LuGalleryHorizontalEnd,
  LuGalleryThumbnails,
  LuGalleryVertical,
  LuGalleryVerticalEnd,
  LuGamepad,
  LuGamepad2,
  LuGanttChart,
  LuGanttChartSquare,
  LuGauge,
  LuGaugeCircle,
  LuGavel,
  LuGem,
  LuGhost,
  LuGift,
  LuGitBranch,
  LuGitBranchPlus,
  LuGitCommit,
  LuGitCompare,
  LuGitFork,
  LuGitMerge,
  LuGitPullRequest,
  LuGitPullRequestClosed,
  LuGitPullRequestDraft,
  LuGithub,
  LuGitlab,
  LuGlassWater,
  LuGlasses,
  LuGlobe,
  LuGlobe2,
  LuGoal,
  LuGrab,
  LuGraduationCap,
  LuGrape,
  LuGrid2X2,
  LuGrid3X3,
  LuGrip,
  LuGripHorizontal,
  LuGripVertical,
  LuGroup,
  LuHammer,
  LuHand,
  LuHandMetal,
  LuHardDrive,
  LuHardDriveDownload,
  LuHardDriveUpload,
  LuHardHat,
  LuHash,
  LuHaze,
  LuHdmiPort,
  LuHeading,
  LuHeading1,
  LuHeading2,
  LuHeading3,
  LuHeading4,
  LuHeading5,
  LuHeading6,
  LuHeadphones,
  LuHeart,
  LuHeartCrack,
  LuHeartHandshake,
  LuHeartOff,
  LuHeartPulse,
  LuHelpCircle,
  LuHelpingHand,
  LuHexagon,
  LuHighlighter,
  LuHistory,
  LuHome,
  LuHop,
  LuHopOff,
  LuHotel,
  LuHourglass,
  LuIceCream,
  LuIceCream2,
  LuImage,
  LuImageDown,
  LuImageMinus,
  LuImageOff,
  LuImagePlus,
  LuImport,
  LuInbox,
  LuIndent,
  LuIndianRupee,
  LuInfinity,
  LuInfo,
  LuInstagram,
  LuItalic,
  LuIterationCcw,
  LuIterationCw,
  LuJapaneseYen,
  LuJoystick,
  LuKanban,
  LuKanbanSquare,
  LuKanbanSquareDashed,
  LuKey,
  LuKeyRound,
  LuKeySquare,
  LuKeyboard,
  LuLamp,
  LuLampCeiling,
  LuLampDesk,
  LuLampFloor,
  LuLampWallDown,
  LuLampWallUp,
  LuLandPlot,
  LuLandmark,
  LuLanguages,
  LuLaptop,
  LuLaptop2,
  LuLasso,
  LuLassoSelect,
  LuLaugh,
  LuLayers,
  LuLayers2,
  LuLayers3,
  LuLayout,
  LuLayoutDashboard,
  LuLayoutGrid,
  LuLayoutList,
  LuLayoutPanelLeft,
  LuLayoutPanelTop,
  LuLayoutTemplate,
  LuLeaf,
  LuLeafyGreen,
  LuLibrary,
  LuLibraryBig,
  LuLibrarySquare,
  LuLifeBuoy,
  LuLigature,
  LuLightbulb,
  LuLightbulbOff,
  LuLineChart,
  LuLink,
  LuLink2,
  LuLink2Off,
  LuLinkedin,
  LuList,
  LuListChecks,
  LuListEnd,
  LuListFilter,
  LuListMinus,
  LuListMusic,
  LuListOrdered,
  LuListPlus,
  LuListRestart,
  LuListStart,
  LuListTodo,
  LuListTree,
  LuListVideo,
  LuListX,
  LuLoader,
  LuLoader2,
  LuLocate,
  LuLocateFixed,
  LuLocateOff,
  LuLock,
  LuLockKeyhole,
  LuLogIn,
  LuLogOut,
  LuLollipop,
  LuLuggage,
  LuMSquare,
  LuMagnet,
  LuMail,
  LuMailCheck,
  LuMailMinus,
  LuMailOpen,
  LuMailPlus,
  LuMailQuestion,
  LuMailSearch,
  LuMailWarning,
  LuMailX,
  LuMailbox,
  LuMails,
  LuMap,
  LuMapPin,
  LuMapPinOff,
  LuMapPinned,
  LuMartini,
  LuMaximize,
  LuMaximize2,
  LuMedal,
  LuMegaphone,
  LuMegaphoneOff,
  LuMeh,
  LuMemoryStick,
  LuMenu,
  LuMenuSquare,
  LuMerge,
  LuMessageCircle,
  LuMessageSquare,
  LuMessageSquareDashed,
  LuMessageSquarePlus,
  LuMessagesSquare,
  LuMic,
  LuMic2,
  LuMicOff,
  LuMicroscope,
  LuMicrowave,
  LuMilestone,
  LuMilk,
  LuMilkOff,
  LuMinimize,
  LuMinimize2,
  LuMinus,
  LuMinusCircle,
  LuMinusSquare,
  LuMonitor,
  LuMonitorCheck,
  LuMonitorDot,
  LuMonitorDown,
  LuMonitorOff,
  LuMonitorPause,
  LuMonitorPlay,
  LuMonitorSmartphone,
  LuMonitorSpeaker,
  LuMonitorStop,
  LuMonitorUp,
  LuMonitorX,
  LuMoon,
  LuMoonStar,
  LuMoreHorizontal,
  LuMoreVertical,
  LuMountain,
  LuMountainSnow,
  LuMouse,
  LuMousePointer,
  LuMousePointer2,
  LuMousePointerClick,
  LuMousePointerSquare,
  LuMousePointerSquareDashed,
  LuMove,
  LuMove3D,
  LuMoveDiagonal,
  LuMoveDiagonal2,
  LuMoveDown,
  LuMoveDownLeft,
  LuMoveDownRight,
  LuMoveHorizontal,
  LuMoveLeft,
  LuMoveRight,
  LuMoveUp,
  LuMoveUpLeft,
  LuMoveUpRight,
  LuMoveVertical,
  LuMusic,
  LuMusic2,
  LuMusic3,
  LuMusic4,
  LuNavigation,
  LuNavigation2,
  LuNavigation2Off,
  LuNavigationOff,
  LuNetwork,
  LuNewspaper,
  LuNfc,
  LuNut,
  LuNutOff,
  LuOctagon,
  LuOption,
  LuOrbit,
  LuOutdent,
  LuPackage,
  LuPackage2,
  LuPackageCheck,
  LuPackageMinus,
  LuPackageOpen,
  LuPackagePlus,
  LuPackageSearch,
  LuPackageX,
  LuPaintBucket,
  LuPaintbrush,
  LuPaintbrush2,
  LuPalette,
  LuPalmtree,
  LuPanelBottom,
  LuPanelBottomClose,
  LuPanelBottomInactive,
  LuPanelBottomOpen,
  LuPanelLeft,
  LuPanelLeftClose,
  LuPanelLeftInactive,
  LuPanelLeftOpen,
  LuPanelRight,
  LuPanelRightClose,
  LuPanelRightInactive,
  LuPanelRightOpen,
  LuPanelTop,
  LuPanelTopClose,
  LuPanelTopInactive,
  LuPanelTopOpen,
  LuPaperclip,
  LuParentheses,
  LuParkingCircle,
  LuParkingCircleOff,
  LuParkingMeter,
  LuParkingSquare,
  LuParkingSquareOff,
  LuPartyPopper,
  LuPause,
  LuPauseCircle,
  LuPauseOctagon,
  LuPawPrint,
  LuPcCase,
  LuPen,
  LuPenLine,
  LuPenSquare,
  LuPenTool,
  LuPencil,
  LuPencilLine,
  LuPencilRuler,
  LuPentagon,
  LuPercent,
  LuPercentCircle,
  LuPercentDiamond,
  LuPercentSquare,
  LuPersonStanding,
  LuPhone,
  LuPhoneCall,
  LuPhoneForwarded,
  LuPhoneIncoming,
  LuPhoneMissed,
  LuPhoneOff,
  LuPhoneOutgoing,
  LuPi,
  LuPiSquare,
  LuPictureInPicture,
  LuPictureInPicture2,
  LuPieChart,
  LuPiggyBank,
  LuPilcrow,
  LuPilcrowSquare,
  LuPill,
  LuPin,
  LuPinOff,
  LuPipette,
  LuPizza,
  LuPlane,
  LuPlaneLanding,
  LuPlaneTakeoff,
  LuPlay,
  LuPlayCircle,
  LuPlaySquare,
  LuPlug,
  LuPlug2,
  LuPlugZap,
  LuPlugZap2,
  LuPlus,
  LuPlusCircle,
  LuPlusSquare,
  LuPocket,
  LuPocketKnife,
  LuPodcast,
  LuPointer,
  LuPopcorn,
  LuPopsicle,
  LuPoundSterling,
  LuPower,
  LuPowerOff,
  LuPresentation,
  LuPrinter,
  LuProjector,
  LuPuzzle,
  LuPyramid,
  LuQrCode,
  LuQuote,
  LuRabbit,
  LuRadar,
  LuRadiation,
  LuRadio,
  LuRadioReceiver,
  LuRadioTower,
  LuRadius,
  LuRailSymbol,
  LuRainbow,
  LuRat,
  LuRatio,
  LuReceipt,
  LuRectangleHorizontal,
  LuRectangleVertical,
  LuRecycle,
  LuRedo,
  LuRedo2,
  LuRedoDot,
  LuRefreshCcw,
  LuRefreshCcwDot,
  LuRefreshCw,
  LuRefreshCwOff,
  LuRefrigerator,
  LuRegex,
  LuRemoveFormatting,
  LuRepeat,
  LuRepeat1,
  LuRepeat2,
  LuReplace,
  LuReplaceAll,
  LuReply,
  LuReplyAll,
  LuRewind,
  LuRocket,
  LuRockingChair,
  LuRollerCoaster,
  LuRotate3D,
  LuRotateCcw,
  LuRotateCw,
  LuRoute,
  LuRouteOff,
  LuRouter,
  LuRows,
  LuRss,
  LuRuler,
  LuRussianRuble,
  LuSailboat,
  LuSalad,
  LuSandwich,
  LuSatellite,
  LuSatelliteDish,
  LuSave,
  LuSaveAll,
  LuScale,
  LuScale3D,
  LuScaling,
  LuScan,
  LuScanBarcode,
  LuScanEye,
  LuScanFace,
  LuScanLine,
  LuScanSearch,
  LuScanText,
  LuScatterChart,
  LuSchool,
  LuSchool2,
  LuScissors,
  LuScissorsLineDashed,
  LuScissorsSquare,
  LuScissorsSquareDashedBottom,
  LuScreenShare,
  LuScreenShareOff,
  LuScroll,
  LuScrollText,
  LuSearch,
  LuSearchCheck,
  LuSearchCode,
  LuSearchSlash,
  LuSearchX,
  LuSend,
  LuSendHorizontal,
  LuSendToBack,
  LuSeparatorHorizontal,
  LuSeparatorVertical,
  LuServer,
  LuServerCog,
  LuServerCrash,
  LuServerOff,
  LuSettings,
  LuSettings2,
  LuShapes,
  LuShare,
  LuShare2,
  LuSheet,
  LuShell,
  LuShield,
  LuShieldAlert,
  LuShieldBan,
  LuShieldCheck,
  LuShieldEllipsis,
  LuShieldHalf,
  LuShieldMinus,
  LuShieldOff,
  LuShieldPlus,
  LuShieldQuestion,
  LuShieldX,
  LuShip,
  LuShipWheel,
  LuShirt,
  LuShoppingBag,
  LuShoppingBasket,
  LuShoppingCart,
  LuShovel,
  LuShowerHead,
  LuShrink,
  LuShrub,
  LuShuffle,
  LuSigma,
  LuSigmaSquare,
  LuSignal,
  LuSignalHigh,
  LuSignalLow,
  LuSignalMedium,
  LuSignalZero,
  LuSignpost,
  LuSignpostBig,
  LuSiren,
  LuSkipBack,
  LuSkipForward,
  LuSkull,
  LuSlack,
  LuSlash,
  LuSlice,
  LuSliders,
  LuSlidersHorizontal,
  LuSmartphone,
  LuSmartphoneCharging,
  LuSmartphoneNfc,
  LuSmile,
  LuSmilePlus,
  LuSnail,
  LuSnowflake,
  LuSofa,
  LuSoup,
  LuSpace,
  LuSpade,
  LuSparkle,
  LuSparkles,
  LuSpeaker,
  LuSpeech,
  LuSpellCheck,
  LuSpellCheck2,
  LuSpline,
  LuSplit,
  LuSplitSquareHorizontal,
  LuSplitSquareVertical,
  LuSprayCan,
  LuSprout,
  LuSquare,
  LuSquareAsterisk,
  LuSquareCode,
  LuSquareDashedBottom,
  LuSquareDashedBottomCode,
  LuSquareDot,
  LuSquareEqual,
  LuSquareSlash,
  LuSquareStack,
  LuSquirrel,
  LuStamp,
  LuStar,
  LuStarHalf,
  LuStarOff,
  LuStepBack,
  LuStepForward,
  LuStethoscope,
  LuSticker,
  LuStickyNote,
  LuStopCircle,
  LuStore,
  LuStretchHorizontal,
  LuStretchVertical,
  LuStrikethrough,
  LuSubscript,
  LuSubtitles,
  LuSun,
  LuSunDim,
  LuSunMedium,
  LuSunMoon,
  LuSunSnow,
  LuSunrise,
  LuSunset,
  LuSuperscript,
  LuSwissFranc,
  LuSwitchCamera,
  LuSword,
  LuSwords,
  LuSyringe,
  LuTable,
  LuTable2,
  LuTableProperties,
  LuTablet,
  LuTabletSmartphone,
  LuTablets,
  LuTag,
  LuTags,
  LuTally1,
  LuTally2,
  LuTally3,
  LuTally4,
  LuTally5,
  LuTangent,
  LuTarget,
  LuTent,
  LuTentTree,
  LuTerminal,
  LuTerminalSquare,
  LuTestTube,
  LuTestTube2,
  LuTestTubes,
  LuText,
  LuTextCursor,
  LuTextCursorInput,
  LuTextQuote,
  LuTextSelect,
  LuTheater,
  LuThermometer,
  LuThermometerSnowflake,
  LuThermometerSun,
  LuThumbsDown,
  LuThumbsUp,
  LuTicket,
  LuTimer,
  LuTimerOff,
  LuTimerReset,
  LuToggleLeft,
  LuToggleRight,
  LuTornado,
  LuTorus,
  LuTouchpad,
  LuTouchpadOff,
  LuTowerControl,
  LuToyBrick,
  LuTractor,
  LuTrafficCone,
  LuTrainFront,
  LuTrainFrontTunnel,
  LuTrainTrack,
  LuTramFront,
  LuTrash,
  LuTrash2,
  LuTreeDeciduous,
  LuTreePine,
  LuTrees,
  LuTrello,
  LuTrendingDown,
  LuTrendingUp,
  LuTriangle,
  LuTriangleRight,
  LuTrophy,
  LuTruck,
  LuTurtle,
  LuTv,
  LuTv2,
  LuTwitch,
  LuTwitter,
  LuType,
  LuUmbrella,
  LuUmbrellaOff,
  LuUnderline,
  LuUndo,
  LuUndo2,
  LuUndoDot,
  LuUnfoldHorizontal,
  LuUnfoldVertical,
  LuUngroup,
  LuUnlink,
  LuUnlink2,
  LuUnlock,
  LuUnlockKeyhole,
  LuUnplug,
  LuUpload,
  LuUploadCloud,
  LuUsb,
  LuUser,
  LuUser2,
  LuUserCheck,
  LuUserCheck2,
  LuUserCircle,
  LuUserCircle2,
  LuUserCog,
  LuUserCog2,
  LuUserMinus,
  LuUserMinus2,
  LuUserPlus,
  LuUserPlus2,
  LuUserSquare,
  LuUserSquare2,
  LuUserX,
  LuUserX2,
  LuUsers,
  LuUsers2,
  LuUtensils,
  LuUtensilsCrossed,
  LuUtilityPole,
  LuVariable,
  LuVegan,
  LuVenetianMask,
  LuVibrate,
  LuVibrateOff,
  LuVideo,
  LuVideoOff,
  LuVideotape,
  LuView,
  LuVoicemail,
  LuVolume,
  LuVolume1,
  LuVolume2,
  LuVolumeX,
  LuVote,
  LuWallet,
  LuWallet2,
  LuWalletCards,
  LuWallpaper,
  LuWand,
  LuWand2,
  LuWarehouse,
  LuWatch,
  LuWaves,
  LuWaypoints,
  LuWebcam,
  LuWebhook,
  LuWeight,
  LuWheat,
  LuWheatOff,
  LuWholeWord,
  LuWifi,
  LuWifiOff,
  LuWind,
  LuWine,
  LuWineOff,
  LuWorkflow,
  LuWrapText,
  LuWrench,
  LuX,
  LuXCircle,
  LuXOctagon,
  LuXSquare,
  LuYoutube,
  LuZap,
  LuZapOff,
  LuZoomIn,
  LuZoomOut
};
